/**
 * СЛОВАРИ ПЕРЕВОДОВ — СГЕНЕРИРОВАНО, РУКАМИ НЕ ПРАВИТЬ.
 *
 * Источник: i18n-source/merged_594.json (русский оригинал + en/es/pt).
 * Пересобрать: scripts/build_messages.py
 */

export const ru = {
  "app.corporateLogin": "Вход через корпоративный аккаунт ALG.",
  "app.errorLogin": "Не удалось войти: {error}",
  "app.hideActionError": "Скрыть",
  "app.incomingCall": "Входящий звонок · {room}",
  "app.inviteNotice": "Вас добавили в «{room}»",
  "app.inviteNoticeMore": "и ещё {count}",
  "app.login": "Войти",
  "app.logout": "Выйти",
  "app.profile": "Личный кабинет",
  "app.settings": "Настройки",
  "app.resetAndRestart": "Сбросить и начать заново",
  "app.selectRoom": "Выберите комнату слева.",
  "app.serverChoose": "Выберите сервер",
  "app.serverConnect": "Подключаюсь к серверу…",
  "app.serverConnectButton": "Подключиться",
  "app.serverConnectDescription": "Приложение подключится к выбранному серверу. Сессия и устройства хранятся отдельно для каждого — переключение не выкинет вас из другого.",
  "app.serverCurrent": "сейчас",
  "app.serverCustom": "Другой адрес",
  "app.serverLabel": "Сервер: {server}",
  "app.serverProduction": "рабочий сервер ALG",
  "app.serverStaging": "тестовый, данные можно ломать",
  "app.serverSwitch": "сменить",
  "app.serverUrlPlaceholder": "matrix.example.com",
  "app.sessionCheck": "Проверяю сессию…",
  "app.unavailableRoom": "Комната недоступна или вы больше не состоите в ней.",
  "call.accept": "Принять звонок",
  "call.callInProgress": "идёт звонок",
  "call.captionRepliesEmpty": "Ответов пока нет.",
  "call.decline": "Отклонить звонок",
  "call.deviceCamera": "Камера",
  "call.deviceDefault": "По умолчанию",
  "call.deviceFallback": "Устройство {count}",
  "call.deviceMicrophone": "Микрофон",
  "call.deviceSpeaker": "Динамик",
  "call.copyDiagnostics": "Скопировать диагностику звонка",
  "call.diagnosticsCopied": "Диагностика скопирована",
  "call.diagnosticsCopyFailed": "Не удалось скопировать",
  "call.goToRoom": "Перейти",
  "call.goToRoomHint": "Перейти в комнату, не отвечая на звонок",
  "call.videoCallInProgress": "идёт видеозвонок",
  "common.accept": "Принять",
  "common.cancel": "Отмена",
  "common.close": "Закрыть",
  "common.create": "Создать",
  "common.decline": "Отклонить",
  "common.done": "Готово",
  "common.hide": "Скрыть",
  "common.invite": "Пригласить",
  "common.inviteShort": "+ Пригласить",
  "common.leave": "Выйти из комнаты",
  "common.messageEdited": " (изменено)",
  "common.messageNotSent": " · не отправлено",
  "common.messageSending": " · отправляю…",
  "common.noMessages": "Сообщений пока нет.",
  "common.remove": "Удалить",
  "common.roomStart": "начало комнаты",
  "common.save": "Сохранить",
  "common.search": "Поиск",
  "common.yesDelete": "Да, удалить",
  "composer.attachFile": "Прикрепить файл",
  "composer.attachImage": "Прикрепить изображение",
  "composer.attachMenu": "Вложения",
  "composer.attachTitle": "Прикрепить файл",
  "composer.cancelEdit": "Отменить редактирование",
  "composer.cancelReply": "Отменить ответ",
  "composer.disabledPlaceholder": "В эту комнату писать нельзя",
  "composer.dropFiles": "Перетащите файлы сюда",
  "composer.editing": "Редактирование сообщения",
  "composer.emoji": "Эмодзи",
  "composer.fileUploadProgress": "Загружаю файл… {percent}%",
  "composer.mentionAll": "Вся комната",
  "composer.mentionInvited": "приглашён",
  "composer.reply": "Ответ {user}",
  "composer.sendButton": "Отправить",
  "composer.sendError": "Не отправилось: {error}",
  "composer.textPlaceholder": "Сообщение… (Enter — отправить, Shift+Enter — перенос)",
  "dialog.avatarOfRoom": "Аватар комнаты",
  "dialog.avatarOfSpace": "Аватар пространства",
  "dialog.createProgress": "Создаю…",
  "dialog.declineDescription": "Приглашение в «{room}» будет отклонено. Если вас пригласят ещё раз, комната появится снова.",
  "dialog.declineProgress": "Отклоняю…",
  "dialog.declineTitle": "Отклонить приглашение?",
  "dialog.dmAllSpacesHint": "Показаны участники всех ваших пространств. Личный чат возможен только с теми, с кем есть общее пространство.",
  "dialog.dmDescription": "Поиск по имени пока не реализован: нужен полный идентификатор вида @логин:algsuccess.com. Собеседник получит приглашение.",
  "dialog.dmIdLabel": "Matrix ID собеседника",
  "dialog.dmSpaceHint": "Показаны участники выбранного пространства. Чтобы видеть всех, переключитесь на «Главная» в рельсе слева.",
  "dialog.dmTitle": "Новый личный чат",
  "dialog.historyHint": "«С момента входа» — новый участник видит историю с момента своего входа. «Только с момента входа» — не видит ничего до своего входа. Изменение не применяется ретроактивно к уже вошедшим.",
  "dialog.historyJoined": "Только с момента входа (новые участники не видят прошлое)",
  "dialog.historyShared": "С момента входа (новые участники видят историю с их входа)",
  "dialog.historyVisibility": "Видимость истории",
  "dialog.historyWho": "Кто видит историю",
  "dialog.inviteDone": "Приглашение отправлено: {user}",
  "dialog.inviteIdLabel": "Matrix ID",
  "dialog.inviteProgress": "Приглашаю…",
  "dialog.inviteSent": "Приглашение отправлено: {user}",
  "dialog.inviteSpaceDescription": "Приглашённый увидит открытые комнаты пространства и всех его участников. Комнаты «только по приглашению» останутся для него невидимыми до отдельного приглашения в каждую.",
  "dialog.inviteSpaceTitle": "Пригласить в пространство «{space}»",
  "dialog.inviteOutsideSpaceWarning": "{user} не состоит в пространстве этой комнаты. Приглашение всё равно можно отправить, но человек останется вне пространства — администратору стоит добавить его туда отдельно.",
  "dialog.inviteSuggestEmpty": "Совпадений нет — проверьте написание или введите полный идентификатор.",
  "dialog.inviteSuggestNone": "Подсказывать некого: все, кого можно пригласить, уже в комнате. Введите полный идентификатор вида @логин:algsuccess.com.",
  "dialog.inviteTitle": "Пригласить в «{room}»",
  "dialog.joinByInvite": "По приглашению",
  "dialog.joinMode": "Режим входа",
  "dialog.joinRoom": "Вход в комнату",
  "dialog.joinSpace": "Вход в пространство",
  "dialog.leaveDescription": "Вы выйдете из комнаты «{room}». История останется на сервере, но вам она будет недоступна. Вернуться в приватную комнату можно только по новому приглашению.",
  "dialog.leaveProgress": "Выхожу…",
  "dialog.leaveTitle": "Выйти из комнаты?",
  "dialog.matrixIdBadDomain": "Недопустимые символы в адресе сервера",
  "dialog.matrixIdCyrillic": "Похоже на русскую раскладку — переключите на английскую",
  "dialog.matrixIdInvalidLocalpart": "В имени пользователя допустимы только латиница, цифры и . _ - = + /",
  "dialog.matrixIdInvalidPrefix": "Matrix ID начинается с @",
  "dialog.matrixIdInvalidSpaces": "В Matrix ID не бывает пробелов",
  "dialog.matrixIdMissingServer": "Не хватает сервера после двоеточия, например @ivanov:algsuccess.com",
  "dialog.matrixIdMissingServerAddress": "Пустой адрес сервера после двоеточия",
  "dialog.matrixIdNoDomain": "Адрес сервера без домена, например algsuccess.com",
  "dialog.moveRoomCurrentHome": "Сейчас комната вне пространств («Главная»).",
  "dialog.moveRoomCurrentSpace": "Сейчас комната в пространстве «{space}».",
  "dialog.moveRoomEmpty": "Некуда переносить: нет пространств, где у вас есть права на управление составом. Попросите администратора пространства выполнить перенос или повысить ваш уровень прав.",
  "dialog.moveRoomLabel": "Куда перенести",
  "dialog.moveRoomProgress": "Переношу…",
  "dialog.moveRoomTitle": "Перенести «{room}»",
  "dialog.newName": "Новое название",
  "dialog.newRoomDescription": "Виден в каталоге сервера, войти может любой сотрудник. Без галочки — только по приглашению.",
  "dialog.newRoomNameLabel": "Название",
  "dialog.newRoomNamePlaceholder": "Например: Релиз 2.4",
  "dialog.newRoomTitle": "Новая комната",
  "dialog.newSpaceTitle": "Новое пространство",
  "dialog.newTopic": "Новая тема",
  "dialog.noSettingsPermission": "У вас нет прав на изменение настроек {kind}.",
  "dialog.publicJoin": "Публичная (любой может войти)",
  "dialog.publicRoomDescription": "Виден в каталоге сервера, войти может любой сотрудник. Без галочки — только по приглашению.",
  "dialog.publicRoomHint": "Публичная комната видна в каталоге сервера и войти может любой сотрудник. По приглашению — только по приглашению от участника.",
  "dialog.publicRoomLabel": "Публичная комната",
  "dialog.publicSpaceHint": "Публичное пространство видно в каталоге сервера и войти может любой сотрудник. По приглашению — только по приглашению от участника.",
  "dialog.roomCreatedInHome": "Комната будет создана вне пространств («Главная»). Приглашать в неё можно любого пользователя.",
  "dialog.roomCreatedInSpace": "Комната будет создана в пространстве «{space}».",
  "dialog.roomLeaveBlocked": "Нельзя выйти из пространства «{room}». {reason}",
  "dialog.roomLeaveSpaceDescription": "Вы выйдете из пространства «{room}». Его комнаты исчезнут из вашего списка, а вернуться можно будет только по новому приглашению.",
  "dialog.roomLeaveSpaceTitle": "Выйти из пространства?",
  "dialog.roomSettings": "Настройки: {room}",
  "dialog.roomTargetHome": "Комната будет создана вне пространств («Главная»). Приглашать в неё можно любого пользователя.",
  "dialog.roomTargetSpace": "Комната будет создана в пространстве «{space}».",
  "dialog.selectedSpace": "выбранное пространство",
  "dialog.spaceCreatedInviteFailed": "Пространство создано, но не удалось пригласить: {users}",
  "dialog.spaceDescription": "Пространство объединяет комнаты и людей. Участник пространства видит открытые комнаты пространства и всех его участников; комнаты «только по приглашению» остаются невидимыми до отдельного приглашения.",
  "dialog.spaceInviteAction": "Пригласить в пространство…",
  "dialog.spaceLeaveAction": "Выйти из пространства…",
  "dialog.spaceMemberPlaceholder": "Имя или @user:algsuccess.com",
  "dialog.spaceMembersAction": "Участники пространства…",
  "dialog.spaceMembersLabel": "Участники (необязательно)",
  "dialog.spaceNameLabel": "Название",
  "dialog.spaceSettingsTitle": "Настройки пространства",
  "dialog.spaceTopicLabel": "Описание (необязательно)",
  "dialog.spaceTopicPlaceholder": "О чём это пространство",
  "dialog.topicUnset": "(не задана)",
  "dialog.understood": "Понятно",
  "dialog.untitled": "(без названия)",
  "emoji.loadFailed": "Не удалось загрузить список эмодзи.",
  "emoji.loading": "Загружаю эмодзи…",
  "emoji.recent": "Недавние",
  "emoji.search": "Поиск эмодзи",
  "error.backToChats": "К списку чатов",
  "error.renderStopped": "Приложение наткнулось на ошибку и остановило отрисовку этого экрана. Остальное работает — можно вернуться к списку чатов.",
  "error.somethingBroken": "Что-то сломалось",
  "matrix.authCallbackMissingFlow": "Got an OIDC callback but no flow context — start login again.",
  "matrix.authRefused": "MAS refused authorization: {error} — {description}",
  "matrix.authStateMismatch": "OIDC state mismatch — aborting login.",
  "matrix.errorAttachmentLink": "Не удалось открыть вложение: сервер не вернул ссылку.",
  "matrix.errorAttachmentServer": "сервер ответил {status}",
  "matrix.errorForbidden": "Недостаточно прав: {detail}",
  "matrix.errorNotFound": "Не найдено: {detail}",
  "matrix.errorRateLimit": "Сервер ограничивает частоту запросов. Попробуйте через минуту.",
  "matrix.profileMissingUserId": "Не найден идентификатор пользователя клиента",
  "matrix.sessionRejected": "Stored session rejected by the server: {error}",
  "media.download": "Скачать",
  "media.loading": "загружаю…",
  "media.next": "Следующее",
  "media.openInBrowser": "Открыть в браузере",
  "media.previous": "Предыдущее",
  "media.share": "Поделиться",
  "member.admin": "Администратор",
  "member.ban": "Заблокировать",
  "member.banAction": "Заблокировать",
  "member.banned": "Заблокированы · {count}",
  "member.bannedCount": "Забанены · {count}",
  "member.changeRole": "Изменить роль",
  "member.changeRoleAction": "Изменить роль",
  "member.close": "✕",
  "member.count": "Участники · {count}",
  "member.invite": "+ Пригласить",
  "member.invited": "Приглашены · {count}",
  "member.invitedCount": "Приглашены · {count}",
  "member.invitedUser": "приглашён · {user}",
  "member.justNow": "был(а) только что",
  "member.kick": "Исключить",
  "member.kickAction": "Исключить",
  "member.lastActive": "был(а) {count} мин назад",
  "member.lastActiveDays": "был(а) {count} дн назад",
  "member.lastActiveHours": "был(а) {count} ч назад",
  "member.leaveSelfWarning": "Нельзя выйти из пространства: вы последний администратор.",
  "member.mismatch": "Сервер сообщает {serverCount} вошедших, загружено {loaded}. Часть состояния комнаты ещё не подгружена.",
  "member.moderator": "модератор",
  "member.notLoaded": "Список участников не загружен.",
  "member.online": "в сети",
  "member.onlineStatus": "в сети",
  "member.participants": "Участники · {count}",
  "member.role": "Роль",
  "member.roleAdministrator": "Администратор",
  "member.roleModerator": "Модератор",
  "member.roleParticipant": "Участник",
  "member.unban": "Разбанить",
  "member.unbanAction": "Разблокировать",
  "member.you": "вы",
  "notification.allow": "Разрешить уведомления",
  "notification.apiMissing": "Notification API нет в этом браузере",
  "notification.browserRejected": "браузер отклонил показ",
  "notification.browserStatus": "Браузерные уведомления: {status}.",
  "notification.deniedHint": "Уведомления заблокированы самим браузером — из приложения снять запрет нельзя. В Safari это Настройки → Веб-сайты → Уведомления, в Chrome — Настройки → Конфиденциальность → Настройки сайтов → Уведомления.",
  "notification.mobileHint": "На iPhone/iPad уведомления доступны, только если сайт добавлен на домашний экран (Поделиться → «На экран Домой», iOS 16.4+). Звук звонка и баннер внутри приложения работают и без этого.",
  "notification.sent": "отправлено в браузер",
  "notification.settingsTitle": "Настройки уведомлений",
  "notification.statusDefault": "ещё не запрашивались",
  "notification.statusDenied": "заблокированы в браузере",
  "notification.statusGranted": "разрешены",
  "notification.statusUnsupported": "не поддерживаются этим браузером",
  "notification.test": "Показать пробное уведомление",
  "notification.testBody": "Пробное уведомление. Если ты это видишь — всё работает.",
  "profile.addDevice": "Добавить устройство",
  "profile.addDeviceCodeHint": "Введите этот код на новом устройстве:",
  "profile.allChats": "Все чаты",
  "profile.appearance": "Оформление",
  "profile.changePhoto": "Изменить фото",
  "profile.clickToRename": "Нажмите, чтобы изменить имя",
  "profile.close": "Закрыть",
  "profile.closeCabinet": "Закрыть личный кабинет",
  "profile.codeValid": "Код действителен: {time}",
  "profile.deleteCurrentDeviceQuestion": "Удалить это устройство — выйти из аккаунта. Приложение попросит войти заново. Продолжить?",
  "profile.deleteDeviceQuestion": "Удалить устройство «{device}»? Все входы с него завершатся.",
  "profile.deviceActive": "активно {date}",
  "profile.deviceCurrent": "это устройство",
  "profile.deviceNameLabel": "Имя устройства",
  "profile.deviceNamePlaceholder": "Например: MacBook, телефон",
  "profile.deviceSessions": "{count} сессии",
  "profile.devices": "Устройства",
  "profile.devicesUnknownActivity": "активность неизвестна",
  "profile.displayName": "Отображаемое имя",
  "profile.filesScopeHint": "Показаны файлы и медиа из уже загруженных переписок, и поиск работает по ним же. Полного серверного архива всех вложений у нас пока нет — это отдельная серверная задача.",
  "profile.filesSearchAria": "Поиск по файлам и медиа",
  "profile.filesSearchPlaceholder": "Поиск по имени файла или подписи",
  "profile.filesTab": "Файлы",
  "profile.finishLoginQuestion": "Завершить вход на «{device}»?",
  "profile.imageRequired": "Нужна картинка (PNG, JPEG и т. п.)",
  "profile.lightTheme": "Светлая",
  "profile.loadingDevices": "Загружаю устройства…",
  "profile.logout": "Выйти",
  "profile.logoutConfirm": "Да, выйти",
  "profile.logoutQuestion": "Выйти из аккаунта на этом устройстве?",
  "profile.mediaTab": "Медиа",
  "profile.multipleSessionsHint": "Несколько входов с одного устройства; если какой-то из них не ваш — завершите его.",
  "profile.myFiles": "Мои файлы и медиа",
  "profile.newCode": "Получить новый код",
  "profile.noMedia": "В загруженных переписках картинок и видео нет.",
  "profile.noOtherFiles": "В загруженных переписках файлов от других нет.",
  "profile.noOwnFiles": "В загруженных переписках ваших файлов нет.",
  "profile.noSearchResults": "По этому запросу ничего не найдено. Поиск работает по уже загруженным перепискам.",
  "profile.notifications": "Уведомления",
  "profile.notificationsEnabled": "Уведомления включены. Правила тишины (открытая комната не пищит) действуют автоматически.",
  "profile.notificationsUnsupported": "Этот браузер не поддерживает уведомления.",
  "profile.openOnNewDevice": "Откройте на новом устройстве:",
  "profile.openPhoto": "Открыть фото во весь экран",
  "profile.permissionDenied": "запрещены в браузере",
  "profile.permissionGranted": "включены",
  "profile.permissionNotAsked": "не запрошены",
  "profile.permissionUnsupported": "не поддерживаются",
  "profile.personalCabinet": "Личный кабинет",
  "profile.photo": "Фото профиля",
  "profile.photoNotSet": "Фото не установлено",
  "profile.renameDevice": "Переименовать это устройство",
  "profile.resetDeviceName": "Сбросить имя",
  "profile.saving": "Сохраняю…",
  "profile.searchResults": "найдено {count}",
  "profile.sharedFiles": "Файлы и медиа, которыми поделились",
  "profile.switchServer": "сменить",
  "profile.title": "Профиль",
  "profile.uploadPhoto": "Загружаю фото…",
  "room.acceptInviteMenu": "Принять приглашение",
  "room.add": "Добавить",
  "room.attachmentBroken": "📎 {name} {size} — не загрузилось: {error}",
  "room.attachmentLoading": "📎 {name} — загружаю…",
  "room.callAlreadyIn": "Вы уже в звонке",
  "room.callCamera": "Камера",
  "room.callConnecting": "Подключаемся…",
  "room.callDecline": "Отклонить звонок",
  "room.callIncoming": "Входящий звонок",
  "room.callLeave": "Завершить звонок",
  "room.callMuted": "Микрофон выключен",
  "room.callParticipants": "идёт звонок · {count} участников",
  "room.captionEnable": "Включить субтитры",
  "room.captions": "Субтитры",
  "room.collapseList": "Свернуть список чатов",
  "room.expandList": "Развернуть список чатов",
  "room.chatsCount": "Чатов: {visible} из {joined}",
  "room.declineInviteMenu": "Отклонить приглашение",
  "room.download": "Скачать",
  "room.emptyFavourites": "Избранных чатов нет. Нажмите на чат правой кнопкой мыши → «В избранное».",
  "room.emptyOutsideSpaces": "Здесь пока пусто",
  "room.emptyPeople": "Личных чатов нет",
  "room.emptySearch": "Ничего не найдено по запросу «{query}»",
  "room.emptySpace": "В этом пространстве нет чатов, в которые вы вошли",
  "room.emptyUnread": "Непрочитанных чатов нет",
  "room.encryptedBadge": "Сквозное шифрование включено",
  "room.encryptedNotice": "Сообщения в этой комнате зашифрованы (E2EE).\nЭтот клиент их намеренно не читает: шифрование в нём отключено. Отправка сюда тоже недоступна — незашифрованное сообщение в зашифрованной комнате другие клиенты отвергнут. Пользуйтесь для этой комнаты Element.",
  "room.encryptedPreview": "Зашифрованное сообщение",
  "room.encryptionPageDisabled": "Шифрование выключено: комната не зашифрована, а поддержка E2EE в этом клиенте отключена намеренно. Включить её здесь нельзя.",
  "room.encryptionPageEnabled": "Комната зашифрована (E2EE), но этот клиент шифрование не поддерживает — выключено. Читать такую комнату можно в Element. Включить шифрование здесь нельзя.",
  "room.favourite": "в избранном",
  "room.favouriteButton": "☆ В избранное",
  "room.favouriteMenu": "В избранное",
  "room.favouritedButton": "★ В избранном",
  "room.favouritesTab": "Избранное",
  "room.headerCallJoin": "Присоединиться к звонку",
  "room.headerCallLeave": "Выйти из звонка",
  "room.headerCallStart": "Начать звонок",
  "room.headerOpenPage": "Открыть страницу комнаты",
  "room.headerVideoJoin": "Присоединиться к звонку с видео",
  "room.headerVideoStart": "Начать видеозвонок",
  "room.historyError": "История не догрузилась: {error}",
  "room.historyLoading": "Загружаю историю…",
  "room.homeLabel": "Главная — чаты вне пространств",
  "room.homeTab": "Главная",
  "room.insufficientPermissions": "Недостаточно прав",
  "room.inviteMenu": "Пригласить участника…",
  "room.inviteNotice": "Это приглашение. Нажмите «Принять» в шапке, чтобы войти в комнату, или «Отклонить», чтобы убрать её из списка. Содержимое комнаты до входа не показывается.",
  "room.inviteNoticeMore": "и ещё {count}",
  "room.invitePreview": "Приглашение в комнату",
  "room.invitesCount": "Приглашения · {count}",
  "room.leaveMenu": "Выйти из комнаты…",
  "room.loadOlder": "↑ прокрутите вверх, чтобы загрузить историю",
  "room.loadingChats": "Загружаю чаты…",
  "room.loadingShort": "Загружаю…",
  "room.mediaFound": "найдено {count}",
  "room.memberCount": "{count} участников · {roomId}",
  "room.members": "Участники",
  "room.mentioned": "вас упомянули",
  "room.waitingChip": "Меня ждут",
  "room.emptyWaiting": "Никто не ждёт ответа",
  "room.waitingChipAria": "Меня ждут: {count}",
  "room.mentionsTab": "Упоминания",
  "room.messageLinkMiss": "Сообщение из ссылки старше загруженной истории. Прокрутите ленту вверх — оно появится при подгрузке.",
  "room.newDm": "+ Личный чат",
  "room.newRoom": "+ Комната",
  "room.noMessagesPreview": "Нет сообщений",
  "room.noResults": "По этому запросу ничего не найдено",
  "room.notificationSettings": "Уведомления",
  "room.notificationsCurrent": "Уведомления: {mode}",
  "room.notificationsMenu": "Уведомления ▾",
  "room.notifyAll": "Все сообщения",
  "room.notifyAllHint": "уведомлять о каждом",
  "room.notifyMentions": "Только упоминания",
  "room.notifyMentionsHint": "молчать, пока не назвали",
  "room.notifyNone": "Ничего",
  "room.notifyNoneHint": "тихо, включая упоминания",
  "room.openMembers": "Открыть список участников",
  "room.openSettings": "Открыть настройки комнаты",
  "room.pageLabel": "Страница комнаты",
  "room.peopleTab": "Личные",
  "room.railAria": "Пространства",
  "room.receiptError": "Отметка о прочтении не отправилась: {error}",
  "room.removeFavourite": "Из избранного",
  "room.roomPage": "Страница комнаты",
  "room.roomSettings": "Настройки комнаты",
  "room.scanBusy": "смотрю…",
  "room.scanComplete": "История просмотрена полностью.",
  "room.scanCount": "Просмотрено {count} сообщений.",
  "room.scanDeeper": "искать глубже",
  "room.searchAria": "Поиск по чатам",
  "room.searchPlaceholder": "Поиск",
  "room.sectionChats": "Чаты",
  "room.sectionFavourites": "Избранное",
  "room.sidebarAria": "Список чатов",
  "room.spaceCreate": "+ Пространство",
  "room.mobileCreateTitle": "Создать",
  "room.mobileCreateRoom": "Комната",
  "room.mobileCreateDm": "Личный чат",
  "room.mobileCreateSpace": "Пространство",
  "room.spaceEmpty": "В этом пространстве нет чатов, в которые вы вошли",
  "room.spaceLeave": "Выйти из пространства",
  "room.spaceMembers": "Участники пространства",
  "room.spaceRename": "Настройки пространства",
  "room.tabFiles": "Файлы",
  "room.tabLinks": "Ссылки",
  "room.tabMedia": "Медиа",
  "room.tabMembers": "Участники",
  "room.tabVoice": "Голосовые",
  "room.unfavouriteMenu": "Убрать из избранного",
  "room.unreadTab": "Непрочитанные",
  "room.you": "вы",
  "space.admin": "админ",
  "space.invited": "приглашён",
  "space.membersNotFound": "Пространство не найдено в загруженных данных. Обновите страницу.",
  "space.partialRemoval": "Удалено не везде. Осталось: {rooms}",
  "space.removeQuestion": "Удалить {user} из пространства?",
  "space.removeSummary": "Он выйдет из пространства и из {count} комнат внутри него. Комнаты и переписка остаются на месте — ничего не удаляется. Комната, где вас было двое, останется с одним участником и полной историей. Позвать человека обратно можно в любой момент.",
  "space.removed": "{user} удалён из пространства и его комнат ({count}).",
  "space.you": "это вы",
  "thread.loadOlder": "↑ прокрутите вверх, чтобы загрузить историю",
  "thread.noReplies": "Ответов пока нет.",
  "thread.sendError": "Не удалось отправить ответ: {error}",
  "thread.start": "начало треда",
  "thread.title": "Тред",
  "timeline.attachmentFallback": "файл",
  "timeline.attachmentNotLoaded": "не загрузилось",
  "timeline.audioOpen": "Открыть в просмотрщике",
  "timeline.callActive": "Звонок идёт",
  "timeline.callDecline": "Отклонить",
  "timeline.callDuration": "Длительность: {duration}",
  "timeline.callFinished": "Звонок завершён",
  "timeline.callJoin": "Присоединиться",
  "timeline.callParticipantsCount": "Участники: {count}",
  "timeline.copyLink": "Копировать ссылку",
  "timeline.dayToday": "сегодня",
  "timeline.dayYesterday": "вчера",
  "timeline.delete": "Удалить",
  "timeline.downloadFile": "Скачать файл",
  "timeline.downloading": "Скачиваю…",
  "timeline.edit": "Изменить",
  "timeline.emote": "* {user} {body}",
  "timeline.historyBeginning": "начало комнаты",
  "timeline.loadOlder": "↑ Загрузить ещё",
  "timeline.noMessages": "Сообщений пока нет.",
  "timeline.openViewer": "Открыть в просмотрщике",
  "timeline.reaction": "Реакция",
  "timeline.repliesFew": "{count} ответа",
  "timeline.repliesMany": "{count} ответов",
  "timeline.repliesOne": "{count} ответ",
  "timeline.reply": "Ответить",
  "timeline.senderMe": "Вы",
  "timeline.senderUnknown": "неизвестно",
  "timeline.share": "Поделиться",
  "ui.zakryt_esc": "Закрыть (Esc)",
  "ui.nuzhna_kartinka_png_jpeg_i_t_p": "Нужна картинка (PNG, JPEG и т.п.)",
  "ui.bez_imeni": "без имени",
  "ui.limit_poka_ne_deystvuet_servernaya_chast": " Лимит пока не действует: серверная часть в работе.",
  "ui.ustroystvo_bez_imeni": "Устройство без имени",
  "ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta": "Удалить это устройство (выход из аккаунта)",
  "ui.udalit_eto_ustroystvo": "Удалить это устройство",
  "ui.udalit_ustroystvo": "Удалить устройство",
  "ui.udalyayu": "Удаляю…",
  "ui.da_zavershit": "Да, завершить",
  "ui.ustroystvo": "устройство",
  "ui.zavershit_etot_vhod": "Завершить этот вход",
  "ui.filtr_po_chatu": "Фильтр по чату",
  "ui.gotovlyu_fayl": "Готовлю файл…",
  "ui.vas_ni_v_ch_m_ne_upominali": "Вас ни в чём не упоминали",
  "ui.home_chaty_vne_prostranstv": "Home — чаты вне пространств",
  "ui.sozdat_prostranstvo": "Создать пространство",
  "ui.v_istorii_komnaty_ne_naydeno_kartinok_i": "В истории комнаты не найдено картинок и видео",
  "ui.my_prosmotreli_tolko_chast_istorii_nazhm": "Мы просмотрели только часть истории — нажмите «искать глубже» ниже.",
  "ui.kb": "КБ",
  "ui.mb": "МБ",
  "ui.gb": "ГБ",
  "ui.v_istorii_komnaty_ne_naydeno_faylov": "В истории комнаты не найдено файлов",
  "ui.v_istorii_komnaty_ne_naydeno_ssylok": "В истории комнаты не найдено ссылок",
  "ui.v_istorii_komnaty_ne_naydeno_golosovyh": "В истории комнаты не найдено голосовых",
  "ui.etot_brauzer_ne_dal_pereklyuchit_dinamik": "Этот браузер не дал переключить динамик. Звук остался на прежнем устройстве.",
  "ui.ne_udalos_pereklyuchit_ustroystvo_ostalo": "Не удалось переключить устройство — осталось прежнее.",
  "ui.mikrofon": "микрофон",
  "ui.kameru": "камеру",
  "ui.dinamik": "динамик",
  "ui.vybrannoe_ranee": "выбранное ранее",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne": "Звонки в зашифрованных комнатах пока не поддерживаются. ",
  "ui.sozdayte_obychnuyu_komnatu_ili_dozhdites_o": "Создайте обычную комнату или дождитесь обновления.",
  "ui.mikrofon_ne_dal_audiodorozhku": "Микрофон не дал аудиодорожку",
  "ui.kamera_ne_dala_videodorozhku": "Камера не дала видеодорожку",
  "ui.jwt_servis_v_otvete_net_url_jwt": "JWT-сервис: в ответе нет url/jwt",
  "ui.brauzer_ne_dal_videodorozhku_ekrana": "Браузер не дал видеодорожку экрана",
  "ui.ekran_vy": "Экран: Вы",
  "ui.demonstraciya_ekrana_ne_nachalas_dostup_n": "Демонстрация экрана не началась: доступ не дан",
  "ui.brauzer_ne_umeet_zapisyvat_opus": "Браузер не умеет записывать opus",
  "ui.slishkom_korotko": "Слишком коротко",
  "ui.golosovoe_dlinnee_5_minut": "Голосовое длиннее 5 минут",
  "ui.dostup_k_mikrofonu_zapresch_n": "Доступ к микрофону запрещён",
  "ui.priglash_n_no_esch_ne_vosh_l_uvedomlenie_pri": "Приглашён, но ещё не вошёл — уведомление придёт после входа",
  "ui.redaktiruyte_soobschenie": "Редактируйте сообщение…",
  "ui.otvet": "Ответ…",
  "ui.soobschenie_upomyanut_enter_otpravit": "Сообщение… (@ — упомянуть, Enter — отправить)",
  "ui.otpravit_fayl": "Отправить файл",
  "ui.uchastniki_komnaty": "Участники комнаты",
  "ui.isklyuchit_iz_komnaty": "Исключить из комнаты",
  "ui.zabanit": "Забанить",
  "ui.izmenit_prava": "Изменить права",
  "ui.prichina_neobyazatelno_vidna_drugim_uchast": "Причина (необязательно, видна другим участникам)",
  "ui.naprimer_flud": "Например: флуд",
  "ui.naprimer_spam": "Например: спам",
  "ui.snyat_ban": "Снять бан?",
  "ui.net_userid_klienta": "нет userId клиента",
  "ui.ustroystvo_2": "Устройство",
  "ui.yandeks_brauzer": "Яндекс.Браузер",
  "ui.brauzer": "браузер",
  "ui.net_access_token": "нет access token",
  "ui.net_client_id_sessiya_ne_oidc": "нет client_id — сессия не OIDC",
  "ui.net_device_id": "нет device_id",
  "ui.mas_graphql_endpoint_ne_obyavlen": "MAS GraphQL endpoint не объявлен",
  "ui.device_authorization_endpoint_ne_obyavle": "Device authorization endpoint не объявлен",
  "ui.token_endpoint_ne_obyavlen": "Token endpoint не объявлен",
  "ui.polzovatel_otklonil_avtorizaciyu": "Пользователь отклонил авторизацию",
  "ui.kod_ist_k": "Код истёк",
  "ui.vremya_ozhidaniya_isteklo": "Время ожидания истекло",
  "ui.id_t_demonstraciya_vashego_ekrana": "Идёт демонстрация вашего экрана",
  "ui.vernutsya_v_zvonok": "Вернуться в звонок",
  "ui.vyklyuchit_mikrofon": "Выключить микрофон",
  "ui.vklyuchit_mikrofon": "Включить микрофон",
  "ui.vyklyuchit_kameru": "Выключить камеру",
  "ui.vklyuchit_kameru": "Включить камеру",
  "ui.otmenit_zvonok": "Отменить звонок",
  "ui.brauzer_otklonil_pokaz_onerror": "браузер отклонил показ (onerror)",
  "ui.api_otsutstvuet": " · API отсутствует",
  "ui.uchastnik": "участник",
  "ui.uchastnikov": "участников",
  "ui.bez_administratora_prostranstvom_nelzya": "Без администратора пространством нельзя будет управлять: ни пригласить, ",
  "ui.ni_dobavit_komnatu_ni_izmenit_nastroyk": "ни добавить комнату, ни изменить настройки. Сначала назначьте другого ",
  "ui.administratora_ili_udalite_ostalnyh_ucha": "администратора или удалите остальных участников.",
  "ui.izmenenie_sobstvennogo_urovnya_prav_zdes": "Изменение собственного уровня прав здесь запрещено",
  "ui.net_eventid_u_redaktiruemogo_soobscheniya": "нет eventId у редактируемого сообщения",
  "ui.net_eventid_dlya_redact": "нет eventId для redact",
  "ui.otklonit_zvonok_zvonyaschiy_uznaet_ob_otka": "Отклонить звонок — звонящий узнает об отказе",
  "ui.staree": "Старее (←)",
  "ui.novee": "Новее (→)",
  "ui.udaleno_ne_vezde_ostalos": "Удалено не везде. Осталось: ",
  "ui.komnaty": "комнаты",
  "ui.komnat": "комнат",
  "ui.ne_udalos_postroit_ssylku_iz_mxc": "не удалось построить ссылку из mxc://",
  "ui.nedostatochno_prav_dlya_otpravki_soobscheniy": "Недостаточно прав для отправки сообщений в эту комнату",
  "ui.redaktiruemoe_soobschenie_ne_naydeno_v_len": "Редактируемое сообщение не найдено в ленте",
  "ui.soobschenie_na_kotoroe_vy_otvechaete_ne_nay": "Сообщение, на которое вы отвечаете, не найдено в ленте",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne_2": "Звонки в зашифрованных комнатах пока не поддерживаются",
  "ui.vybrat_mikrofon_i_dinamik": "Выбрать микрофон и динамик",
  "ui.zaprashivaem_dostup_k_kamere": "Запрашиваем доступ к камере…",
  "ui.vklyuchit_kameru_zaprosim_dostup": "Включить камеру (запросим доступ)",
  "ui.vybrat_kameru": "Выбрать камеру",
  "ui.demonstraciya_ekrana_nedostupna_v_etom_br": "Демонстрация экрана недоступна в этом браузере",
  "ui.vybiraem_okno_ili_ekran": "Выбираем окно или экран…",
  "ui.ostanovit_demonstraciyu_ekrana": "Остановить демонстрацию экрана",
  "ui.demonstraciya_ekrana": "Демонстрация экрана",
  "ui.svernut_zvonok_v_okoshko_chtoby_pisat_v": "Свернуть звонок в окошко — чтобы писать в этой комнате",
  "ui.uchastnika": "участника",
  "ui.podklyuchaemsya_k_zvonku": "Подключаемся к звонку…",
  "ui.id_t_zvonok_zhd_m_otveta": "Идёт звонок, ждём ответа",
  "ui.otkazatsya_ot_zvonka_zvonyaschiy_uznaet_ob": "Отказаться от звонка — звонящий узнает об отказе",
  "ui.otkazatsya_ot_zvonka": "Отказаться от звонка",
  "ui.otmenit_podklyuchenie": "Отменить подключение",
  "ui.udalit_soobschenie": "Удалить сообщение?",
  "ui.nedostatochno_prav_dlya_udaleniya_etogo_soo": "Недостаточно прав для удаления этого сообщения.",
  "ui.soobschenie_ne_naydeno": "Сообщение не найдено",
  "ui.udalit_svo_soobschenie": "Удалить своё сообщение?",
  "ui.udalit_soobschenie_moderatorom": "Удалить сообщение модератором?",
  "ui.soobschenie_ne_naydeno_v_lente": "Сообщение не найдено в ленте.",
  "ui.komnata_budet_sozdana_vne_prostranstv_do": "Комната будет создана вне пространств («Дом»). Приглашать в неё можно любого пользователя.",
  "ui.pustoe_imya_polzovatelya_do_dvoetochiya": "Пустое имя пользователя до двоеточия",
  "ui.pokazany_uchastniki_vybrannogo_prostranst": "Показаны участники выбранного пространства. Чтобы видеть всех, переключитесь на «Дом» в рельсе слева.",
  "ui.naprimer_otdel_prodazh": "Например: Отдел продаж",
  "ui.perenesti": "Перенести",
  "ui.seychas_komnata_vne_prostranstv_dom": "Сейчас комната вне пространств («Дом»).",
  "ui.podskazyvat_nekogo_vse_kogo_vy_znaete_p": "Подсказывать некого: все, кого вы знаете по пространствам, уже здесь. Введите полный идентификатор вида @логин:algsuccess.com.",
  "ui.zagruzka": "Загрузка…",
  "ui.zagruzit_avatar_komnaty": "Загрузить аватар комнаты",
  "ui.vidna_vsem_dazhe_bez_vhoda": "видна всем, даже без входа",
  "ui.s_momenta_vhoda_uchastnika": "с момента входа участника",
  "ui.s_momenta_priglasheniya": "с момента приглашения",
  "ui.tolko_s_momenta_vhoda": "только с момента входа",
  "ui.tema": "Тема",
  "ui.avatar": "Аватар",
  "ui.publichnaya": "публичная",
  "ui.po_priglasheniyu": "по приглашению",
  "ui.pisat_soobscheniya": "Писать сообщения",
  "ui.priglashat_uchastnikov": "Приглашать участников",
  "ui.udalyat_chuzhie_soobscheniya": "Удалять чужие сообщения",
  "ui.menyat_nastroyki_i_roli": "Менять настройки и роли",
  "ui.uchastniki": "участники",
  "ui.moderatory": "модераторы",
  "ui.adminy": "админы",
  "ui.nedostatochno_prav_dlya_izmeneniya": "Недостаточно прав для изменения",
  "ui.menyat_prava_roley_mozhet_tolko_tot_u_ko": "Менять права ролей может только тот, у кого достаточно прав (порог m.room.power_levels). У вас их нет — значения показаны для сведения.",
  "ui.otvetov": "ответов",
  "ui.otvet_2": "ответ",
  "ui.otveta": "ответа",
  "ui.history_avtodogruzka_ostanovlena_8_stra": "[history] автодогрузка остановлена: 8 страниц без прироста",
  "ui.naverhu_stranica_ne_dala_vidimyh_soobschen": "наверху, страница не дала видимых сообщений",
  "ui.soobschenie_ne_zagruzheno": "Сообщение не загружено",
  "ui.menshe_minuty": "меньше минуты",
  "ui.snyat_reakciyu": "Снять реакцию",
  "ui.drugoy_emodzi": "Другой эмодзи",
  "ui.otvetit_v_trede": "Ответить в треде",
  "ui.kopirovat_tekst": "Копировать текст",
  "ui.prostranstva": "пространства",
  "ui.prostranstvo": "пространство",
  "ui.komnatu": "комнату",
  "ui.publichnoe_prostranstvo_vidno_v_kataloge": "Публичное пространство видно в каталоге сервера и войти может любой сотрудник. По приглашению — только по инвайту от участника.",
  "ui.publichnaya_komnata_vidna_v_kataloge_serve": "Публичная комната видна в каталоге сервера и войти может любой сотрудник. По приглашению — только по инвайту от участника.",
  "ui.etogo_prostranstva": "этого пространства",
  "ui.etoy_komnaty": "этой комнаты",
  "ui.zagruzit": "Загрузить",
  "ui.zakryt_tred": "Закрыть тред",
  "ui.otvetit_v_tred_upomyanut_enter_otpravit": "Ответить в тред… (@ — упомянуть, Enter — отправить)",
  "ui.perenesti_v_prostranstvo": "Перенести в пространство…",
  "ui.nastroyki_komnaty": "Настройки комнаты…",
  "profile.language": "Язык",
  "profile.files": "Мои файлы",
  "profile.server": "Сервер",
  "profile.serverChange": "сменить",
  "theme.system": "Как в системе",
  "theme.light": "Светлая",
  "theme.dark": "Тёмная",
  "ui.b": "Б",
  "rtc.deviceDefault": "По умолчанию",
  "rtc.micLabel": "Микрофон",
  "rtc.cameraLabel": "Камера",
  "rtc.speakerLabel": "Динамик",
  "rtc.micWord": "микрофон",
  "rtc.cameraWord": "камеру",
  "rtc.speakerWord": "динамик",
  "rtc.previouslyChosen": "выбранное ранее",
  "rtc.speakerSwitchFailed": "Этот браузер не дал переключить динамик. Звук остался на прежнем.",
  "rtc.deviceSwitchFailed": "Не удалось переключить устройство — осталось прежнее.",
  "rtc.encryptedNotSupported1": "Звонки в зашифрованных комнатах пока не поддерживаются. ",
  "rtc.encryptedNotSupported2": "Создайте обычную комнату или дождитесь обновления.",
  "rtc.you": "Вы",
  "rtc.screenYou": "Экран: Вы",
  "rtc.micMuted": "Микрофон выключен",
  "rtc.cameraOff": "Камера выключена",
  "rtc.screenShareDenied": "Демонстрация экрана не началась: доступ не дан",
  "device.generic": "Устройство",
  "device.yandexBrowser": "Яндекс.Браузер",
  "device.browserWord": "браузер",
  "file.generic": "файл",
  "error.rateLimited": "Сервер ограничивает частоту запросов. Попробуйте через минуту.",
  "space.memberSingular": "участник",
  "space.memberPlural": "участников",
  "space.lastAdminWarn1": "Без администратора пространством нельзя будет управлять: ни пригласить, ",
  "space.lastAdminWarn2": "ни добавить комнату, ни изменить настройки. Сначала назначьте другого ",
  "space.lastAdminWarn3": "администратора или удалите остальных участников.",
  "common.unknown": "неизвестно",
  "message.encrypted": "Зашифрованное сообщение",
  "message.youPrefix": "Вы",
  "room.inviteToRoom": "Приглашение в комнату",
  "message.deleted": "сообщение удалено",
  "message.wasDeleted": "Сообщение удалено",
  "message.attachment": "вложение",
  "emoji.searchPlaceholder": "Поиск (по-английски: heart, cat, fire)",
  "server.current": " · сейчас",
  "space.settingsMenu": "Настройки пространства…",
  "file.noName": "без имени",
  "error.noUserId": "нет userId клиента",
  "error.noAccessToken": "нет access token",
  "error.noClientIdNotOidc": "нет client_id — сессия не OIDC",
  "error.noDeviceId": "нет device_id",
  "error.masEndpointMissing": "MAS GraphQL endpoint не объявлен",
  "error.deviceAuthEndpointMissing": "Device authorization endpoint не объявлен",
  "error.tokenEndpointMissing": "Token endpoint не объявлен",
  "error.authDeclined": "Пользователь отклонил авторизацию",
  "error.codeExpired": "Код истёк",
  "error.waitTimeout": "Время ожидания истекло",
  "error.micNoTrack": "Микрофон не дал аудиодорожку",
  "error.cameraNoTrack": "Камера не дала видеодорожку",
  "error.jwtNoUrl": "JWT-сервис: в ответе нет url/jwt",
  "error.screenNoTrack": "Браузер не дал видеодорожку экрана",
  "error.ownPowerLevel": "Изменение собственного уровня прав здесь запрещено",
  "error.noEventIdEdit": "нет eventId у редактируемого сообщения",
  "error.noEventIdRedact": "нет eventId для redact",
  "error.mxcLinkFailed": "не удалось построить ссылку из mxc://",
  "error.providerMissing": "MatrixClientProvider отсутствует выше по дереву",
  "emoji.groupSmileys": "Улыбки и эмоции",
  "emoji.groupPeople": "Люди",
  "emoji.groupNature": "Животные и природа",
  "emoji.groupFood": "Еда и напитки",
  "emoji.groupTravel": "Путешествия",
  "emoji.groupActivities": "Занятия",
  "emoji.groupObjects": "Предметы",
  "emoji.groupSymbols": "Символы",
  "emoji.groupFlags": "Флаги",
  "server.hintMain": "рабочий сервер ALG",
  "server.hintStage": "тестовый, данные можно ломать",
  "error.serverAddressRequired": "Укажите адрес сервера",
  "error.serverAddressInvalid": "Адрес сервера выглядит неверно",
  "error.serverAddressHttps": "Адрес должен начинаться с https://",
  "call.ringDiagStarting": "звонок: попытка запуска звука…",
  "notification.newMessage": "Новое сообщение",
  "app.roomUnavailable": "Комната недоступна",
  "app.roomUnavailableBody": "Вы не состоите в этой комнате (или ссылка содержит опечатку). Попросите участника пригласить вас — после приглашения ссылка откроется сама.",
  "room.linkMenu": "Ссылка на комнату…",
  "roomLink.title": "Ссылка на «{room}»",
  "roomLink.hint": "Отправьте эту ссылку, чтобы пригласить в комнату. Ссылка открывает комнату в нашем мессенджере.",
  "roomLink.fieldLabel": "Ссылка",
  "roomLink.copy": "Копировать",
  "roomLink.share": "Поделиться",
  "roomLink.copied": "Ссылка скопирована",
  "roomLink.copyFailed": "Не удалось скопировать — выделите ссылку и скопируйте вручную",
  "roomLink.closedHint": "Комната закрытая (только по приглашению): по ссылке войдут те, кого уже пригласили. Остальные увидят просьбу запросить приглашение.",
  "roomLink.openHint": "Комната открытая: любой пользователь сервера войдёт по ссылке.",
  "roomLink.restrictedHint": "Войти по ссылке смогут участники пространства, к которому относится комната.",
  "roomLink.knockHint": "В комнату можно попроситься, но заявку этот клиент пока не отправляет: без приглашения по ссылке не войти.",
  "roomGate.title": "Комната по ссылке",
  "roomGate.loading": "Проверяем комнату…",
  "roomGate.join": "Войти в комнату",
  "roomGate.joining": "Входим…",
  "roomGate.members": "Участников: {count}",
  "roomGate.closedTitle": "Комната закрытая, попросите приглашение",
  "roomGate.closedBody": "По ссылке войти нельзя: в эту комнату попадают только по приглашению. Попросите участника пригласить вас — после приглашения ссылка откроется сама.",
  "roomGate.knockBody": "В эту комнату можно попроситься, но отправка заявки из этого клиента пока не включена. Попросите участника пригласить вас.",
  "roomGate.notFound": "Комната по этой ссылке не найдена. Проверьте ссылку.",
  "app.clickToOpen": "Нажмите, чтобы перейти",
  "app.goBack": "Вернуться",
  "composer.releaseToSend": "Отпустите, чтобы отправить",
  "composer.photoVideo": "Фото/видео",
  "composer.file": "Файл",
  "composer.voiceMessage": "Голосовое сообщение",
  "composer.toRoom": "В комнату:",
  "common.secShort": "сек",
  "emoji.nothingFound": "Ничего не найдено",
  "error.boundaryBody": "Приложение наткнулось на ошибку и остановило отрисовку этого экрана. Остальное работает — можно вернуться назад.",
  "media.fileDownloaded": "Файл скачан.",
  "media.shareFallbackDownloaded": "Поделиться не удалось — файл скачан.",
  "member.youSuffix": "· вы",
  "member.banCannotReturn": "не сможет войти обратно",
  "member.banCannotReturnTail": ", даже по новому приглашению, пока бан не будет снят вручную (список забаненных — внизу панели участников).",
  "member.kickNoAutoReturn": "не вернётся в комнату автоматически",
  "member.kickNoAutoReturnTail": ": ему нужно войти заново или быть приглашённым повторно.",
  "member.roleExplain": "Роль определяет, что участник может делать в комнате: писать, приглашать, модерировать, менять настройки. Повышение действует сразу для всех клиентов.",
  "member.powerLevel": "Уровень прав",
  "member.stateNotLoaded": ". Часть состояния комнаты ещё не подгружена.",
  "member.kickWarnBody": "будет исключён из комнаты и сможет вернуться по новому приглашению (или сам, если комната публичная).",
  "member.unbanWarn": "будет разбанен, но",
  "notification.iosHint": "На iPhone/iPad уведомления доступны, только если сайт добавлен на домашний экран (Поделиться → На экран «Домой»).",
  "notification.blockedHint": "Уведомления заблокированы самим браузером — из приложения снять запрет нельзя. В Safari это Настройки → Сайты → Уведомления.",
  "notification.showNew": "Показывать уведомления о новых сообщениях",
  "notification.soundNew": "Звук о новом сообщении",
  "notification.ringOnCall": "Звонок при входящем звонке",
  "profile.deviceCodeHint": "Откроется код: введите его на новом устройстве, чтобы подтвердить вход с него на этом аккаунте.",
  "profile.multiSessionHint": "Несколько входов с одного устройства; если какой-то из них не ваш — завершите его.",
  "profile.thisDeviceSuffix": "· это устройство",
  "profile.clientUnknown": "клиент неизвестен — сервер его не отдаёт",
  "profile.generatingCode": "Генерирую код…",
  "profile.notificationsOnHint": "Уведомления включены. Правила тишины (открытая комната не пищит) действуют автоматически.",
  "profile.notYouHint": ". Если это не вы — откройте управление устройством и завершите чужой вход.",
  "profile.deviceLimitHint": "-го устройства потребуется подтверждение администратора. Ограничение пока не действует: серверная часть в работе.",
  "profile.sessionsWord": "сессии",
  "profile.permissionRetryHint": "). Кнопка ниже повторно спросит браузер; при ответе «запрещено» изменить его можно только в настройках браузера.",
  "dialog.cannotLeaveSpace": "Нельзя выйти из пространства",
  "dialog.youWillLeaveSpace": "Вы выйдете из пространства",
  "dialog.leaveSpaceTail": ". Его комнаты исчезнут из вашего списка, а вернуться можно будет только по новому приглашению.",
  "dialog.youWillLeaveRoom": "Вы выйдете из комнаты",
  "dialog.leaveRoomTail": ". История останется на сервере, но вам она будет недоступна. Вернуться в приватную комнату можно только по новому приглашению.",
  "dialog.invitationTo": "Приглашение в",
  "dialog.inviteDeclineTail": "будет отклонено. Если вас пригласят ещё раз, комната появится снова.",
  "dialog.spaceExplain": "Пространство объединяет комнаты и людей. Участник пространства видит открытые комнаты пространства.",
  "dialog.noSpacesToMove": "Некуда переносить: нет пространств, где у вас есть права на управление составом (m.space.child). Попросите администратора пространства выполнить перенос или повысить ваш уровень прав.",
  "dialog.outsideSpacesHome": "— Вне пространств (Дом) —",
  "dialog.inviteSpaceHint": "Приглашённый увидит открытые комнаты пространства и всех его участников. Комнаты «только по приглашению» останутся скрытыми.",
  "room.encryptionWord": "Шифрование",
  "room.encNotSupportedOff": "не поддерживает — выключено",
  "room.encReadInElement": ". Читать такую комнату можно в Element. Включить шифрование здесь нельзя.",
  "room.offWord": "выключено",
  "room.encDisabledTail": ": комната не зашифрована, а поддержка E2EE в этом клиенте отключена намеренно. Включить её здесь нельзя.",
  "room.changeSettings": "Изменить настройки…",
  "room.noRightsSettings": "У вас нет прав менять эти настройки — они показаны для сведения. Обратитесь к администратору комнаты.",
  "room.noRights": "нет прав",
  "room.rolePermissions": "Права ролей",
  "room.advancedSettings": "Расширенные настройки",
  "room.settingsSubtitle": "Настройки комнаты, права ролей, шифрование",
  "room.loadingHistory": "Смотрю историю…",
  "room.publicWord": "Публичная",
  "room.historyShared": "С момента входа (shared)",
  "room.historyJoined": "Только с момента входа (joined)",
  "room.historyExplain": "«С момента входа» — новый участник видит историю с момента своего входа. «Только с момента входа» — строже: даже приглашение не открывает прошлое.",
  "room.thisIsWord": "Это",
  "room.invitationWord": "приглашение",
  "room.inviteHintTail": ". Нажмите «Принять» в шапке, чтобы войти в комнату, или «Отклонить», чтобы убрать её из списка. Содержимое комнаты до входа не показывается.",
  "room.encryptedNoticeTail": "Этот клиент их намеренно не читает: шифрование в нём отключено. Отправка сюда тоже недоступна — незашифрованное сообщение в зашифрованной комнате другие клиенты отвергнут. Пользуйтесь для этой комнаты Element.",
  "room.callInProgress": "Разговор идёт",
  "room.callConnectFailed": "Не удалось подключиться к звонку.",
  "common.tryAgain": "Попробовать снова",
  "room.moderatorDeleteNotice": "Вы удаляете чужое сообщение по праву модератора. Другие участники увидят, что сообщение удалено.",
  "room.noVideoYet": "· видео никто не включил",
  "server.pickerHint": "Приложение подключится к выбранному серверу. Сессия и устройства хранятся отдельно для каждого сервера.",
  "space.fromSpaceQuestion": "из пространства?",
  "space.itIsYou": "— это вы",
  "space.adminSuffix": "· админ",
  "space.noMembersYet": "В пространстве пока нет участников кроме вас.",
  "space.removeMemberTail": ". Комнаты и переписка остаются на месте — ничего не удаляется. Комната, где вас было двое, останется с одним участником и полной историей. Позвать человека обратно можно в любой момент.",
  "space.invitedSuffix": "· приглашён",
  "message.editedMark": "(изменено)",
  "message.sendingMark": "· отправляю…",
  "message.notSentMark": "· не отправлено",
  "timeline.loadingPreview": "Загружаю превью…",
  "timeline.callOngoing": "Идёт звонок",
  "timeline.loadingTail": "— загружаю…",
  "member.kickShort": "Кик",
  "member.banShort": "Бан",
  "notification.permissionNotGranted": "Разрешение не выдано",
  "member.banStricterHead": "Бан строже исключения:",
  "profile.deviceLimitHead": "При добавлении",
  "room.membersCountOne": "участник",
  "room.membersCountFew": "участника",
  "room.membersCountMany": "участников",
  "profile.deviceLabelWeb": "{machine} · {client} (веб)",
  "profile.deviceDeleteUnexpectedStatus": "Неожиданный статус удаления: {status}",
  "matrix.errorUserNotFoundOnServer": "Пользователь {user} не найден на своём сервере",
  "matrix.errorServerUnreachable": "Не удаётся связаться с сервером: {detail}. Проверьте домен.",
  "space.lastAdminHead": "Вы единственный администратор, а в пространстве ещё {count} ",
  "timeline.inReplyTo": "В ответ на",
  "rtc.deviceDisconnectedFallback": "{device} «{name}» отключено — переключились на устройство по умолчанию.",
  "rtc.speakerRestored": "Динамик «{name}» снова доступен — звук вернули на него.",
  "rtc.callMembershipFailed": "Членство звонка не записалось в комнату: {error}. Другие участники вас не увидят. Попробуйте выйти и войти снова.",
  "rtc.screenOf": "Экран: {name}",
  "error.jwtHttp": "JWT-сервис: HTTP {status}",
  "space.notInRoomSpace": "{user} не состоит в пространстве этой комнаты. Сначала пусть администратор добавит человека в пространство — только после этого его можно приглашать в комнаты и звонки.",
  "timeline.roomNameChanged": "{actor} изменил(а) название комнаты на «{name}»",
  "timeline.roomNameRemoved": "{actor} убрал(а) название комнаты",
  "timeline.roomTopicChanged": "{actor} изменил(а) тему комнаты",
  "timeline.roomTopicRemoved": "{actor} убрал(а) тему комнаты",
  "timeline.roomAvatarChanged": "{actor} изменил(а) аватар комнаты",
  "timeline.roomAvatarRemoved": "{actor} убрал(а) аватар комнаты",
  "timeline.memberInvited": "{actor} пригласил(а) {subject} в комнату",
  "timeline.memberRenamed": "{oldName} теперь {newName}",
  "timeline.memberAvatarChanged": "{subject} изменил(а) свой аватар",
  "timeline.memberJoined": "{subject} вошёл(ла) в комнату",
  "timeline.memberUnbanned": "{actor} разблокировал(а) {subject}",
  "timeline.memberLeft": "{subject} вышел(ла) из комнаты",
  "timeline.memberKicked": "{actor} исключил(а) {subject} из комнаты{reason}",
  "timeline.memberBanned": "{actor} заблокировал(а) {subject}{reason}",
  "timeline.summaryJoined": "{names} вошли в комнату",
  "timeline.summaryInvited": "{names} приглашены в комнату",
  "timeline.summaryLeft": "{names} вышли из комнаты",
  "timeline.summaryKicked": "{names} исключены из комнаты",
  "timeline.summaryBanned": "{names} заблокированы",
  "timeline.summaryUnbanned": "{names} разблокированы",
  "timeline.namesTwo": "{first} и {second}",
  "timeline.namesThree": "{first}, {second} и {third}",
  "timeline.namesMoreOne": "{first}, {second} и ещё {count} участник",
  "timeline.namesMoreFew": "{first}, {second} и ещё {count} участника",
  "timeline.namesMoreMany": "{first}, {second} и ещё {count} участников",
  "profile.titleWithName": "Личный кабинет — {name}",
  "common.sizeBytes": "{size} Б",
  "common.sizeKb": "{size} КБ",
  "common.sizeMb": "{size} МБ",
  "space.membersTitle": "Участники: {space}",
  "timeline.readUpToHere": "{name} дочитал досюда",
  "timeline.attachmentDownload": "{info} · скачать",
  "timeline.threadLastSender": " · последний: {name}",
  "timeline.durationMinutes": "{minutes} мин",
  "timeline.durationHours": "{hours} ч",
  "timeline.durationHoursMinutes": "{hours} ч {minutes} мин",
  "timeline.addReaction": "Поставить {emoji}",
  "timeline.openThreadCount": "Открыть тред · {count}",
  "call.ringBlocked": "звук заблокирован браузером: {prefix}",
  "call.ringStarted": "звук запущен ({prefix})",
  "room.inviteAcceptFailed": "Не удалось принять приглашение в «{room}»: {error}",
  "call.ongoingVideoInRoom": "📹 Идёт видеозвонок · {room}",
  "call.ongoingAudioInRoom": "📞 Идёт звонок · {room}",
  "call.incomingVideoFrom": "Входящий видеозвонок: {callers}",
  "call.incomingAudioFrom": "Входящий звонок: {callers}",
  "call.roomOngoingParticipants": "{room} · идёт звонок · {participants}",
  "media.downloadNamed": "Скачать {name}",
  "profile.fileFrom": "от {user}",
  "profile.loadFailed": "Не удалось загрузить: {error}",
  "dialog.domainLooksTruncated": "Домен «{host}» выглядит обрезанным",
  "dialog.removeEntry": "Убрать {id}",
  "room.yourPowerLevel": "Ваш уровень прав: {level}. Порог выше вашего уровня сервер не примет.",
  "call.declinedBy": "{name} отклонил(а) звонок",
  "call.inCallOne": "Вы в звонке · {count} участник",
  "call.inCallFew": "Вы в звонке · {count} участника",
  "call.inCallMany": "Вы в звонке · {count} участников",
  "member.actionsFor": "Действия: {name}",
  "member.kickQuestion": "Исключить {name}?",
  "member.banQuestion": "Забанить {name}?",
  "member.roleFor": "Роль: {name}",
  "notification.cannotShowPermission": "нельзя показать: permission={permission}",
  "notification.showError": "ошибка показа: {error}",
  "profile.photoOf": "Фото: {name}",
  "profile.deviceAdded": "добавлено {date}",
  "profile.renameDeviceNamed": "Переименовать {device}",
  "profile.endSessionNamed": "Завершить вход {device}",
  "composer.micEnableFailed": "Не удалось включить микрофон: {error}",
  "space.notInAnySpace": "{user} не состоит ни в одном вашем пространстве. Личный чат возможен только внутри общего пространства — сначала администратор должен добавить человека туда.",
  "dialog.noSettingsPermissionRoom": "У вас нет прав на изменение настроек этой комнаты.",
  "dialog.noSettingsPermissionSpace": "У вас нет прав на изменение настроек этого пространства.",
  "dialog.spaceSettings": "Настройки: {space}",
  "profile.masSessionNotFound": "Активная сессия устройства {deviceId} не найдена в MAS — возможно, она уже завершена. Обновите список; если устройство осталось, повторите удаление.",
  "rtc.deviceSwitchError": "Не удалось переключить {device}: {error}",
  "profile.newDeviceOne": "С прошлого просмотра появилось новое устройство: {devices}",
  "profile.newDeviceMany": "С прошлого просмотра появились новые устройства ({count}): {devices}",
  "profile.deviceCount": "Устройств: {count} из {limit}.",
  "room.levelValue": "уровень {level}",
  "thread.historyError": "История треда не догрузилась: {error}",
  "thread.replyNotSent": "Ответ не отправлен: {error}",
  "call.ringingWaitAnswer": "Идёт звонок, ждём ответа…",
  "call.noAnswerCountdown": "Никто не ответил · звонок завершится через 0:{seconds}",
  "call.waitingCountdown": "Ждём ответа · завершится через 0:{seconds}",
  "call.cameraFailed": "Камера не включилась: {error}",
  "call.screenShareFailed": "Демонстрация экрана не включилась: {error}",
  "call.roomCallWithCount": "В комнате идёт звонок · {count} {word}",
  "space.leaveRoomsOne": "Он выйдет из пространства и из {count} комнаты внутри него",
  "space.leaveRoomsFew": "Он выйдет из пространства и из {count} комнат внутри него",
  "space.leaveRoomsMany": "Он выйдет из пространства и из {count} комнат внутри него",
  "app.invitedBy": "Пригласил(а): {user}",
  "composer.voiceRecordingSeconds": "Записываю голосовое… {seconds} сек",
  "media.slideBroken": "{icon} {name} — не загрузилось",
  "media.slideBrokenError": "{icon} {name} — не загрузилось: {error}",
  "room.attachmentBrokenNoError": "📎 {name} {size} — не загрузилось",
  "composer.deleteRecording": "Удалить запись",
  "composer.recordingDuration": "Длительность: {seconds} сек.",
  "composer.stopRecording": "Остановить запись",
  "composer.formattingToolbar": "Форматирование текста",
  "composer.bold": "Полужирный",
  "composer.italic": "Курсив",
  "composer.underline": "Подчёркнутый",
  "composer.strikethrough": "Зачёркнутый",
  "composer.textColorRed": "Цвет текста: красный",
  "composer.textColorOrange": "Цвет текста: оранжевый",
  "composer.textColorGreen": "Цвет текста: зелёный",
  "composer.textColorBlue": "Цвет текста: синий",
  "composer.textColorPurple": "Цвет текста: фиолетовый",
  "notification.messageSoundLabel": "Звук сообщения",
  "notification.callSoundLabel": "Звук звонка",
  "notification.previewSound": "Прослушать",
  "notification.roomModeLabel": "Режим уведомлений",
  "notification.roomSoundLabel": "Звук этого чата",
  "notification.soundDefault": "По умолчанию",
  "notification.soundSoft": "Мягкий",
  "notification.soundDouble": "Двойной сигнал",
  "notification.soundChime": "Перезвон",
  "fontSize.default": "По умолчанию",
  "fontSize.label": "Размер текста",
  "fontSize.large": "Большой",
  "fontSize.small": "Маленький",
  "notification.acceptedUnverified": "Приложение приняло запрос, но системный показ не подтверждён",
  "notification.appDisabled": "Системные уведомления выключены в приложении",
  "notification.appEnabled": "Системные уведомления включены в приложении",
  "notification.categoriesTitle": "Типы уведомлений",
  "notification.categoryCalls": "Входящие звонки",
  "notification.categoryDirect": "Личные сообщения",
  "notification.categoryGroup": "Сообщения в группах",
  "notification.categoryInvites": "Приглашения в комнаты и пространства",
  "notification.categoryMentions": "Упоминания и @room",
  "notification.categoryReactions": "Реакции на мои сообщения",
  "notification.categoryReplies": "Ответы и треды",
  "notification.createdVerified": "Системное уведомление создано приложением",
  "push.disable": "Отключить",
  "push.disabled": "Не включены для этого устройства",
  "push.enable": "Включить фоновые уведомления",
  "push.enabled": "Работают, даже когда приложение закрыто",
  "push.notReady": "Сервис фоновых уведомлений ещё не готов",
  "push.test": "Проверить фоновое уведомление",
  "push.testSent": "Фоновое уведомление отправлено",
  "push.title": "Фоновые уведомления",
  "push.working": "Подождите…",
  "room.groupsTab": "Группы",
  "room.emptyGroups": "Нет групповых чатов",
  "chat.private": "Личный чат",
  "chat.filterLabel": "Фильтр: {value}",
  "chat.filterChats": "Фильтр чатов",
  "chat.filters": "Фильтры чатов",
  "chat.clearFilter": "Очистить фильтр",
  "chat.messagePrivately": "Написать лично",
  "profile.view": "Посмотреть профиль",
  "chat.jumpToLatest": "Перейти к последнему сообщению",
  "chat.jumpToMention": "К упоминанию",
  "settings.language": "Язык",
  "server.main": "Основной",
  "server.stage": "Тестовый",
  "server.matrixPlaceholder": "matrix.example.com",
  "notification.background": "Фоновые уведомления",
  "notification.notEnabledForDevice": "Не включено для этого устройства",
  "notification.enableBackground": "Включить фоновые уведомления",
  "notification.unsupportedRuntime": "Фоновые уведомления не поддерживаются средой выполнения этого приложения.",
  "typing.one": "{name} печатает",
  "typing.two": "{a} и {b} печатают",
  "typing.more": "{a}, {b} и ещё {count} печатают",
  "matrix.errorNetwork": "Нет связи с сервером. Проверьте подключение и повторите.",
  "picker.busy": "Предыдущая загрузка ещё идёт, подождите.",
  "picker.cancelled": "Файл не выбран.",
  "picker.chosen": "Выбран файл «{name}», отправляю…",
  "picker.done": "Готово, изображение загружено.",
  "picker.failed": "Не удалось загрузить: {error}",
  "picker.shellFailed": "Не удалось получить файл от приложения. Попробуйте ещё раз.",
  "picker.shellTooLarge": "Файл «{name}» слишком большой: {size}, предел {limit}.",
  "picker.noDialog": "Нажатие прошло, но система не открыла окно выбора файла. Покажите эту строку в поддержку.",
  "picker.noInput": "Поле выбора файла не готово. Откройте экран заново.",
  "picker.opening": "Открываю выбор файла…",
  "search.error": "Поиск по сообщениям не выполнен: {error}",
  "search.loadingMore": "Загружаю ещё…",
  "search.messagesCount": "Сообщения · найдено {count}",
  "search.messagesSection": "Сообщения",
  "search.more": "Показать ещё",
  "search.noMessages": "В сообщениях ничего не найдено по запросу «{query}»",
  "search.resultAria": "Сообщение от {sender} в «{room}»",
  "search.retry": "Повторить",
  "search.searching": "Ищу на сервере…",
  "search.tooShort": "Введите хотя бы 2 символа, чтобы искать по сообщениям",
  "search.unknownRoom": "Неизвестная комната",
  "app.sessionEndedTitle": "Сессия завершена на сервере",
  "app.sessionEndedBody": "Это устройство отключили от аккаунта. Войдите снова, чтобы продолжить.",
  "profile.logoutProgress": "Выхожу…",
  "profile.logoutRetry": "Повторить выход",
  "avatar.jpegOnly": "Не удалось подготовить картинку. Попробуйте файл JPEG.",
  "avatar.decodeFailed": "Не удалось открыть этот файл как картинку. Попробуйте JPEG или PNG.",
  "avatar.encodeFailed": "Не удалось преобразовать картинку в JPEG.",
  "ui.perevernut_kameru": "Перевернуть камеру",
  "call.labelSpeaker": "Динамик",
  "call.labelScreenShare": "Экран",
  "call.labelInvite": "Пригласить",
  "call.labelFlipCamera": "Перевернуть",
  "call.labelCompose": "Написать",
  "call.labelEnd": "Завершить",
  "call.labelMicrophone": "Микрофон",
  "call.labelCamera": "Камера",
  "message.forward": "Переслать",
  "forward.title": "Переслать в",
  "forward.unsupported": "Переслать можно только текстовое сообщение.",
  "forward.failed": "Не удалось переслать сообщение: {error}",
  "update.title": "Доступна новая версия",
  "update.body": "Доступна новая версия приложения: {version}.",
  "update.bodySize": "Доступна новая версия приложения: {version} · {size}.",
  "update.mandatoryNote": "Обновление обязательно: без него продолжить работу нельзя.",
  "update.now": "Обновить",
  "update.later": "Позже",
};

export type Messages = Record<keyof typeof ru, string>;

export const en: Messages = {
  "app.corporateLogin": "Sign in with ALG corporate account.",
  "app.errorLogin": "Sign-in failed: {error}",
  "app.hideActionError": "Hide",
  "app.incomingCall": "Incoming call · {room}",
  "app.inviteNotice": "You were invited to “{room}”",
  "app.inviteNoticeMore": "and {count} more",
  "app.login": "Sign in",
  "app.logout": "Sign out",
  "app.profile": "Profile",
  "app.settings": "Settings",
  "app.resetAndRestart": "Reset and start over",
  "app.selectRoom": "Select a room on the left.",
  "app.serverChoose": "Choose a server",
  "app.serverConnect": "Connecting to server…",
  "app.serverConnectButton": "Connect",
  "app.serverConnectDescription": "The app will connect to the selected server. Sessions and devices are stored separately for each one, so switching will not sign you out of another.",
  "app.serverCurrent": "current",
  "app.serverCustom": "Other address",
  "app.serverLabel": "Server: {server}",
  "app.serverProduction": "ALG production server",
  "app.serverStaging": "staging, data may be changed",
  "app.serverSwitch": "switch",
  "app.serverUrlPlaceholder": "matrix.example.com",
  "app.sessionCheck": "Checking session…",
  "app.unavailableRoom": "The room is unavailable or you are no longer a member.",
  "call.accept": "Accept call",
  "call.callInProgress": "call in progress",
  "call.captionRepliesEmpty": "No replies yet.",
  "call.decline": "Decline call",
  "call.deviceCamera": "Camera",
  "call.deviceDefault": "Default",
  "call.deviceFallback": "Device {count}",
  "call.deviceMicrophone": "Microphone",
  "call.deviceSpeaker": "Speaker",
  "call.copyDiagnostics": "Copy call diagnostics",
  "call.diagnosticsCopied": "Diagnostics copied",
  "call.diagnosticsCopyFailed": "Could not copy diagnostics",
  "call.goToRoom": "Go to room",
  "call.goToRoomHint": "Go to the room without answering the call",
  "call.videoCallInProgress": "video call in progress",
  "common.accept": "Accept",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.create": "Create",
  "common.decline": "Decline",
  "common.done": "Done",
  "common.hide": "Hide",
  "common.invite": "Invite",
  "common.inviteShort": "+ Invite",
  "common.leave": "Leave room",
  "common.messageEdited": " (edited)",
  "common.messageNotSent": " · not sent",
  "common.messageSending": " · sending…",
  "common.noMessages": "No messages yet.",
  "common.remove": "Delete",
  "common.roomStart": "room beginning",
  "common.save": "Save",
  "common.search": "Search",
  "common.yesDelete": "Yes, delete",
  "composer.attachFile": "Attach file",
  "composer.attachImage": "Attach image",
  "composer.attachMenu": "Attachments",
  "composer.attachTitle": "Attach file",
  "composer.cancelEdit": "Cancel editing",
  "composer.cancelReply": "Cancel reply",
  "composer.disabledPlaceholder": "You cannot write in this room",
  "composer.dropFiles": "Drop files here",
  "composer.editing": "Editing message",
  "composer.emoji": "Emoji",
  "composer.fileUploadProgress": "Uploading file… {percent}%",
  "composer.mentionAll": "Entire room",
  "composer.mentionInvited": "invited",
  "composer.reply": "Reply to {user}",
  "composer.sendButton": "Send",
  "composer.sendError": "Could not send: {error}",
  "composer.textPlaceholder": "Message… (Enter to send, Shift+Enter for a line break)",
  "dialog.avatarOfRoom": "Room avatar",
  "dialog.avatarOfSpace": "Space avatar",
  "dialog.createProgress": "Creating…",
  "dialog.declineDescription": "The invitation to “{room}” will be declined. If you are invited again, the room will appear again.",
  "dialog.declineProgress": "Declining…",
  "dialog.declineTitle": "Decline invitation?",
  "dialog.dmAllSpacesHint": "Members of all your spaces are shown. You can start a private chat only with people who share a space with you.",
  "dialog.dmDescription": "Search by name is not available yet: enter the full ID in the form @username:algsuccess.com. The person will receive an invitation.",
  "dialog.dmIdLabel": "Contact's Matrix ID",
  "dialog.dmSpaceHint": "Members of the selected space are shown. To see everyone, switch to “Home” in the rail on the left.",
  "dialog.dmTitle": "New private chat",
  "dialog.historyHint": "“From the time they join” means a new member sees history from when they joined. “Only from the time they join” means they see nothing from before joining. This change is not retroactive for members who have already joined.",
  "dialog.historyJoined": "Only from the time they join (new members cannot see the past)",
  "dialog.historyShared": "From the time they join (new members see history from when they joined)",
  "dialog.historyVisibility": "History visibility",
  "dialog.historyWho": "Who can see history",
  "dialog.inviteDone": "Invitation sent: {user}",
  "dialog.inviteIdLabel": "Matrix ID",
  "dialog.inviteProgress": "Inviting…",
  "dialog.inviteSent": "Invitation sent: {user}",
  "dialog.inviteSpaceDescription": "The invitee will see the space's public rooms and all its members. Invite-only rooms remain hidden until they are invited to each one separately.",
  "dialog.inviteSpaceTitle": "Invite to space “{space}”",
  "dialog.inviteOutsideSpaceWarning": "{user} is not a member of this room's space. You can still send the invite, but they will remain outside the space — an administrator should add them separately.",
  "dialog.inviteSuggestEmpty": "No matches — check the spelling or enter the full ID.",
  "dialog.inviteSuggestNone": "There is no one left to suggest: everyone you can invite is already in the room. Enter the full ID in the form @username:algsuccess.com.",
  "dialog.inviteTitle": "Invite to “{room}”",
  "dialog.joinByInvite": "By invitation",
  "dialog.joinMode": "Join mode",
  "dialog.joinRoom": "Join room",
  "dialog.joinSpace": "Join space",
  "dialog.leaveDescription": "You will leave “{room}”. Its history will remain on the server, but you will no longer be able to access it. You can return to a private room only with a new invitation.",
  "dialog.leaveProgress": "Leaving…",
  "dialog.leaveTitle": "Leave room?",
  "dialog.matrixIdBadDomain": "Invalid characters in server address",
  "dialog.matrixIdCyrillic": "This looks like a Russian keyboard layout — switch to English",
  "dialog.matrixIdInvalidLocalpart": "Usernames may contain only Latin letters, digits, and . _ - = + /",
  "dialog.matrixIdInvalidPrefix": "A Matrix ID starts with @",
  "dialog.matrixIdInvalidSpaces": "Matrix IDs cannot contain spaces",
  "dialog.matrixIdMissingServer": "Server is missing after the colon, for example @ivanov:algsuccess.com",
  "dialog.matrixIdMissingServerAddress": "Server address after the colon is empty",
  "dialog.matrixIdNoDomain": "Server address has no domain, for example algsuccess.com",
  "dialog.moveRoomCurrentHome": "The room is currently outside spaces (“Home”).",
  "dialog.moveRoomCurrentSpace": "The room is currently in the space “{space}”.",
  "dialog.moveRoomEmpty": "There is nowhere to move it: you have no spaces where you can manage membership. Ask a space admin to move it or raise your permission level.",
  "dialog.moveRoomLabel": "Move to",
  "dialog.moveRoomProgress": "Moving…",
  "dialog.moveRoomTitle": "Move “{room}”",
  "dialog.newName": "New name",
  "dialog.newRoomDescription": "Visible in the server directory; any employee can join. Without the checkbox, it is invite-only.",
  "dialog.newRoomNameLabel": "Name",
  "dialog.newRoomNamePlaceholder": "For example: Release 2.4",
  "dialog.newRoomTitle": "New room",
  "dialog.newSpaceTitle": "New space",
  "dialog.newTopic": "New topic",
  "dialog.noSettingsPermission": "You do not have permission to change {kind} settings.",
  "dialog.publicJoin": "Public (anyone can join)",
  "dialog.publicRoomDescription": "Visible in the server directory; any employee can join. Without the checkbox, it is invite-only.",
  "dialog.publicRoomHint": "A public room is visible in the server directory and anyone can join. Invite-only rooms can be joined only through an invitation from a member.",
  "dialog.publicRoomLabel": "Public room",
  "dialog.publicSpaceHint": "A public space is visible in the server directory and anyone can join. Invite-only spaces can be joined only through an invitation from a member.",
  "dialog.roomCreatedInHome": "The room will be created outside spaces (“Home”). You can invite any user to it.",
  "dialog.roomCreatedInSpace": "The room will be created in the space “{space}”.",
  "dialog.roomLeaveBlocked": "You cannot leave the space “{room}”. {reason}",
  "dialog.roomLeaveSpaceDescription": "You will leave the space “{room}”. Its rooms will disappear from your list, and you can return only with a new invitation.",
  "dialog.roomLeaveSpaceTitle": "Leave space?",
  "dialog.roomSettings": "Room settings: {room}",
  "dialog.roomTargetHome": "The room will be created outside spaces (“Home”). You can invite any user to it.",
  "dialog.roomTargetSpace": "The room will be created in the space “{space}”.",
  "dialog.selectedSpace": "selected space",
  "dialog.spaceCreatedInviteFailed": "Space created, but invitations failed: {users}",
  "dialog.spaceDescription": "A space brings rooms and people together. Space members see the space's public rooms and all its members; invite-only rooms remain hidden until a separate invitation.",
  "dialog.spaceInviteAction": "Invite to space…",
  "dialog.spaceLeaveAction": "Leave space…",
  "dialog.spaceMemberPlaceholder": "Name or @user:algsuccess.com",
  "dialog.spaceMembersAction": "Space members…",
  "dialog.spaceMembersLabel": "Members (optional)",
  "dialog.spaceNameLabel": "Name",
  "dialog.spaceSettingsTitle": "Space settings",
  "dialog.spaceTopicLabel": "Description (optional)",
  "dialog.spaceTopicPlaceholder": "What this space is about",
  "dialog.topicUnset": "(not set)",
  "dialog.understood": "Understood",
  "dialog.untitled": "(untitled)",
  "emoji.loadFailed": "Could not load the emoji list.",
  "emoji.loading": "Loading emoji…",
  "emoji.recent": "Recent",
  "emoji.search": "Search emoji",
  "error.backToChats": "Back to chats",
  "error.renderStopped": "The app encountered an error and stopped rendering this screen. Everything else is working — you can return to the chat list.",
  "error.somethingBroken": "Something went wrong",
  "matrix.authCallbackMissingFlow": "Got an OIDC callback but no flow context — start login again.",
  "matrix.authRefused": "MAS refused authorization: {error} — {description}",
  "matrix.authStateMismatch": "OIDC state mismatch — aborting login.",
  "matrix.errorAttachmentLink": "Could not open attachment: the server returned no link.",
  "matrix.errorAttachmentServer": "server responded {status}",
  "matrix.errorForbidden": "Insufficient permissions: {detail}",
  "matrix.errorNotFound": "Not found: {detail}",
  "matrix.errorRateLimit": "The server is rate-limiting requests. Try again in a minute.",
  "matrix.profileMissingUserId": "The client's user ID was not found",
  "matrix.sessionRejected": "Stored session rejected by the server: {error}",
  "media.download": "Download",
  "media.loading": "loading…",
  "media.next": "Next",
  "media.openInBrowser": "Open in browser",
  "media.previous": "Previous",
  "media.share": "Share",
  "member.admin": "Administrator",
  "member.ban": "Ban",
  "member.banAction": "Ban",
  "member.banned": "Banned · {count}",
  "member.bannedCount": "Banned · {count}",
  "member.changeRole": "Change role",
  "member.changeRoleAction": "Change role",
  "member.close": "✕",
  "member.count": "Members · {count}",
  "member.invite": "+ Invite",
  "member.invited": "Invited · {count}",
  "member.invitedCount": "Invited · {count}",
  "member.invitedUser": "invited · {user}",
  "member.justNow": "was just now",
  "member.kick": "Remove",
  "member.kickAction": "Remove",
  "member.lastActive": "was active {count} min ago",
  "member.lastActiveDays": "was active {count} days ago",
  "member.lastActiveHours": "was active {count} hours ago",
  "member.leaveSelfWarning": "You cannot leave the space: you are the last administrator.",
  "member.mismatch": "The server reports {serverCount} joined members, but {loaded} were loaded. Part of the room state has not loaded yet.",
  "member.moderator": "moderator",
  "member.notLoaded": "Member list not loaded.",
  "member.online": "online",
  "member.onlineStatus": "online",
  "member.participants": "Participants · {count}",
  "member.role": "Role",
  "member.roleAdministrator": "Administrator",
  "member.roleModerator": "Moderator",
  "member.roleParticipant": "Participant",
  "member.unban": "Unban",
  "member.unbanAction": "Unblock",
  "member.you": "you",
  "notification.allow": "Allow notifications",
  "notification.apiMissing": "Notification API is not available in this browser",
  "notification.browserRejected": "browser rejected the request",
  "notification.browserStatus": "Browser notifications: {status}.",
  "notification.deniedHint": "Notifications are blocked by the browser — the app cannot unblock them. In Safari, go to Settings → Websites → Notifications; in Chrome, go to Settings → Privacy → Site settings → Notifications.",
  "notification.mobileHint": "On iPhone/iPad, notifications are available only if the site is added to the Home Screen (Share → “Add to Home Screen”, iOS 16.4+). Call sounds and in-app banners work without this.",
  "notification.sent": "sent to browser",
  "notification.settingsTitle": "Notification settings",
  "notification.statusDefault": "not requested yet",
  "notification.statusDenied": "blocked by browser",
  "notification.statusGranted": "allowed",
  "notification.statusUnsupported": "not supported by this browser",
  "notification.test": "Show test notification",
  "notification.testBody": "Test notification. If you can see this, everything is working.",
  "profile.addDevice": "Add device",
  "profile.addDeviceCodeHint": "Enter this code on the new device:",
  "profile.allChats": "All chats",
  "profile.appearance": "Appearance",
  "profile.changePhoto": "Change photo",
  "profile.clickToRename": "Click to change the name",
  "profile.close": "Close",
  "profile.closeCabinet": "Close profile",
  "profile.codeValid": "Code valid for: {time}",
  "profile.deleteCurrentDeviceQuestion": "Delete this device and sign out. The app will ask you to sign in again. Continue?",
  "profile.deleteDeviceQuestion": "Delete device “{device}”? All sessions on it will end.",
  "profile.deviceActive": "active {date}",
  "profile.deviceCurrent": "this device",
  "profile.deviceNameLabel": "Device name",
  "profile.deviceNamePlaceholder": "For example: MacBook, phone",
  "profile.deviceSessions": "{count} sessions",
  "profile.devices": "Devices",
  "profile.devicesUnknownActivity": "activity unknown",
  "profile.displayName": "Display name",
  "profile.filesScopeHint": "Files and media from already loaded chats are shown, and search works across them. We do not yet have a complete server archive of all attachments — that is a separate server task.",
  "profile.filesSearchAria": "Search files and media",
  "profile.filesSearchPlaceholder": "Search by file name or caption",
  "profile.filesTab": "Files",
  "profile.finishLoginQuestion": "Finish signing in on “{device}”?",
  "profile.imageRequired": "An image is required (PNG, JPEG, etc.)",
  "profile.lightTheme": "Light",
  "profile.loadingDevices": "Loading devices…",
  "profile.logout": "Sign out",
  "profile.logoutConfirm": "Yes, sign out",
  "profile.logoutQuestion": "Sign out of this device?",
  "profile.mediaTab": "Media",
  "profile.multipleSessionsHint": "Multiple sessions from one device; if one is not yours, end it.",
  "profile.myFiles": "My files and media",
  "profile.newCode": "Get new code",
  "profile.noMedia": "There are no images or videos in the loaded chats.",
  "profile.noOtherFiles": "There are no files from others in the loaded chats.",
  "profile.noOwnFiles": "There are no files from you in the loaded chats.",
  "profile.noSearchResults": "Nothing found for this query. Search works across already loaded chats.",
  "profile.notifications": "Notifications",
  "profile.notificationsEnabled": "Notifications are enabled. Quiet rules (no sound for public rooms) apply automatically.",
  "profile.notificationsUnsupported": "This browser does not support notifications.",
  "profile.openOnNewDevice": "Open on the new device:",
  "profile.openPhoto": "Open photo full screen",
  "profile.permissionDenied": "blocked by browser",
  "profile.permissionGranted": "enabled",
  "profile.permissionNotAsked": "not requested",
  "profile.permissionUnsupported": "not supported",
  "profile.personalCabinet": "Profile",
  "profile.photo": "Profile photo",
  "profile.photoNotSet": "No photo set",
  "profile.renameDevice": "Rename this device",
  "profile.resetDeviceName": "Reset name",
  "profile.saving": "Saving…",
  "profile.searchResults": "{count} found",
  "profile.sharedFiles": "Shared files and media",
  "profile.switchServer": "switch",
  "profile.title": "Profile",
  "profile.uploadPhoto": "Uploading photo…",
  "room.acceptInviteMenu": "Accept invitation",
  "room.add": "Add",
  "room.attachmentBroken": "📎 {name} {size} — failed to load: {error}",
  "room.attachmentLoading": "📎 {name} — loading…",
  "room.callAlreadyIn": "You are already in a call",
  "room.callCamera": "Camera",
  "room.callConnecting": "Connecting…",
  "room.callDecline": "Decline call",
  "room.callIncoming": "Incoming call",
  "room.callLeave": "End call",
  "room.callMuted": "Microphone off",
  "room.callParticipants": "call in progress · {count} participants",
  "room.captionEnable": "Turn on captions",
  "room.captions": "Captions",
  "room.collapseList": "Collapse chat list",
  "room.expandList": "Expand chat list",
  "room.chatsCount": "Chats: {visible} of {joined}",
  "room.declineInviteMenu": "Decline invitation",
  "room.download": "Download",
  "room.emptyFavourites": "No favourite chats. Right-click a chat → “Add to favourites”.",
  "room.emptyOutsideSpaces": "Nothing here yet",
  "room.emptyPeople": "No private chats",
  "room.emptySearch": "Nothing found for “{query}”",
  "room.emptySpace": "This space has no rooms you have joined",
  "room.emptyUnread": "No unread chats",
  "room.encryptedBadge": "End-to-end encryption enabled",
  "room.encryptedNotice": "Messages in this room are encrypted (E2EE).\nThis client deliberately does not read them: encryption is disabled here. Sending is also unavailable — other clients will reject an unencrypted message in an encrypted room. Use Element for this room.",
  "room.encryptedPreview": "Encrypted message",
  "room.encryptionPageDisabled": "Encryption is off: the room is not encrypted, and E2EE support is deliberately disabled in this client. It cannot be enabled here.",
  "room.encryptionPageEnabled": "The room is encrypted (E2EE), but this client does not support encryption — it is disabled. Read this room in Element. Encryption cannot be enabled here.",
  "room.favourite": "favourite",
  "room.favouriteButton": "☆ Add to favourites",
  "room.favouriteMenu": "Add to favourites",
  "room.favouritedButton": "★ In favourites",
  "room.favouritesTab": "Favourites",
  "room.headerCallJoin": "Join call",
  "room.headerCallLeave": "Leave call",
  "room.headerCallStart": "Start call",
  "room.headerOpenPage": "Open room page",
  "room.headerVideoJoin": "Join call with video",
  "room.headerVideoStart": "Start video call",
  "room.historyError": "History did not finish loading: {error}",
  "room.historyLoading": "Loading history…",
  "room.homeLabel": "Home — chats outside spaces",
  "room.homeTab": "Home",
  "room.insufficientPermissions": "Insufficient permissions",
  "room.inviteMenu": "Invite member…",
  "room.inviteNotice": "This is an invitation. Select “Accept” in the header to join the room, or “Decline” to remove it from the list. Room contents are not shown before you join.",
  "room.inviteNoticeMore": "and {count} more",
  "room.invitePreview": "Room invitation",
  "room.invitesCount": "Invitations · {count}",
  "room.leaveMenu": "Leave room…",
  "room.loadOlder": "↑ scroll up to load history",
  "room.loadingChats": "Loading chats…",
  "room.loadingShort": "Loading…",
  "room.mediaFound": "{count} found",
  "room.memberCount": "{count} members · {roomId}",
  "room.members": "Members",
  "room.mentioned": "you were mentioned",
  "room.waitingChip": "Waiting for me",
  "room.emptyWaiting": "Nobody is waiting for you",
  "room.waitingChipAria": "Waiting for me: {count}",
  "room.mentionsTab": "Mentions",
  "room.messageLinkMiss": "The linked message is older than the loaded history. Scroll up to load more; it will appear then.",
  "room.newDm": "+ Private chat",
  "room.newRoom": "+ Room",
  "room.noMessagesPreview": "No messages",
  "room.noResults": "Nothing found for this query",
  "room.notificationSettings": "Notifications",
  "room.notificationsCurrent": "Notifications: {mode}",
  "room.notificationsMenu": "Notifications ▾",
  "room.notifyAll": "All messages",
  "room.notifyAllHint": "notify for every message",
  "room.notifyMentions": "Mentions only",
  "room.notifyMentionsHint": "stay quiet until mentioned",
  "room.notifyNone": "None",
  "room.notifyNoneHint": "quiet, including mentions",
  "room.openMembers": "Open member list",
  "room.openSettings": "Open room settings",
  "room.pageLabel": "Room page",
  "room.peopleTab": "People",
  "room.railAria": "Spaces",
  "room.receiptError": "Read receipt could not be sent: {error}",
  "room.removeFavourite": "Remove from favourites",
  "room.roomPage": "Room page",
  "room.roomSettings": "Room settings",
  "room.scanBusy": "checking…",
  "room.scanComplete": "Entire history viewed.",
  "room.scanCount": "Viewed {count} messages.",
  "room.scanDeeper": "search deeper",
  "room.searchAria": "Search chats",
  "room.searchPlaceholder": "Search",
  "room.sectionChats": "Chats",
  "room.sectionFavourites": "Favourites",
  "room.sidebarAria": "Chat list",
  "room.spaceCreate": "+ Space",
  "room.mobileCreateTitle": "Create",
  "room.mobileCreateRoom": "Room",
  "room.mobileCreateDm": "Private chat",
  "room.mobileCreateSpace": "Space",
  "room.spaceEmpty": "This space has no rooms you have joined",
  "room.spaceLeave": "Leave space",
  "room.spaceMembers": "Space members",
  "room.spaceRename": "Space settings",
  "room.tabFiles": "Files",
  "room.tabLinks": "Links",
  "room.tabMedia": "Media",
  "room.tabMembers": "Members",
  "room.tabVoice": "Voice messages",
  "room.unfavouriteMenu": "Remove from favourites",
  "room.unreadTab": "Unread",
  "room.you": "you",
  "space.admin": "admin",
  "space.invited": "invited",
  "space.membersNotFound": "Space not found in the loaded data. Refresh the page.",
  "space.partialRemoval": "Not removed everywhere. Remaining: {rooms}",
  "space.removeQuestion": "Remove {user} from the space?",
  "space.removeSummary": "They will leave the space and its {count} rooms. The rooms and chats remain in place — nothing is deleted. A room where there were two of you will remain with one member and its full history. You can invite the person back at any time.",
  "space.removed": "{user} removed from the space and its rooms ({count}).",
  "space.you": "you",
  "thread.loadOlder": "↑ scroll up to load history",
  "thread.noReplies": "No replies yet.",
  "thread.sendError": "Could not send reply: {error}",
  "thread.start": "thread beginning",
  "thread.title": "Thread",
  "timeline.attachmentFallback": "file",
  "timeline.attachmentNotLoaded": "not loaded",
  "timeline.audioOpen": "Open in viewer",
  "timeline.callActive": "Call in progress",
  "timeline.callDecline": "Decline",
  "timeline.callDuration": "Duration: {duration}",
  "timeline.callFinished": "Call ended",
  "timeline.callJoin": "Join",
  "timeline.callParticipantsCount": "Participants: {count}",
  "timeline.copyLink": "Copy link",
  "timeline.dayToday": "today",
  "timeline.dayYesterday": "yesterday",
  "timeline.delete": "Delete",
  "timeline.downloadFile": "Download file",
  "timeline.downloading": "Downloading…",
  "timeline.edit": "Edit",
  "timeline.emote": "* {user} {body}",
  "timeline.historyBeginning": "room beginning",
  "timeline.loadOlder": "↑ Load more",
  "timeline.noMessages": "No messages yet.",
  "timeline.openViewer": "Open in viewer",
  "timeline.reaction": "Reaction",
  "timeline.repliesFew": "{count} replies",
  "timeline.repliesMany": "{count} replies",
  "timeline.repliesOne": "{count} reply",
  "timeline.reply": "Reply",
  "timeline.senderMe": "You",
  "timeline.senderUnknown": "unknown",
  "timeline.share": "Share",
  "ui.zakryt_esc": "Close (Esc)",
  "ui.nuzhna_kartinka_png_jpeg_i_t_p": "An image is required (PNG, JPEG, etc.)",
  "ui.bez_imeni": "unnamed",
  "ui.limit_poka_ne_deystvuet_servernaya_chast": " The limit is not active yet: the server side is in progress.",
  "ui.ustroystvo_bez_imeni": "Unnamed device",
  "ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta": "Remove this device (sign out)",
  "ui.udalit_eto_ustroystvo": "Remove this device",
  "ui.udalit_ustroystvo": "Remove device",
  "ui.udalyayu": "Removing…",
  "ui.da_zavershit": "Yes, end it",
  "ui.ustroystvo": "device",
  "ui.zavershit_etot_vhod": "End this session",
  "ui.filtr_po_chatu": "Filter by chat",
  "ui.gotovlyu_fayl": "Preparing file…",
  "ui.vas_ni_v_ch_m_ne_upominali": "You haven’t been mentioned",
  "ui.home_chaty_vne_prostranstv": "Home — chats outside spaces",
  "ui.sozdat_prostranstvo": "Create space",
  "ui.v_istorii_komnaty_ne_naydeno_kartinok_i": "No images or videos found in room history",
  "ui.my_prosmotreli_tolko_chast_istorii_nazhm": "We viewed only part of the history — click “search deeper” below.",
  "ui.kb": "KB",
  "ui.mb": "MB",
  "ui.gb": "GB",
  "ui.v_istorii_komnaty_ne_naydeno_faylov": "No files found in room history",
  "ui.v_istorii_komnaty_ne_naydeno_ssylok": "No links found in room history",
  "ui.v_istorii_komnaty_ne_naydeno_golosovyh": "No voice messages found in room history",
  "ui.etot_brauzer_ne_dal_pereklyuchit_dinamik": "This browser couldn’t switch the speaker. Sound stayed on the previous device.",
  "ui.ne_udalos_pereklyuchit_ustroystvo_ostalo": "Couldn’t switch device — the previous one remains.",
  "ui.mikrofon": "microphone",
  "ui.kameru": "camera",
  "ui.dinamik": "speaker",
  "ui.vybrannoe_ranee": "previously selected",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne": "Calls in encrypted rooms aren’t supported yet. ",
  "ui.sozdayte_obychnuyu_komnatu_ili_dozhdites_o": "Create a regular room or wait for an update.",
  "ui.mikrofon_ne_dal_audiodorozhku": "Microphone provided no audio track",
  "ui.kamera_ne_dala_videodorozhku": "Camera provided no video track",
  "ui.jwt_servis_v_otvete_net_url_jwt": "JWT service: response has no url/jwt",
  "ui.brauzer_ne_dal_videodorozhku_ekrana": "Browser provided no screen video track",
  "ui.ekran_vy": "Screen: You",
  "ui.demonstraciya_ekrana_ne_nachalas_dostup_n": "Screen sharing didn’t start: access not granted",
  "ui.brauzer_ne_umeet_zapisyvat_opus": "Browser can’t record opus",
  "ui.slishkom_korotko": "Too short",
  "ui.golosovoe_dlinnee_5_minut": "Voice message longer than 5 minutes",
  "ui.dostup_k_mikrofonu_zapresch_n": "Microphone access denied",
  "ui.priglash_n_no_esch_ne_vosh_l_uvedomlenie_pri": "Invited but hasn't joined yet — the notification will arrive after they join",
  "ui.redaktiruyte_soobschenie": "Edit message…",
  "ui.otvet": "Reply…",
  "ui.soobschenie_upomyanut_enter_otpravit": "Message… (@ — mention, Enter — send)",
  "ui.otpravit_fayl": "Send file",
  "ui.uchastniki_komnaty": "Room members",
  "ui.isklyuchit_iz_komnaty": "Remove from room",
  "ui.zabanit": "Ban",
  "ui.izmenit_prava": "Change permissions",
  "ui.prichina_neobyazatelno_vidna_drugim_uchast": "Reason (optional, visible to other members)",
  "ui.naprimer_flud": "For example: flooding",
  "ui.naprimer_spam": "For example: spam",
  "ui.snyat_ban": "Unban?",
  "ui.net_userid_klienta": "no client userId",
  "ui.ustroystvo_2": "Device",
  "ui.yandeks_brauzer": "Yandex Browser",
  "ui.brauzer": "browser",
  "ui.net_access_token": "no access token",
  "ui.net_client_id_sessiya_ne_oidc": "no client_id — session is not OIDC",
  "ui.net_device_id": "no device_id",
  "ui.mas_graphql_endpoint_ne_obyavlen": "MAS GraphQL endpoint not declared",
  "ui.device_authorization_endpoint_ne_obyavle": "Device authorization endpoint not declared",
  "ui.token_endpoint_ne_obyavlen": "Token endpoint not declared",
  "ui.polzovatel_otklonil_avtorizaciyu": "User declined authorization",
  "ui.kod_ist_k": "Code expired",
  "ui.vremya_ozhidaniya_isteklo": "Timed out",
  "ui.id_t_demonstraciya_vashego_ekrana": "You are sharing your screen",
  "ui.vernutsya_v_zvonok": "Return to call",
  "ui.vyklyuchit_mikrofon": "Mute microphone",
  "ui.vklyuchit_mikrofon": "Unmute microphone",
  "ui.vyklyuchit_kameru": "Turn off camera",
  "ui.vklyuchit_kameru": "Turn on camera",
  "ui.otmenit_zvonok": "Cancel call",
  "ui.brauzer_otklonil_pokaz_onerror": "browser rejected display (onerror)",
  "ui.api_otsutstvuet": " · API unavailable",
  "ui.uchastnik": "participant",
  "ui.uchastnikov": "participants",
  "ui.bez_administratora_prostranstvom_nelzya": "Without an administrator, the space can’t be managed: you can’t invite, ",
  "ui.ni_dobavit_komnatu_ni_izmenit_nastroyk": "add a room, or change settings. First appoint another ",
  "ui.administratora_ili_udalite_ostalnyh_ucha": "administrator or remove the other members.",
  "ui.izmenenie_sobstvennogo_urovnya_prav_zdes": "Changing your own permission level is not allowed here",
  "ui.net_eventid_u_redaktiruemogo_soobscheniya": "edited message has no eventId",
  "ui.net_eventid_dlya_redact": "no eventId for redact",
  "ui.otklonit_zvonok_zvonyaschiy_uznaet_ob_otka": "Decline call — the caller will know it was declined",
  "ui.staree": "Older (←)",
  "ui.novee": "Newer (→)",
  "ui.udaleno_ne_vezde_ostalos": "Not deleted everywhere. Remaining: ",
  "ui.komnaty": "chats",
  "ui.komnat": "rooms",
  "ui.ne_udalos_postroit_ssylku_iz_mxc": "couldn’t build link from mxc://",
  "ui.nedostatochno_prav_dlya_otpravki_soobscheniy": "You don't have permission to send messages in this chat",
  "ui.redaktiruemoe_soobschenie_ne_naydeno_v_len": "The message being edited wasn't found in the timeline",
  "ui.soobschenie_na_kotoroe_vy_otvechaete_ne_nay": "The message you're replying to wasn't found in the timeline",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne_2": "Calls in encrypted chats aren't supported yet",
  "ui.vybrat_mikrofon_i_dinamik": "Select microphone and speaker",
  "ui.zaprashivaem_dostup_k_kamere": "Requesting camera access…",
  "ui.vklyuchit_kameru_zaprosim_dostup": "Turn on camera (we'll request access)",
  "ui.vybrat_kameru": "Select camera",
  "ui.demonstraciya_ekrana_nedostupna_v_etom_br": "Screen sharing isn't available in this browser",
  "ui.vybiraem_okno_ili_ekran": "Select a window or screen…",
  "ui.ostanovit_demonstraciyu_ekrana": "Stop screen sharing",
  "ui.demonstraciya_ekrana": "Screen sharing",
  "ui.svernut_zvonok_v_okoshko_chtoby_pisat_v": "Minimize the call to a window — to chat in this room",
  "ui.uchastnika": "participants",
  "ui.podklyuchaemsya_k_zvonku": "Joining call…",
  "ui.id_t_zvonok_zhd_m_otveta": "Calling, waiting for an answer",
  "ui.otkazatsya_ot_zvonka_zvonyaschiy_uznaet_ob": "Decline the call — the caller will know you declined",
  "ui.otkazatsya_ot_zvonka": "Decline call",
  "ui.otmenit_podklyuchenie": "Cancel connection",
  "ui.udalit_soobschenie": "Delete message?",
  "ui.nedostatochno_prav_dlya_udaleniya_etogo_soo": "You don't have permission to delete this message.",
  "ui.soobschenie_ne_naydeno": "Message not found",
  "ui.udalit_svo_soobschenie": "Delete your message?",
  "ui.udalit_soobschenie_moderatorom": "Delete message as moderator?",
  "ui.soobschenie_ne_naydeno_v_lente": "Message not found in the timeline.",
  "ui.komnata_budet_sozdana_vne_prostranstv_do": "The chat will be created outside spaces (\"Home\"). Anyone can be invited.",
  "ui.pustoe_imya_polzovatelya_do_dvoetochiya": "Username before the colon is empty",
  "ui.pokazany_uchastniki_vybrannogo_prostranst": "Showing members of the selected space. To see everyone, switch to \"Home\" in the rail on the left.",
  "ui.naprimer_otdel_prodazh": "For example: Sales team",
  "ui.perenesti": "Move",
  "ui.seychas_komnata_vne_prostranstv_dom": "This chat is currently outside spaces (\"Home\").",
  "ui.podskazyvat_nekogo_vse_kogo_vy_znaete_p": "No one to suggest: everyone you know from your spaces is already here. Enter a full ID such as @username:algsuccess.com.",
  "ui.zagruzka": "Loading…",
  "ui.zagruzit_avatar_komnaty": "Upload chat avatar",
  "ui.vidna_vsem_dazhe_bez_vhoda": "visible to everyone, even without joining",
  "ui.s_momenta_vhoda_uchastnika": "since the member joined",
  "ui.s_momenta_priglasheniya": "since the invitation",
  "ui.tolko_s_momenta_vhoda": "only since joining",
  "ui.tema": "Topic",
  "ui.avatar": "Avatar",
  "ui.publichnaya": "public",
  "ui.po_priglasheniyu": "invite-only",
  "ui.pisat_soobscheniya": "Send messages",
  "ui.priglashat_uchastnikov": "Invite members",
  "ui.udalyat_chuzhie_soobscheniya": "Delete others' messages",
  "ui.menyat_nastroyki_i_roli": "Change settings and roles",
  "ui.uchastniki": "members",
  "ui.moderatory": "moderators",
  "ui.adminy": "admins",
  "ui.nedostatochno_prav_dlya_izmeneniya": "You don't have permission to change this",
  "ui.menyat_prava_roley_mozhet_tolko_tot_u_ko": "Only someone with sufficient permissions can change role permissions (m.room.power_levels threshold). You don't have them — values are shown for reference.",
  "ui.otvetov": "replies",
  "ui.otvet_2": "reply",
  "ui.otveta": "replies",
  "ui.history_avtodogruzka_ostanovlena_8_stra": "[history] automatic loading stopped: 8 pages with no progress",
  "ui.naverhu_stranica_ne_dala_vidimyh_soobschen": "at the top, the page returned no visible messages",
  "ui.soobschenie_ne_zagruzheno": "Message not loaded",
  "ui.menshe_minuty": "less than a minute",
  "ui.snyat_reakciyu": "Remove reaction",
  "ui.drugoy_emodzi": "Other emoji",
  "ui.otvetit_v_trede": "Reply in thread",
  "ui.kopirovat_tekst": "Copy text",
  "ui.prostranstva": "spaces",
  "ui.prostranstvo": "space",
  "ui.komnatu": "chat",
  "ui.publichnoe_prostranstvo_vidno_v_kataloge": "A public space appears in the server directory and any employee can join. Invite-only means joining requires an invitation from a member.",
  "ui.publichnaya_komnata_vidna_v_kataloge_serve": "A public chat appears in the server directory and any employee can join. Invite-only means joining requires an invitation from a member.",
  "ui.etogo_prostranstva": "this space",
  "ui.etoy_komnaty": "this chat",
  "ui.zagruzit": "Upload",
  "ui.zakryt_tred": "Close thread",
  "ui.otvetit_v_tred_upomyanut_enter_otpravit": "Reply in thread… (@ — mention, Enter — send)",
  "ui.perenesti_v_prostranstvo": "Move to space…",
  "ui.nastroyki_komnaty": "Chat settings…",
  "profile.language": "Language",
  "profile.files": "My files",
  "profile.server": "Server",
  "profile.serverChange": "change",
  "theme.system": "System",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "ui.b": "B",
  "rtc.deviceDefault": "Default",
  "rtc.micLabel": "Microphone",
  "rtc.cameraLabel": "Camera",
  "rtc.speakerLabel": "Speaker",
  "rtc.micWord": "microphone",
  "rtc.cameraWord": "camera",
  "rtc.speakerWord": "speaker",
  "rtc.previouslyChosen": "previously selected",
  "rtc.speakerSwitchFailed": "This browser did not allow switching the speaker. Audio stayed on the previous one.",
  "rtc.deviceSwitchFailed": "Could not switch the device — the previous one is still in use.",
  "rtc.encryptedNotSupported1": "Calls in encrypted rooms are not supported yet. ",
  "rtc.encryptedNotSupported2": "Create a regular room or wait for an update.",
  "rtc.you": "You",
  "rtc.screenYou": "Screen: You",
  "rtc.micMuted": "Microphone off",
  "rtc.cameraOff": "Camera off",
  "rtc.screenShareDenied": "Screen sharing did not start: access denied",
  "device.generic": "Device",
  "device.yandexBrowser": "Yandex Browser",
  "device.browserWord": "browser",
  "file.generic": "file",
  "error.rateLimited": "The server is rate limiting requests. Try again in a minute.",
  "space.memberSingular": "member",
  "space.memberPlural": "members",
  "space.lastAdminWarn1": "Without an admin the space cannot be managed: no invites, ",
  "space.lastAdminWarn2": "no adding rooms, no changing settings. Appoint another ",
  "space.lastAdminWarn3": "admin first, or remove the remaining members.",
  "common.unknown": "unknown",
  "message.encrypted": "Encrypted message",
  "message.youPrefix": "You",
  "room.inviteToRoom": "Room invitation",
  "message.deleted": "message deleted",
  "message.wasDeleted": "Message was deleted",
  "message.attachment": "attachment",
  "emoji.searchPlaceholder": "Search (in English: heart, cat, fire)",
  "server.current": " · current",
  "space.settingsMenu": "Space settings…",
  "file.noName": "unnamed",
  "error.noUserId": "No client user ID",
  "error.noAccessToken": "No access token",
  "error.noClientIdNotOidc": "No client_id — the session is not OIDC",
  "error.noDeviceId": "No device_id",
  "error.masEndpointMissing": "MAS GraphQL endpoint is not declared",
  "error.deviceAuthEndpointMissing": "Device authorization endpoint is not declared",
  "error.tokenEndpointMissing": "Token endpoint is not declared",
  "error.authDeclined": "Authorization was declined",
  "error.codeExpired": "The code has expired",
  "error.waitTimeout": "The wait timed out",
  "error.micNoTrack": "The microphone returned no audio track",
  "error.cameraNoTrack": "The camera returned no video track",
  "error.jwtNoUrl": "JWT service: the response has no url/jwt",
  "error.screenNoTrack": "The browser returned no screen video track",
  "error.ownPowerLevel": "Changing your own permission level is not allowed here",
  "error.noEventIdEdit": "The edited message has no event ID",
  "error.noEventIdRedact": "No event ID to redact",
  "error.mxcLinkFailed": "Could not build a link from mxc://",
  "error.providerMissing": "MatrixClientProvider is missing higher up the tree",
  "emoji.groupSmileys": "Smileys & Emotion",
  "emoji.groupPeople": "People",
  "emoji.groupNature": "Animals & Nature",
  "emoji.groupFood": "Food & Drink",
  "emoji.groupTravel": "Travel & Places",
  "emoji.groupActivities": "Activities",
  "emoji.groupObjects": "Objects",
  "emoji.groupSymbols": "Symbols",
  "emoji.groupFlags": "Flags",
  "server.hintMain": "ALG production server",
  "server.hintStage": "test server, data can be broken",
  "error.serverAddressRequired": "Enter the server address",
  "error.serverAddressInvalid": "The server address looks invalid",
  "error.serverAddressHttps": "The address must start with https://",
  "call.ringDiagStarting": "call: trying to start sound…",
  "notification.newMessage": "New message",
  "app.roomUnavailable": "Room unavailable",
  "app.roomUnavailableBody": "You are not in this room (or the link has a typo). Ask a member to invite you — once invited, the link will open on its own.",
  "room.linkMenu": "Room link…",
  "roomLink.title": "Link to “{room}”",
  "roomLink.hint": "Send this link to invite people to the room. It opens the room in our messenger.",
  "roomLink.fieldLabel": "Link",
  "roomLink.copy": "Copy",
  "roomLink.share": "Share",
  "roomLink.copied": "Link copied",
  "roomLink.copyFailed": "Could not copy — select the link and copy it manually",
  "roomLink.closedHint": "This room is invite-only: the link lets in people who are already invited. Everyone else will be asked to request an invite.",
  "roomLink.openHint": "This room is public: any user of the server can join via the link.",
  "roomLink.restrictedHint": "Members of the room's space can join via the link.",
  "roomLink.knockHint": "People may ask to join this room, but this client does not send join requests yet: without an invite the link will not let them in.",
  "roomGate.title": "Room from a link",
  "roomGate.loading": "Checking the room…",
  "roomGate.join": "Join room",
  "roomGate.joining": "Joining…",
  "roomGate.members": "Members: {count}",
  "roomGate.closedTitle": "This room is private — ask for an invite",
  "roomGate.closedBody": "You cannot join via the link: this room is invite-only. Ask a member to invite you — once invited, the link will open on its own.",
  "roomGate.knockBody": "You may ask to join this room, but sending join requests from this client is not enabled yet. Ask a member to invite you.",
  "roomGate.notFound": "No room was found for this link. Check the link.",
  "app.clickToOpen": "Click to open",
  "app.goBack": "Go back",
  "composer.releaseToSend": "Release to send",
  "composer.photoVideo": "Photo/video",
  "composer.file": "File",
  "composer.voiceMessage": "Voice message",
  "composer.toRoom": "To room:",
  "common.secShort": "s",
  "emoji.nothingFound": "Nothing found",
  "error.boundaryBody": "The app hit an error and stopped rendering this screen. The rest still works — you can go back.",
  "media.fileDownloaded": "File downloaded.",
  "media.shareFallbackDownloaded": "Sharing is unavailable here, so the file was downloaded instead.",
  "member.youSuffix": "· you",
  "member.banCannotReturn": "will not be able to join again",
  "member.banCannotReturnTail": ", even with a new invitation, until the ban is lifted manually (the ban list is at the bottom of the members panel).",
  "member.kickNoAutoReturn": "will not return to the room automatically",
  "member.kickNoAutoReturnTail": ": they need to join again or be invited once more.",
  "member.roleExplain": "The role defines what a member can do in the room: post, invite, moderate, change settings. A promotion takes effect immediately for all clients.",
  "member.powerLevel": "Permission level",
  "member.stateNotLoaded": ". Part of the room state has not loaded yet.",
  "member.kickWarnBody": "will be removed from the room and can return with a new invitation (or on their own, if the room is public).",
  "member.unbanWarn": "will be unbanned, but",
  "notification.iosHint": "On iPhone/iPad notifications work only if the site is added to the home screen (Share → Add to Home Screen).",
  "notification.blockedHint": "Notifications are blocked by the browser itself — the app cannot lift that. In Safari: Settings → Websites → Notifications.",
  "notification.showNew": "Show notifications about new messages",
  "notification.soundNew": "Sound for a new message",
  "notification.ringOnCall": "Ring on an incoming call",
  "profile.deviceCodeHint": "A code will appear: enter it on the new device to confirm its sign-in to this account.",
  "profile.multiSessionHint": "Several sign-ins from one device; if one of them is not yours, end it.",
  "profile.thisDeviceSuffix": "· this device",
  "profile.clientUnknown": "client unknown — the server does not report it",
  "profile.generatingCode": "Generating a code…",
  "profile.notificationsOnHint": "Notifications are on. Quiet rules (an open room stays silent) apply automatically.",
  "profile.notYouHint": ". If this is not you, open device management and end the other session.",
  "profile.deviceLimitHint": "th device will require administrator approval. The limit is not active yet: the server side is still in progress.",
  "profile.sessionsWord": "sessions",
  "profile.permissionRetryHint": "). The button below asks the browser again; if it answers “denied”, only browser settings can change it.",
  "dialog.cannotLeaveSpace": "You cannot leave the space",
  "dialog.youWillLeaveSpace": "You will leave the space",
  "dialog.leaveSpaceTail": ". Its rooms will disappear from your list, and returning will require a new invitation.",
  "dialog.youWillLeaveRoom": "You will leave the room",
  "dialog.leaveRoomTail": ". The history stays on the server but will not be available to you. Returning to a private room requires a new invitation.",
  "dialog.invitationTo": "Invitation to",
  "dialog.inviteDeclineTail": "will be declined. If you are invited again, the room will reappear.",
  "dialog.spaceExplain": "A space groups rooms and people together. A space member sees the open rooms of that space.",
  "dialog.noSpacesToMove": "Nowhere to move: there are no spaces where you can manage the contents (m.space.child). Ask a space administrator to move it or to raise your permission level.",
  "dialog.outsideSpacesHome": "— Outside spaces (Home) —",
  "dialog.inviteSpaceHint": "The invitee will see the open rooms of the space and all its members. Invite-only rooms stay hidden.",
  "room.encryptionWord": "Encryption",
  "room.encNotSupportedOff": "not supported — turned off",
  "room.encReadInElement": ". You can read such a room in Element. Encryption cannot be enabled here.",
  "room.offWord": "off",
  "room.encDisabledTail": ": the room is not encrypted, and E2EE support is intentionally disabled in this client. It cannot be enabled here.",
  "room.changeSettings": "Change settings…",
  "room.noRightsSettings": "You do not have rights to change these settings — they are shown for reference. Contact a room administrator.",
  "room.noRights": "no rights",
  "room.rolePermissions": "Role permissions",
  "room.advancedSettings": "Advanced settings",
  "room.settingsSubtitle": "Room settings, role permissions, encryption",
  "room.loadingHistory": "Loading history…",
  "room.publicWord": "Public",
  "room.historyShared": "From the moment of joining (shared)",
  "room.historyJoined": "Only from the moment of joining (joined)",
  "room.historyExplain": "“From the moment of joining” — a new member sees history from their join. “Only from the moment of joining” is stricter: even an invitation does not reveal the past.",
  "room.thisIsWord": "This is",
  "room.invitationWord": "an invitation",
  "room.inviteHintTail": ". Press “Accept” in the header to join the room, or “Decline” to remove it from the list. The room contents are not shown before you join.",
  "room.encryptedNoticeTail": "This client intentionally does not read them: encryption is disabled here. Sending is unavailable too — other clients reject an unencrypted message in an encrypted room. Use Element for this room.",
  "room.callInProgress": "Call in progress",
  "room.callConnectFailed": "Could not connect to the call.",
  "common.tryAgain": "Try again",
  "room.moderatorDeleteNotice": "You are deleting someone else's message as a moderator. Other members will see that the message was deleted.",
  "room.noVideoYet": "· nobody turned on video",
  "server.pickerHint": "The app will connect to the selected server. Session and devices are stored separately per server.",
  "space.fromSpaceQuestion": "from the space?",
  "space.itIsYou": "— that's you",
  "space.adminSuffix": "· admin",
  "space.noMembersYet": "The space has no members besides you yet.",
  "space.removeMemberTail": ". Rooms and conversations stay in place — nothing is deleted. A room where there were two of you keeps one member and the full history. You can invite the person back at any time.",
  "space.invitedSuffix": "· invited",
  "message.editedMark": "(edited)",
  "message.sendingMark": "· sending…",
  "message.notSentMark": "· not sent",
  "timeline.loadingPreview": "Loading preview…",
  "timeline.callOngoing": "Call ongoing",
  "timeline.loadingTail": "— loading…",
  "member.kickShort": "Kick",
  "member.banShort": "Ban",
  "notification.permissionNotGranted": "Permission not granted",
  "member.banStricterHead": "A ban is stricter than a kick:",
  "profile.deviceLimitHead": "When adding the",
  "room.membersCountOne": "member",
  "room.membersCountFew": "members",
  "room.membersCountMany": "members",
  "profile.deviceLabelWeb": "{machine} · {client} (web)",
  "profile.deviceDeleteUnexpectedStatus": "Unexpected deletion status: {status}",
  "matrix.errorUserNotFoundOnServer": "User {user} was not found on their home server",
  "matrix.errorServerUnreachable": "Cannot reach the server: {detail}. Check the domain.",
  "space.lastAdminHead": "You are the only administrator, and the space still has {count} ",
  "timeline.inReplyTo": "In reply to",
  "rtc.deviceDisconnectedFallback": "{device} “{name}” was disconnected — switched to the default device.",
  "rtc.speakerRestored": "Speaker “{name}” is available again — call audio is back on it.",
  "rtc.callMembershipFailed": "Call membership was not recorded in the room: {error}. Other participants will not see you. Try leaving the call and joining again.",
  "rtc.screenOf": "Screen: {name}",
  "error.jwtHttp": "JWT service: HTTP {status}",
  "space.notInRoomSpace": "{user} is not a member of this room's space. Ask an administrator to add them to the space first — only then can they be invited to rooms and calls.",
  "timeline.roomNameChanged": "{actor} changed the room name to “{name}”",
  "timeline.roomNameRemoved": "{actor} removed the room name",
  "timeline.roomTopicChanged": "{actor} changed the room topic",
  "timeline.roomTopicRemoved": "{actor} removed the room topic",
  "timeline.roomAvatarChanged": "{actor} changed the room avatar",
  "timeline.roomAvatarRemoved": "{actor} removed the room avatar",
  "timeline.memberInvited": "{actor} invited {subject} to the room",
  "timeline.memberRenamed": "{oldName} is now {newName}",
  "timeline.memberAvatarChanged": "{subject} changed their avatar",
  "timeline.memberJoined": "{subject} joined the room",
  "timeline.memberUnbanned": "{actor} unbanned {subject}",
  "timeline.memberLeft": "{subject} left the room",
  "timeline.memberKicked": "{actor} removed {subject} from the room{reason}",
  "timeline.memberBanned": "{actor} banned {subject}{reason}",
  "timeline.summaryJoined": "{names} joined the room",
  "timeline.summaryInvited": "{names} were invited to the room",
  "timeline.summaryLeft": "{names} left the room",
  "timeline.summaryKicked": "{names} were removed from the room",
  "timeline.summaryBanned": "{names} were banned",
  "timeline.summaryUnbanned": "{names} were unbanned",
  "timeline.namesTwo": "{first} and {second}",
  "timeline.namesThree": "{first}, {second} and {third}",
  "timeline.namesMoreOne": "{first}, {second} and {count} other participant",
  "timeline.namesMoreFew": "{first}, {second} and {count} other participants",
  "timeline.namesMoreMany": "{first}, {second} and {count} other participants",
  "profile.titleWithName": "Profile — {name}",
  "common.sizeBytes": "{size} B",
  "common.sizeKb": "{size} KB",
  "common.sizeMb": "{size} MB",
  "space.membersTitle": "Members: {space}",
  "timeline.readUpToHere": "{name} has read up to here",
  "timeline.attachmentDownload": "{info} · download",
  "timeline.threadLastSender": " · last: {name}",
  "timeline.durationMinutes": "{minutes} min",
  "timeline.durationHours": "{hours} h",
  "timeline.durationHoursMinutes": "{hours} h {minutes} min",
  "timeline.addReaction": "React with {emoji}",
  "timeline.openThreadCount": "Open thread · {count}",
  "call.ringBlocked": "sound blocked by the browser: {prefix}",
  "call.ringStarted": "sound started ({prefix})",
  "room.inviteAcceptFailed": "Could not accept the invitation to “{room}”: {error}",
  "call.ongoingVideoInRoom": "📹 Video call in progress · {room}",
  "call.ongoingAudioInRoom": "📞 Call in progress · {room}",
  "call.incomingVideoFrom": "Incoming video call: {callers}",
  "call.incomingAudioFrom": "Incoming call: {callers}",
  "call.roomOngoingParticipants": "{room} · call in progress · {participants}",
  "media.downloadNamed": "Download {name}",
  "profile.fileFrom": "from {user}",
  "profile.loadFailed": "Could not load: {error}",
  "dialog.domainLooksTruncated": "The domain “{host}” looks truncated",
  "dialog.removeEntry": "Remove {id}",
  "room.yourPowerLevel": "Your permission level: {level}. The server will not accept a threshold above your own level.",
  "call.declinedBy": "{name} declined the call",
  "call.inCallOne": "You are in the call · {count} participant",
  "call.inCallFew": "You are in the call · {count} participants",
  "call.inCallMany": "You are in the call · {count} participants",
  "member.actionsFor": "Actions: {name}",
  "member.kickQuestion": "Remove {name}?",
  "member.banQuestion": "Ban {name}?",
  "member.roleFor": "Role: {name}",
  "notification.cannotShowPermission": "cannot show: permission={permission}",
  "notification.showError": "display error: {error}",
  "profile.photoOf": "Photo: {name}",
  "profile.deviceAdded": "added {date}",
  "profile.renameDeviceNamed": "Rename {device}",
  "profile.endSessionNamed": "End the session on {device}",
  "composer.micEnableFailed": "Could not turn on the microphone: {error}",
  "space.notInAnySpace": "{user} is not a member of any of your spaces. A private chat is possible only within a shared space — an administrator has to add them there first.",
  "dialog.noSettingsPermissionRoom": "You do not have permission to change this room's settings.",
  "dialog.noSettingsPermissionSpace": "You do not have permission to change this space's settings.",
  "dialog.spaceSettings": "Space settings: {space}",
  "profile.masSessionNotFound": "No active session for device {deviceId} was found in MAS — it may already be ended. Refresh the list; if the device is still there, try deleting again.",
  "rtc.deviceSwitchError": "Could not switch the {device}: {error}",
  "profile.newDeviceOne": "A new device has appeared since your last visit: {devices}",
  "profile.newDeviceMany": "New devices have appeared since your last visit ({count}): {devices}",
  "profile.deviceCount": "Devices: {count} of {limit}.",
  "room.levelValue": "level {level}",
  "thread.historyError": "The thread history did not finish loading: {error}",
  "thread.replyNotSent": "The reply was not sent: {error}",
  "call.ringingWaitAnswer": "Calling, waiting for an answer…",
  "call.noAnswerCountdown": "Nobody answered · the call will end in 0:{seconds}",
  "call.waitingCountdown": "Waiting for an answer · will end in 0:{seconds}",
  "call.cameraFailed": "The camera did not turn on: {error}",
  "call.screenShareFailed": "Screen sharing did not start: {error}",
  "call.roomCallWithCount": "A call is in progress in this room · {count} {word}",
  "space.leaveRoomsOne": "They will leave the space and {count} room inside it",
  "space.leaveRoomsFew": "They will leave the space and {count} rooms inside it",
  "space.leaveRoomsMany": "They will leave the space and {count} rooms inside it",
  "app.invitedBy": "Invited by: {user}",
  "composer.voiceRecordingSeconds": "Recording a voice message… {seconds} s",
  "media.slideBroken": "{icon} {name} — failed to load",
  "media.slideBrokenError": "{icon} {name} — failed to load: {error}",
  "room.attachmentBrokenNoError": "📎 {name} {size} — failed to load",
  "composer.deleteRecording": "Delete recording",
  "composer.recordingDuration": "Duration: {seconds} sec.",
  "composer.stopRecording": "Stop recording",
  "composer.formattingToolbar": "Text formatting",
  "composer.bold": "Bold",
  "composer.italic": "Italic",
  "composer.underline": "Underline",
  "composer.strikethrough": "Strikethrough",
  "composer.textColorRed": "Text color: red",
  "composer.textColorOrange": "Text color: orange",
  "composer.textColorGreen": "Text color: green",
  "composer.textColorBlue": "Text color: blue",
  "composer.textColorPurple": "Text color: purple",
  "notification.messageSoundLabel": "Message sound",
  "notification.callSoundLabel": "Call sound",
  "notification.previewSound": "Preview",
  "notification.roomModeLabel": "Notification mode",
  "notification.roomSoundLabel": "Sound for this chat",
  "notification.soundDefault": "Default",
  "notification.soundSoft": "Soft",
  "notification.soundDouble": "Double tone",
  "notification.soundChime": "Chime",
  "fontSize.default": "Default",
  "fontSize.label": "Text size",
  "fontSize.large": "Large",
  "fontSize.small": "Small",
  "notification.acceptedUnverified": "The app accepted the request, but system display was not confirmed",
  "notification.appDisabled": "System notifications are disabled in the app",
  "notification.appEnabled": "System notifications are enabled in the app",
  "notification.categoriesTitle": "Notification types",
  "notification.categoryCalls": "Incoming calls",
  "notification.categoryDirect": "Direct messages",
  "notification.categoryGroup": "Group messages",
  "notification.categoryInvites": "Room and space invites",
  "notification.categoryMentions": "Mentions and @room",
  "notification.categoryReactions": "Reactions to my messages",
  "notification.categoryReplies": "Replies and threads",
  "notification.createdVerified": "The system notification was created by the app",
  "push.disable": "Disable",
  "push.disabled": "Not enabled for this device",
  "push.enable": "Enable background notifications",
  "push.enabled": "Works even when the app is closed",
  "push.notReady": "The background notification service is not ready yet",
  "push.test": "Test background notification",
  "push.testSent": "Background notification sent",
  "push.title": "Background notifications",
  "push.working": "Please wait…",
  "room.groupsTab": "Groups",
  "room.emptyGroups": "No group chats",
  "chat.private": "Private chat",
  "chat.filterLabel": "Filter: {value}",
  "chat.filterChats": "Filter chats",
  "chat.filters": "Chat filters",
  "chat.clearFilter": "Clear filter",
  "chat.messagePrivately": "Message privately",
  "profile.view": "View profile",
  "chat.jumpToLatest": "Jump to latest message",
  "chat.jumpToMention": "Jump to mention",
  "settings.language": "Language",
  "server.main": "Main",
  "server.stage": "Stage",
  "server.matrixPlaceholder": "matrix.example.com",
  "notification.background": "Background notifications",
  "notification.notEnabledForDevice": "Not enabled for this device",
  "notification.enableBackground": "Enable background notifications",
  "notification.unsupportedRuntime": "Background notifications are not supported by this app runtime.",
  "typing.one": "{name} is typing",
  "typing.two": "{a} and {b} are typing",
  "typing.more": "{a}, {b} and {count} more are typing",
  "matrix.errorNetwork": "No connection to the server. Check your network and try again.",
  "picker.busy": "The previous upload is still running, please wait.",
  "picker.cancelled": "No file selected.",
  "picker.chosen": "File “{name}” selected, uploading…",
  "picker.done": "Done, the image is uploaded.",
  "picker.failed": "Upload failed: {error}",
  "picker.shellFailed": "The app could not get the file. Please try again.",
  "picker.shellTooLarge": "The file “{name}” is too large: {size}, the limit is {limit}.",
  "picker.noDialog": "The click went through, but the system did not open the file window. Please report this line to support.",
  "picker.noInput": "The file field is not ready. Please reopen the screen.",
  "picker.opening": "Opening the file picker…",
  "search.error": "Message search failed: {error}",
  "search.loadingMore": "Loading more…",
  "search.messagesCount": "Messages · {count} found",
  "search.messagesSection": "Messages",
  "search.more": "Show more",
  "search.noMessages": "No messages found for “{query}”",
  "search.resultAria": "Message from {sender} in “{room}”",
  "search.retry": "Try again",
  "search.searching": "Searching on the server…",
  "search.tooShort": "Type at least 2 characters to search messages",
  "search.unknownRoom": "Unknown room",
  "app.sessionEndedTitle": "Your session was ended on the server",
  "app.sessionEndedBody": "This device was signed out of the account. Sign in again to continue.",
  "profile.logoutProgress": "Signing out…",
  "profile.logoutRetry": "Try signing out again",
  "avatar.jpegOnly": "Could not prepare the image. Please try a JPEG file.",
  "avatar.decodeFailed": "Could not open this file as an image. Please try JPEG or PNG.",
  "avatar.encodeFailed": "Could not convert the image to JPEG.",
  "ui.perevernut_kameru": "Flip camera",
  "call.labelSpeaker": "Speaker",
  "call.labelScreenShare": "Screen",
  "call.labelInvite": "Invite",
  "call.labelFlipCamera": "Flip",
  "call.labelCompose": "Write",
  "call.labelEnd": "End",
  "call.labelMicrophone": "Microphone",
  "call.labelCamera": "Camera",
  "message.forward": "Forward",
  "forward.title": "Forward to",
  "forward.unsupported": "Only text messages can be forwarded.",
  "forward.failed": "Could not forward the message: {error}",
  "update.title": "Update available",
  "update.body": "A new version of the app is available: {version}.",
  "update.bodySize": "A new version of the app is available: {version} · {size}.",
  "update.mandatoryNote": "This update is required to continue using the app.",
  "update.now": "Update",
  "update.later": "Later",
};

export const es: Messages = {
  "app.corporateLogin": "Iniciar sesión con la cuenta corporativa de ALG.",
  "app.errorLogin": "No se ha podido iniciar sesión: {error}",
  "app.hideActionError": "Ocultar",
  "app.incomingCall": "Llamada entrante · {room}",
  "app.inviteNotice": "Te han invitado a «{room}»",
  "app.inviteNoticeMore": "y {count} más",
  "app.login": "Iniciar sesión",
  "app.logout": "Cerrar sesión",
  "app.profile": "Perfil",
  "app.settings": "Ajustes",
  "app.resetAndRestart": "Restablecer y empezar de nuevo",
  "app.selectRoom": "Selecciona una sala a la izquierda.",
  "app.serverChoose": "Elegir un servidor",
  "app.serverConnect": "Conectando con el servidor…",
  "app.serverConnectButton": "Conectar",
  "app.serverConnectDescription": "La aplicación se conectará al servidor seleccionado. Las sesiones y los dispositivos se almacenan por separado para cada servidor, así que cambiar de servidor no cerrará tu sesión en otro.",
  "app.serverCurrent": "actual",
  "app.serverCustom": "Otra dirección",
  "app.serverLabel": "Servidor: {server}",
  "app.serverProduction": "Servidor de producción de ALG",
  "app.serverStaging": "entorno de pruebas, los datos pueden cambiar",
  "app.serverSwitch": "cambiar",
  "app.serverUrlPlaceholder": "matrix.example.com",
  "app.sessionCheck": "Comprobando la sesión…",
  "app.unavailableRoom": "La sala no está disponible o ya no eres miembro.",
  "call.accept": "Aceptar llamada",
  "call.callInProgress": "llamada en curso",
  "call.captionRepliesEmpty": "Aún no hay respuestas.",
  "call.decline": "Rechazar llamada",
  "call.deviceCamera": "Cámara",
  "call.deviceDefault": "Predeterminado",
  "call.deviceFallback": "Dispositivo {count}",
  "call.deviceMicrophone": "Micrófono",
  "call.deviceSpeaker": "Altavoz",
  "call.copyDiagnostics": "Copiar diagnóstico de la llamada",
  "call.diagnosticsCopied": "Diagnóstico copiado",
  "call.diagnosticsCopyFailed": "No se pudo copiar el diagnóstico",
  "call.goToRoom": "Ir a la sala",
  "call.goToRoomHint": "Ir a la sala sin responder a la llamada",
  "call.videoCallInProgress": "videollamada en curso",
  "common.accept": "Aceptar",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.create": "Crear",
  "common.decline": "Rechazar",
  "common.done": "Hecho",
  "common.hide": "Ocultar",
  "common.invite": "Invitar",
  "common.inviteShort": "+ Invitar",
  "common.leave": "Salir de la sala",
  "common.messageEdited": " (editado)",
  "common.messageNotSent": " · no enviado",
  "common.messageSending": " · enviando…",
  "common.noMessages": "Aún no hay mensajes.",
  "common.remove": "Eliminar",
  "common.roomStart": "inicio de la sala",
  "common.save": "Guardar",
  "common.search": "Buscar",
  "common.yesDelete": "Sí, eliminar",
  "composer.attachFile": "Adjuntar archivo",
  "composer.attachImage": "Adjuntar imagen",
  "composer.attachMenu": "Archivos adjuntos",
  "composer.attachTitle": "Adjuntar archivo",
  "composer.cancelEdit": "Cancelar edición",
  "composer.cancelReply": "Cancelar respuesta",
  "composer.disabledPlaceholder": "No puedes escribir en esta sala",
  "composer.dropFiles": "Suelta los archivos aquí",
  "composer.editing": "Editando mensaje",
  "composer.emoji": "Emoji",
  "composer.fileUploadProgress": "Subiendo archivo… {percent}%",
  "composer.mentionAll": "Toda la sala",
  "composer.mentionInvited": "invitado",
  "composer.reply": "Responder a {user}",
  "composer.sendButton": "Enviar",
  "composer.sendError": "No se ha podido enviar: {error}",
  "composer.textPlaceholder": "Mensaje… (Enter para enviar, Shift+Enter para saltar de línea)",
  "dialog.avatarOfRoom": "Avatar de la sala",
  "dialog.avatarOfSpace": "Avatar del espacio",
  "dialog.createProgress": "Creando…",
  "dialog.declineDescription": "Se rechazará la invitación a «{room}». Si vuelves a recibir una invitación, la sala aparecerá de nuevo.",
  "dialog.declineProgress": "Rechazando…",
  "dialog.declineTitle": "¿Rechazar la invitación?",
  "dialog.dmAllSpacesHint": "Se muestran los miembros de todos tus espacios. Solo puedes iniciar un chat directo con personas que compartan un espacio contigo.",
  "dialog.dmDescription": "La búsqueda por nombre aún no está disponible: introduce el ID completo con el formato @username:algsuccess.com. La persona recibirá una invitación.",
  "dialog.dmIdLabel": "ID de Matrix del contacto",
  "dialog.dmSpaceHint": "Se muestran los miembros del espacio seleccionado. Para verlos todos, cambia a «Inicio» en la barra de la izquierda.",
  "dialog.dmTitle": "Nuevo chat directo",
  "dialog.historyHint": "«Desde el momento en que se unen» significa que un miembro nuevo ve el historial desde que se unió. «Solo desde el momento en que se unen» significa que no ve nada anterior. Este cambio no es retroactivo para los miembros que ya se han unido.",
  "dialog.historyJoined": "Solo desde el momento en que se unen (los miembros nuevos no pueden ver el pasado)",
  "dialog.historyShared": "Desde el momento en que se unen (los miembros nuevos ven el historial desde que se unieron)",
  "dialog.historyVisibility": "Visibilidad del historial",
  "dialog.historyWho": "Quién puede ver el historial",
  "dialog.inviteDone": "Invitación enviada: {user}",
  "dialog.inviteIdLabel": "ID de Matrix",
  "dialog.inviteProgress": "Invitando…",
  "dialog.inviteSent": "Invitación enviada: {user}",
  "dialog.inviteSpaceDescription": "La persona invitada verá las salas públicas del espacio y todos sus miembros. Las salas solo para invitados permanecerán ocultas hasta que reciba una invitación independiente para cada una.",
  "dialog.inviteSpaceTitle": "Invitar al espacio «{space}»",
  "dialog.inviteOutsideSpaceWarning": "{user} no pertenece al espacio de esta sala. Aun así puedes enviar la invitación, pero la persona seguirá fuera del espacio: un administrador debería añadirla aparte.",
  "dialog.inviteSuggestEmpty": "No hay coincidencias: comprueba la escritura o introduce el ID completo.",
  "dialog.inviteSuggestNone": "No queda nadie que sugerir: todas las personas a las que puedes invitar ya están en la sala. Introduce el ID completo con el formato @username:algsuccess.com.",
  "dialog.inviteTitle": "Invitar a «{room}»",
  "dialog.joinByInvite": "Por invitación",
  "dialog.joinMode": "Modo de acceso",
  "dialog.joinRoom": "Unirse a la sala",
  "dialog.joinSpace": "Unirse al espacio",
  "dialog.leaveDescription": "Saldrás de «{room}». El historial permanecerá en el servidor, pero ya no podrás acceder a él. Solo podrás volver a una sala privada con una nueva invitación.",
  "dialog.leaveProgress": "Saliendo…",
  "dialog.leaveTitle": "¿Salir de la sala?",
  "dialog.matrixIdBadDomain": "Hay caracteres no válidos en la dirección del servidor",
  "dialog.matrixIdCyrillic": "Parece una distribución de teclado rusa: cambia a inglés",
  "dialog.matrixIdInvalidLocalpart": "Los nombres de usuario solo pueden contener letras latinas, números y . _ - = + /",
  "dialog.matrixIdInvalidPrefix": "Un ID de Matrix empieza por @",
  "dialog.matrixIdInvalidSpaces": "Los ID de Matrix no pueden contener espacios",
  "dialog.matrixIdMissingServer": "Falta el servidor después de los dos puntos, por ejemplo @ivanov:algsuccess.com",
  "dialog.matrixIdMissingServerAddress": "La dirección del servidor después de los dos puntos está vacía",
  "dialog.matrixIdNoDomain": "La dirección del servidor no tiene dominio, por ejemplo algsuccess.com",
  "dialog.moveRoomCurrentHome": "La sala está actualmente fuera de los espacios («Inicio»).",
  "dialog.moveRoomCurrentSpace": "La sala está actualmente en el espacio «{space}».",
  "dialog.moveRoomEmpty": "No hay dónde moverla: no tienes ningún espacio en el que puedas gestionar miembros. Pide a un administrador del espacio que la mueva o que aumente tu nivel de permisos.",
  "dialog.moveRoomLabel": "Mover a",
  "dialog.moveRoomProgress": "Moviendo…",
  "dialog.moveRoomTitle": "Mover «{room}»",
  "dialog.newName": "Nombre nuevo",
  "dialog.newRoomDescription": "Visible en el directorio del servidor; cualquier empleado puede unirse. Sin marcar la casilla, será solo por invitación.",
  "dialog.newRoomNameLabel": "Nombre",
  "dialog.newRoomNamePlaceholder": "Por ejemplo: Versión 2.4",
  "dialog.newRoomTitle": "Nueva sala",
  "dialog.newSpaceTitle": "Nuevo espacio",
  "dialog.newTopic": "Tema nuevo",
  "dialog.noSettingsPermission": "No tienes permiso para cambiar la configuración de {kind}.",
  "dialog.publicJoin": "Pública (cualquiera puede unirse)",
  "dialog.publicRoomDescription": "Visible en el directorio del servidor; cualquier empleado puede unirse. Sin marcar la casilla, será solo por invitación.",
  "dialog.publicRoomHint": "Una sala pública es visible en el directorio del servidor y cualquiera puede unirse. A las salas solo para invitados solo se puede acceder mediante una invitación de un miembro.",
  "dialog.publicRoomLabel": "Sala pública",
  "dialog.publicSpaceHint": "Un espacio público es visible en el directorio del servidor y cualquiera puede unirse. A los espacios solo para invitados solo se puede acceder mediante una invitación de un miembro.",
  "dialog.roomCreatedInHome": "La sala se creará fuera de los espacios («Inicio»). Puedes invitar a cualquier usuario.",
  "dialog.roomCreatedInSpace": "La sala se creará en el espacio «{space}».",
  "dialog.roomLeaveBlocked": "No puedes salir del espacio «{room}». {reason}",
  "dialog.roomLeaveSpaceDescription": "Saldrás del espacio «{room}». Sus salas desaparecerán de tu lista y solo podrás volver con una nueva invitación.",
  "dialog.roomLeaveSpaceTitle": "¿Salir del espacio?",
  "dialog.roomSettings": "Configuración de la sala: {room}",
  "dialog.roomTargetHome": "La sala se creará fuera de los espacios («Inicio»). Puedes invitar a cualquier usuario.",
  "dialog.roomTargetSpace": "La sala se creará en el espacio «{space}».",
  "dialog.selectedSpace": "espacio seleccionado",
  "dialog.spaceCreatedInviteFailed": "Espacio creado, pero no se han podido enviar las invitaciones: {users}",
  "dialog.spaceDescription": "Un espacio reúne salas y personas. Sus miembros ven las salas públicas del espacio y todos sus miembros; las salas solo para invitados permanecen ocultas hasta recibir una invitación independiente.",
  "dialog.spaceInviteAction": "Invitar al espacio…",
  "dialog.spaceLeaveAction": "Salir del espacio…",
  "dialog.spaceMemberPlaceholder": "Nombre o @user:algsuccess.com",
  "dialog.spaceMembersAction": "Miembros del espacio…",
  "dialog.spaceMembersLabel": "Miembros (opcional)",
  "dialog.spaceNameLabel": "Nombre",
  "dialog.spaceSettingsTitle": "Configuración del espacio",
  "dialog.spaceTopicLabel": "Descripción (opcional)",
  "dialog.spaceTopicPlaceholder": "De qué trata este espacio",
  "dialog.topicUnset": "(sin definir)",
  "dialog.understood": "Entendido",
  "dialog.untitled": "(sin título)",
  "emoji.loadFailed": "No se ha podido cargar la lista de emojis.",
  "emoji.loading": "Cargando emojis…",
  "emoji.recent": "Recientes",
  "emoji.search": "Buscar emojis",
  "error.backToChats": "Volver a los chats",
  "error.renderStopped": "La aplicación ha encontrado un error y ha dejado de mostrar esta pantalla. Todo lo demás funciona; puedes volver a la lista de chats.",
  "error.somethingBroken": "Algo ha fallado",
  "matrix.authCallbackMissingFlow": "Se ha recibido una devolución de OIDC, pero no hay contexto de flujo; inicia sesión de nuevo.",
  "matrix.authRefused": "MAS ha rechazado la autorización: {error} — {description}",
  "matrix.authStateMismatch": "El estado de OIDC no coincide; se cancela el inicio de sesión.",
  "matrix.errorAttachmentLink": "No se ha podido abrir el archivo adjunto: el servidor no ha devuelto ningún enlace.",
  "matrix.errorAttachmentServer": "el servidor ha respondido {status}",
  "matrix.errorForbidden": "Permisos insuficientes: {detail}",
  "matrix.errorNotFound": "No encontrado: {detail}",
  "matrix.errorRateLimit": "El servidor está limitando las solicitudes. Inténtalo de nuevo dentro de un minuto.",
  "matrix.profileMissingUserId": "No se ha encontrado el ID de usuario del cliente",
  "matrix.sessionRejected": "El servidor ha rechazado la sesión almacenada: {error}",
  "media.download": "Descargar",
  "media.loading": "cargando…",
  "media.next": "Siguiente",
  "media.openInBrowser": "Abrir en el navegador",
  "media.previous": "Anterior",
  "media.share": "Compartir",
  "member.admin": "Administrador",
  "member.ban": "Bloquear",
  "member.banAction": "Bloquear",
  "member.banned": "Bloqueados · {count}",
  "member.bannedCount": "Bloqueados · {count}",
  "member.changeRole": "Cambiar rol",
  "member.changeRoleAction": "Cambiar rol",
  "member.close": "✕",
  "member.count": "Miembros · {count}",
  "member.invite": "+ Invitar",
  "member.invited": "Invitados · {count}",
  "member.invitedCount": "Invitados · {count}",
  "member.invitedUser": "invitado · {user}",
  "member.justNow": "estaba aquí hace un momento",
  "member.kick": "Eliminar",
  "member.kickAction": "Eliminar",
  "member.lastActive": "estuvo activo hace {count} min",
  "member.lastActiveDays": "estuvo activo hace {count} días",
  "member.lastActiveHours": "estuvo activo hace {count} horas",
  "member.leaveSelfWarning": "No puedes salir del espacio: eres el último administrador.",
  "member.mismatch": "El servidor indica que hay {serverCount} miembros unidos, pero se han cargado {loaded}. Aún no se ha cargado parte del estado de la sala.",
  "member.moderator": "moderador",
  "member.notLoaded": "La lista de miembros no se ha cargado.",
  "member.online": "en línea",
  "member.onlineStatus": "en línea",
  "member.participants": "Participantes · {count}",
  "member.role": "Rol",
  "member.roleAdministrator": "Administrador",
  "member.roleModerator": "Moderador",
  "member.roleParticipant": "Participante",
  "member.unban": "Desbloquear",
  "member.unbanAction": "Desbloquear",
  "member.you": "tú",
  "notification.allow": "Permitir notificaciones",
  "notification.apiMissing": "La API de notificaciones no está disponible en este navegador",
  "notification.browserRejected": "el navegador ha rechazado la solicitud",
  "notification.browserStatus": "Notificaciones del navegador: {status}.",
  "notification.deniedHint": "El navegador ha bloqueado las notificaciones y la aplicación no puede desbloquearlas. En Safari, ve a Ajustes → Sitios web → Notificaciones; en Chrome, ve a Ajustes → Privacidad → Configuración de sitios → Notificaciones.",
  "notification.mobileHint": "En iPhone/iPad, las notificaciones solo están disponibles si añades el sitio a la pantalla de inicio (Compartir → «Añadir a pantalla de inicio», iOS 16.4 o posterior). Los sonidos de llamada y los avisos dentro de la aplicación funcionan sin esto.",
  "notification.sent": "enviada al navegador",
  "notification.settingsTitle": "Configuración de notificaciones",
  "notification.statusDefault": "aún no solicitadas",
  "notification.statusDenied": "bloqueadas por el navegador",
  "notification.statusGranted": "permitidas",
  "notification.statusUnsupported": "no compatibles con este navegador",
  "notification.test": "Mostrar notificación de prueba",
  "notification.testBody": "Notificación de prueba. Si puedes verla, todo funciona.",
  "profile.addDevice": "Añadir dispositivo",
  "profile.addDeviceCodeHint": "Introduce este código en el dispositivo nuevo:",
  "profile.allChats": "Todos los chats",
  "profile.appearance": "Apariencia",
  "profile.changePhoto": "Cambiar foto",
  "profile.clickToRename": "Haz clic para cambiar el nombre",
  "profile.close": "Cerrar",
  "profile.closeCabinet": "Cerrar perfil",
  "profile.codeValid": "Código válido durante: {time}",
  "profile.deleteCurrentDeviceQuestion": "Eliminar este dispositivo y cerrar sesión. La aplicación te pedirá que vuelvas a iniciar sesión. ¿Continuar?",
  "profile.deleteDeviceQuestion": "¿Eliminar el dispositivo «{device}»? Todas sus sesiones finalizarán.",
  "profile.deviceActive": "activo {date}",
  "profile.deviceCurrent": "este dispositivo",
  "profile.deviceNameLabel": "Nombre del dispositivo",
  "profile.deviceNamePlaceholder": "Por ejemplo: MacBook, teléfono",
  "profile.deviceSessions": "{count} sesiones",
  "profile.devices": "Dispositivos",
  "profile.devicesUnknownActivity": "actividad desconocida",
  "profile.displayName": "Nombre visible",
  "profile.filesScopeHint": "Se muestran los archivos y el contenido multimedia de los chats ya cargados, y la búsqueda funciona en ellos. Aún no tenemos un archivo completo del servidor con todos los archivos adjuntos; es una tarea independiente del servidor.",
  "profile.filesSearchAria": "Buscar archivos y contenido multimedia",
  "profile.filesSearchPlaceholder": "Buscar por nombre o pie de foto",
  "profile.filesTab": "Archivos",
  "profile.finishLoginQuestion": "¿Terminar de iniciar sesión en «{device}»?",
  "profile.imageRequired": "Se necesita una imagen (PNG, JPEG, etc.)",
  "profile.lightTheme": "Claro",
  "profile.loadingDevices": "Cargando dispositivos…",
  "profile.logout": "Cerrar sesión",
  "profile.logoutConfirm": "Sí, cerrar sesión",
  "profile.logoutQuestion": "¿Cerrar la sesión de este dispositivo?",
  "profile.mediaTab": "Contenido multimedia",
  "profile.multipleSessionsHint": "Hay varias sesiones desde un dispositivo; si alguna no es tuya, finalízala.",
  "profile.myFiles": "Mis archivos y contenido multimedia",
  "profile.newCode": "Obtener un código nuevo",
  "profile.noMedia": "No hay imágenes ni vídeos en los chats cargados.",
  "profile.noOtherFiles": "No hay archivos de otras personas en los chats cargados.",
  "profile.noOwnFiles": "No hay archivos tuyos en los chats cargados.",
  "profile.noSearchResults": "No se ha encontrado nada para esta consulta. La búsqueda funciona en los chats ya cargados.",
  "profile.notifications": "Notificaciones",
  "profile.notificationsEnabled": "Las notificaciones están activadas. Las reglas de silencio (sin sonido para las salas públicas) se aplican automáticamente.",
  "profile.notificationsUnsupported": "Este navegador no admite notificaciones.",
  "profile.openOnNewDevice": "Ábrelo en el dispositivo nuevo:",
  "profile.openPhoto": "Abrir la foto a pantalla completa",
  "profile.permissionDenied": "bloqueadas por el navegador",
  "profile.permissionGranted": "activadas",
  "profile.permissionNotAsked": "no solicitadas",
  "profile.permissionUnsupported": "no compatibles",
  "profile.personalCabinet": "Perfil",
  "profile.photo": "Foto de perfil",
  "profile.photoNotSet": "No se ha establecido ninguna foto",
  "profile.renameDevice": "Cambiar el nombre de este dispositivo",
  "profile.resetDeviceName": "Restablecer nombre",
  "profile.saving": "Guardando…",
  "profile.searchResults": "{count} encontrados",
  "profile.sharedFiles": "Archivos y contenido multimedia compartidos",
  "profile.switchServer": "cambiar",
  "profile.title": "Perfil",
  "profile.uploadPhoto": "Subiendo foto…",
  "room.acceptInviteMenu": "Aceptar invitación",
  "room.add": "Añadir",
  "room.attachmentBroken": "📎 {name} {size} — no se ha podido cargar: {error}",
  "room.attachmentLoading": "📎 {name} — cargando…",
  "room.callAlreadyIn": "Ya estás en una llamada",
  "room.callCamera": "Cámara",
  "room.callConnecting": "Conectando…",
  "room.callDecline": "Rechazar llamada",
  "room.callIncoming": "Llamada entrante",
  "room.callLeave": "Finalizar llamada",
  "room.callMuted": "Micrófono desactivado",
  "room.callParticipants": "llamada en curso · {count} participantes",
  "room.captionEnable": "Activar subtítulos",
  "room.captions": "Subtítulos",
  "room.collapseList": "Contraer la lista de chats",
  "room.expandList": "Expandir la lista de chats",
  "room.chatsCount": "Chats: {visible} de {joined}",
  "room.declineInviteMenu": "Rechazar invitación",
  "room.download": "Descargar",
  "room.emptyFavourites": "No hay chats favoritos. Haz clic derecho en un chat → «Añadir a favoritos».",
  "room.emptyOutsideSpaces": "Aquí no hay nada todavía",
  "room.emptyPeople": "No hay chats directos",
  "room.emptySearch": "No se ha encontrado nada para «{query}»",
  "room.emptySpace": "Este espacio no tiene salas a las que te hayas unido",
  "room.emptyUnread": "No hay chats sin leer",
  "room.encryptedBadge": "Cifrado de extremo a extremo activado",
  "room.encryptedNotice": "Los mensajes de esta sala están cifrados (E2EE).\nEste cliente no los lee deliberadamente: el cifrado está desactivado aquí. Tampoco se pueden enviar mensajes; otros clientes rechazarán un mensaje sin cifrar en una sala cifrada. Usa Element para esta sala.",
  "room.encryptedPreview": "Mensaje cifrado",
  "room.encryptionPageDisabled": "El cifrado está desactivado: la sala no está cifrada y la compatibilidad con E2EE está desactivada deliberadamente en este cliente. No se puede activar aquí.",
  "room.encryptionPageEnabled": "La sala está cifrada (E2EE), pero este cliente no admite cifrado y está desactivado. Lee esta sala en Element. No se puede activar el cifrado aquí.",
  "room.favourite": "favorito",
  "room.favouriteButton": "☆ Añadir a favoritos",
  "room.favouriteMenu": "Añadir a favoritos",
  "room.favouritedButton": "★ En favoritos",
  "room.favouritesTab": "Favoritos",
  "room.headerCallJoin": "Unirse a la llamada",
  "room.headerCallLeave": "Salir de la llamada",
  "room.headerCallStart": "Iniciar llamada",
  "room.headerOpenPage": "Abrir página de la sala",
  "room.headerVideoJoin": "Unirse a la llamada con vídeo",
  "room.headerVideoStart": "Iniciar videollamada",
  "room.historyError": "No se ha terminado de cargar el historial: {error}",
  "room.historyLoading": "Cargando historial…",
  "room.homeLabel": "Inicio — chats fuera de los espacios",
  "room.homeTab": "Inicio",
  "room.insufficientPermissions": "Permisos insuficientes",
  "room.inviteMenu": "Invitar a un miembro…",
  "room.inviteNotice": "Esta es una invitación. Selecciona «Aceptar» en la cabecera para unirte a la sala o «Rechazar» para quitarla de la lista. El contenido de la sala no se muestra antes de unirte.",
  "room.inviteNoticeMore": "y {count} más",
  "room.invitePreview": "Invitación a la sala",
  "room.invitesCount": "Invitaciones · {count}",
  "room.leaveMenu": "Salir de la sala…",
  "room.loadOlder": "↑ desplázate hacia arriba para cargar el historial",
  "room.loadingChats": "Cargando chats…",
  "room.loadingShort": "Cargando…",
  "room.mediaFound": "{count} encontrados",
  "room.memberCount": "{count} miembros · {roomId}",
  "room.members": "Miembros",
  "room.mentioned": "te han mencionado",
  "room.waitingChip": "Me esperan",
  "room.emptyWaiting": "Nadie te espera",
  "room.waitingChipAria": "Me esperan: {count}",
  "room.mentionsTab": "Menciones",
  "room.messageLinkMiss": "El mensaje enlazado es anterior al historial cargado. Desplázate hacia arriba para cargar más; aparecerá entonces.",
  "room.newDm": "+ Chat directo",
  "room.newRoom": "+ Sala",
  "room.noMessagesPreview": "No hay mensajes",
  "room.noResults": "No se ha encontrado nada para esta consulta",
  "room.notificationSettings": "Notificaciones",
  "room.notificationsCurrent": "Notificaciones: {mode}",
  "room.notificationsMenu": "Notificaciones ▾",
  "room.notifyAll": "Todos los mensajes",
  "room.notifyAllHint": "notificar cada mensaje",
  "room.notifyMentions": "Solo menciones",
  "room.notifyMentionsHint": "mantener silencio hasta que te mencionen",
  "room.notifyNone": "Ninguna",
  "room.notifyNoneHint": "silencio, incluidas las menciones",
  "room.openMembers": "Abrir lista de miembros",
  "room.openSettings": "Abrir configuración de la sala",
  "room.pageLabel": "Página de la sala",
  "room.peopleTab": "Personas",
  "room.railAria": "Espacios",
  "room.receiptError": "No se ha podido enviar la confirmación de lectura: {error}",
  "room.removeFavourite": "Quitar de favoritos",
  "room.roomPage": "Página de la sala",
  "room.roomSettings": "Configuración de la sala",
  "room.scanBusy": "comprobando…",
  "room.scanComplete": "Se ha visto todo el historial.",
  "room.scanCount": "Se han visto {count} mensajes.",
  "room.scanDeeper": "buscar más a fondo",
  "room.searchAria": "Buscar chats",
  "room.searchPlaceholder": "Buscar",
  "room.sectionChats": "Chats",
  "room.sectionFavourites": "Favoritos",
  "room.sidebarAria": "Lista de chats",
  "room.spaceCreate": "+ Espacio",
  "room.mobileCreateTitle": "Crear",
  "room.mobileCreateRoom": "Sala",
  "room.mobileCreateDm": "Chat privado",
  "room.mobileCreateSpace": "Espacio",
  "room.spaceEmpty": "Este espacio no tiene salas a las que te hayas unido",
  "room.spaceLeave": "Salir del espacio",
  "room.spaceMembers": "Miembros del espacio",
  "room.spaceRename": "Configuración del espacio",
  "room.tabFiles": "Archivos",
  "room.tabLinks": "Enlaces",
  "room.tabMedia": "Contenido multimedia",
  "room.tabMembers": "Miembros",
  "room.tabVoice": "Mensajes de voz",
  "room.unfavouriteMenu": "Quitar de favoritos",
  "room.unreadTab": "Sin leer",
  "room.you": "tú",
  "space.admin": "administrador",
  "space.invited": "invitado",
  "space.membersNotFound": "No se ha encontrado el espacio en los datos cargados. Actualiza la página.",
  "space.partialRemoval": "No se ha eliminado de todas partes. Queda: {rooms}",
  "space.removeQuestion": "¿Eliminar a {user} del espacio?",
  "space.removeSummary": "Saldrá del espacio y de sus {count} salas. Las salas y los chats permanecerán en su sitio; no se elimina nada. Una sala en la que solo estabais dos personas quedará con un miembro y todo su historial. Puedes volver a invitar a esa persona en cualquier momento.",
  "space.removed": "{user} ha sido eliminado del espacio y de sus salas ({count}).",
  "space.you": "tú",
  "thread.loadOlder": "↑ desplázate hacia arriba para cargar el historial",
  "thread.noReplies": "Aún no hay respuestas.",
  "thread.sendError": "No se ha podido enviar la respuesta: {error}",
  "thread.start": "inicio del hilo",
  "thread.title": "Hilo",
  "timeline.attachmentFallback": "archivo",
  "timeline.attachmentNotLoaded": "no cargado",
  "timeline.audioOpen": "Abrir en el visor",
  "timeline.callActive": "Llamada en curso",
  "timeline.callDecline": "Rechazar",
  "timeline.callDuration": "Duración: {duration}",
  "timeline.callFinished": "Llamada finalizada",
  "timeline.callJoin": "Unirse",
  "timeline.callParticipantsCount": "Participantes: {count}",
  "timeline.copyLink": "Copiar enlace",
  "timeline.dayToday": "hoy",
  "timeline.dayYesterday": "ayer",
  "timeline.delete": "Eliminar",
  "timeline.downloadFile": "Descargar archivo",
  "timeline.downloading": "Descargando…",
  "timeline.edit": "Editar",
  "timeline.emote": "* {user} {body}",
  "timeline.historyBeginning": "inicio de la sala",
  "timeline.loadOlder": "↑ Cargar más",
  "timeline.noMessages": "Aún no hay mensajes.",
  "timeline.openViewer": "Abrir en el visor",
  "timeline.reaction": "Reacción",
  "timeline.repliesFew": "{count} respuestas",
  "timeline.repliesMany": "{count} respuestas",
  "timeline.repliesOne": "{count} respuesta",
  "timeline.reply": "Responder",
  "timeline.senderMe": "Tú",
  "timeline.senderUnknown": "desconocido",
  "timeline.share": "Compartir",
  "ui.zakryt_esc": "Cerrar (Esc)",
  "ui.nuzhna_kartinka_png_jpeg_i_t_p": "Se necesita una imagen (PNG, JPEG, etc.)",
  "ui.bez_imeni": "sin nombre",
  "ui.limit_poka_ne_deystvuet_servernaya_chast": " El límite aún no está activo: el servidor está en desarrollo.",
  "ui.ustroystvo_bez_imeni": "Dispositivo sin nombre",
  "ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta": "Eliminar este dispositivo (cerrar sesión)",
  "ui.udalit_eto_ustroystvo": "Eliminar este dispositivo",
  "ui.udalit_ustroystvo": "Eliminar dispositivo",
  "ui.udalyayu": "Eliminando…",
  "ui.da_zavershit": "Sí, finalizar",
  "ui.ustroystvo": "dispositivo",
  "ui.zavershit_etot_vhod": "Cerrar esta sesión",
  "ui.filtr_po_chatu": "Filtrar por chat",
  "ui.gotovlyu_fayl": "Preparando archivo…",
  "ui.vas_ni_v_ch_m_ne_upominali": "No te han mencionado",
  "ui.home_chaty_vne_prostranstv": "Home — chats fuera de los espacios",
  "ui.sozdat_prostranstvo": "Crear espacio",
  "ui.v_istorii_komnaty_ne_naydeno_kartinok_i": "No se encontraron imágenes ni vídeos en el historial de la sala",
  "ui.my_prosmotreli_tolko_chast_istorii_nazhm": "Solo vimos parte del historial — haz clic en «buscar más atrás» abajo.",
  "ui.kb": "KB",
  "ui.mb": "MB",
  "ui.gb": "GB",
  "ui.v_istorii_komnaty_ne_naydeno_faylov": "No se encontraron archivos en el historial de la sala",
  "ui.v_istorii_komnaty_ne_naydeno_ssylok": "No se encontraron enlaces en el historial de la sala",
  "ui.v_istorii_komnaty_ne_naydeno_golosovyh": "No se encontraron mensajes de voz en el historial de la sala",
  "ui.etot_brauzer_ne_dal_pereklyuchit_dinamik": "Este navegador no pudo cambiar el altavoz. El sonido siguió en el dispositivo anterior.",
  "ui.ne_udalos_pereklyuchit_ustroystvo_ostalo": "No se pudo cambiar de dispositivo — se mantiene el anterior.",
  "ui.mikrofon": "micrófono",
  "ui.kameru": "cámara",
  "ui.dinamik": "altavoz",
  "ui.vybrannoe_ranee": "seleccionado anteriormente",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne": "Las llamadas en salas cifradas aún no son compatibles. ",
  "ui.sozdayte_obychnuyu_komnatu_ili_dozhdites_o": "Crea una sala normal o espera una actualización.",
  "ui.mikrofon_ne_dal_audiodorozhku": "El micrófono no proporcionó una pista de audio",
  "ui.kamera_ne_dala_videodorozhku": "La cámara no proporcionó una pista de vídeo",
  "ui.jwt_servis_v_otvete_net_url_jwt": "Servicio JWT: la respuesta no contiene url/jwt",
  "ui.brauzer_ne_dal_videodorozhku_ekrana": "El navegador no proporcionó una pista de vídeo de pantalla",
  "ui.ekran_vy": "Pantalla: tú",
  "ui.demonstraciya_ekrana_ne_nachalas_dostup_n": "La pantalla compartida no comenzó: no se concedió acceso",
  "ui.brauzer_ne_umeet_zapisyvat_opus": "El navegador no puede grabar opus",
  "ui.slishkom_korotko": "Demasiado corto",
  "ui.golosovoe_dlinnee_5_minut": "El mensaje de voz dura más de 5 minutos",
  "ui.dostup_k_mikrofonu_zapresch_n": "Acceso al micrófono denegado",
  "ui.priglash_n_no_esch_ne_vosh_l_uvedomlenie_pri": "Invitado, pero aún no se ha unido; recibirá la notificación al entrar",
  "ui.redaktiruyte_soobschenie": "Edita el mensaje…",
  "ui.otvet": "Responder…",
  "ui.soobschenie_upomyanut_enter_otpravit": "Mensaje… (@ — mencionar, Enter — enviar)",
  "ui.otpravit_fayl": "Enviar archivo",
  "ui.uchastniki_komnaty": "Miembros de la sala",
  "ui.isklyuchit_iz_komnaty": "Expulsar de la sala",
  "ui.zabanit": "Bloquear",
  "ui.izmenit_prava": "Cambiar permisos",
  "ui.prichina_neobyazatelno_vidna_drugim_uchast": "Motivo (opcional, visible para otros miembros)",
  "ui.naprimer_flud": "Por ejemplo: flood",
  "ui.naprimer_spam": "Por ejemplo: spam",
  "ui.snyat_ban": "¿Desbloquear?",
  "ui.net_userid_klienta": "no hay userId del cliente",
  "ui.ustroystvo_2": "Dispositivo",
  "ui.yandeks_brauzer": "Yandex Browser",
  "ui.brauzer": "navegador",
  "ui.net_access_token": "no hay access token",
  "ui.net_client_id_sessiya_ne_oidc": "no hay client_id — la sesión no es OIDC",
  "ui.net_device_id": "no hay device_id",
  "ui.mas_graphql_endpoint_ne_obyavlen": "MAS GraphQL endpoint no declarado",
  "ui.device_authorization_endpoint_ne_obyavle": "Device authorization endpoint no declarado",
  "ui.token_endpoint_ne_obyavlen": "Token endpoint no declarado",
  "ui.polzovatel_otklonil_avtorizaciyu": "El usuario rechazó la autorización",
  "ui.kod_ist_k": "El código ha caducado",
  "ui.vremya_ozhidaniya_isteklo": "Se agotó el tiempo de espera",
  "ui.id_t_demonstraciya_vashego_ekrana": "Estás compartiendo tu pantalla",
  "ui.vernutsya_v_zvonok": "Volver a la llamada",
  "ui.vyklyuchit_mikrofon": "Silenciar micrófono",
  "ui.vklyuchit_mikrofon": "Activar micrófono",
  "ui.vyklyuchit_kameru": "Apagar cámara",
  "ui.vklyuchit_kameru": "Encender cámara",
  "ui.otmenit_zvonok": "Cancelar llamada",
  "ui.brauzer_otklonil_pokaz_onerror": "el navegador rechazó la visualización (onerror)",
  "ui.api_otsutstvuet": " · API no disponible",
  "ui.uchastnik": "participante",
  "ui.uchastnikov": "participantes",
  "ui.bez_administratora_prostranstvom_nelzya": "Sin administrador, no se podrá gestionar el espacio: no se podrá invitar, ",
  "ui.ni_dobavit_komnatu_ni_izmenit_nastroyk": "añadir una sala ni cambiar los ajustes. Primero designa a otro ",
  "ui.administratora_ili_udalite_ostalnyh_ucha": "administrador o elimina a los demás miembros.",
  "ui.izmenenie_sobstvennogo_urovnya_prav_zdes": "Aquí no puedes cambiar tu propio nivel de permisos",
  "ui.net_eventid_u_redaktiruemogo_soobscheniya": "el mensaje editado no tiene eventId",
  "ui.net_eventid_dlya_redact": "no hay eventId para redact",
  "ui.otklonit_zvonok_zvonyaschiy_uznaet_ob_otka": "Rechazar llamada — el autor sabrá que la rechazaste",
  "ui.staree": "Más antiguo (←)",
  "ui.novee": "Más reciente (→)",
  "ui.udaleno_ne_vezde_ostalos": "No se eliminó en todas partes. Quedan: ",
  "ui.komnaty": "chats",
  "ui.komnat": "salas",
  "ui.ne_udalos_postroit_ssylku_iz_mxc": "no se pudo crear el enlace desde mxc://",
  "ui.nedostatochno_prav_dlya_otpravki_soobscheniy": "No tienes permiso para enviar mensajes en este chat",
  "ui.redaktiruemoe_soobschenie_ne_naydeno_v_len": "No se encontró el mensaje que estás editando en la cronología",
  "ui.soobschenie_na_kotoroe_vy_otvechaete_ne_nay": "No se encontró el mensaje al que estás respondiendo en la cronología",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne_2": "Las llamadas en chats cifrados aún no son compatibles",
  "ui.vybrat_mikrofon_i_dinamik": "Seleccionar micrófono y altavoz",
  "ui.zaprashivaem_dostup_k_kamere": "Solicitando acceso a la cámara…",
  "ui.vklyuchit_kameru_zaprosim_dostup": "Encender cámara (solicitaremos acceso)",
  "ui.vybrat_kameru": "Seleccionar cámara",
  "ui.demonstraciya_ekrana_nedostupna_v_etom_br": "Compartir pantalla no está disponible en este navegador",
  "ui.vybiraem_okno_ili_ekran": "Selecciona una ventana o pantalla…",
  "ui.ostanovit_demonstraciyu_ekrana": "Dejar de compartir pantalla",
  "ui.demonstraciya_ekrana": "Compartir pantalla",
  "ui.svernut_zvonok_v_okoshko_chtoby_pisat_v": "Minimiza la llamada en una ventana para escribir en este chat",
  "ui.uchastnika": "participantes",
  "ui.podklyuchaemsya_k_zvonku": "Uniéndose a la llamada…",
  "ui.id_t_zvonok_zhd_m_otveta": "Llamando, esperando respuesta",
  "ui.otkazatsya_ot_zvonka_zvonyaschiy_uznaet_ob": "Rechaza la llamada: el autor sabrá que la rechazaste",
  "ui.otkazatsya_ot_zvonka": "Rechazar llamada",
  "ui.otmenit_podklyuchenie": "Cancelar conexión",
  "ui.udalit_soobschenie": "¿Eliminar mensaje?",
  "ui.nedostatochno_prav_dlya_udaleniya_etogo_soo": "No tienes permiso para eliminar este mensaje.",
  "ui.soobschenie_ne_naydeno": "No se encontró el mensaje",
  "ui.udalit_svo_soobschenie": "¿Eliminar tu mensaje?",
  "ui.udalit_soobschenie_moderatorom": "¿Eliminar mensaje como moderador?",
  "ui.soobschenie_ne_naydeno_v_lente": "No se encontró el mensaje en la cronología.",
  "ui.komnata_budet_sozdana_vne_prostranstv_do": "El chat se creará fuera de los espacios (\"Home\"). Se puede invitar a cualquier usuario.",
  "ui.pustoe_imya_polzovatelya_do_dvoetochiya": "El nombre de usuario antes de los dos puntos está vacío",
  "ui.pokazany_uchastniki_vybrannogo_prostranst": "Se muestran los miembros del espacio seleccionado. Para verlos a todos, cambia a \"Home\" en la barra izquierda.",
  "ui.naprimer_otdel_prodazh": "Por ejemplo: Equipo de ventas",
  "ui.perenesti": "Mover",
  "ui.seychas_komnata_vne_prostranstv_dom": "Este chat está fuera de los espacios (\"Home\").",
  "ui.podskazyvat_nekogo_vse_kogo_vy_znaete_p": "No hay sugerencias: todos los que conoces de tus espacios ya están aquí. Introduce un identificador completo, como @usuario:algsuccess.com.",
  "ui.zagruzka": "Cargando…",
  "ui.zagruzit_avatar_komnaty": "Subir avatar del chat",
  "ui.vidna_vsem_dazhe_bez_vhoda": "visible para todos, incluso sin unirse",
  "ui.s_momenta_vhoda_uchastnika": "desde que el miembro se unió",
  "ui.s_momenta_priglasheniya": "desde la invitación",
  "ui.tolko_s_momenta_vhoda": "solo desde que se unió",
  "ui.tema": "Tema",
  "ui.avatar": "Avatar",
  "ui.publichnaya": "pública",
  "ui.po_priglasheniyu": "solo por invitación",
  "ui.pisat_soobscheniya": "Enviar mensajes",
  "ui.priglashat_uchastnikov": "Invitar miembros",
  "ui.udalyat_chuzhie_soobscheniya": "Eliminar mensajes de otros",
  "ui.menyat_nastroyki_i_roli": "Cambiar ajustes y roles",
  "ui.uchastniki": "miembros",
  "ui.moderatory": "moderadores",
  "ui.adminy": "administradores",
  "ui.nedostatochno_prav_dlya_izmeneniya": "No tienes permiso para cambiar esto",
  "ui.menyat_prava_roley_mozhet_tolko_tot_u_ko": "Solo alguien con permisos suficientes puede cambiar los permisos de los roles (umbral m.room.power_levels). No los tienes; los valores se muestran como referencia.",
  "ui.otvetov": "respuestas",
  "ui.otvet_2": "respuesta",
  "ui.otveta": "respuestas",
  "ui.history_avtodogruzka_ostanovlena_8_stra": "[history] carga automática detenida: 8 páginas sin progreso",
  "ui.naverhu_stranica_ne_dala_vidimyh_soobschen": "arriba; la página no devolvió mensajes visibles",
  "ui.soobschenie_ne_zagruzheno": "Mensaje no cargado",
  "ui.menshe_minuty": "menos de un minuto",
  "ui.snyat_reakciyu": "Quitar reacción",
  "ui.drugoy_emodzi": "Otro emoji",
  "ui.otvetit_v_trede": "Responder en el hilo",
  "ui.kopirovat_tekst": "Copiar texto",
  "ui.prostranstva": "espacios",
  "ui.prostranstvo": "espacio",
  "ui.komnatu": "chat",
  "ui.publichnoe_prostranstvo_vidno_v_kataloge": "Un espacio público aparece en el directorio del servidor y cualquier empleado puede unirse. Solo por invitación significa que hace falta una invitación de un miembro.",
  "ui.publichnaya_komnata_vidna_v_kataloge_serve": "Un chat público aparece en el directorio del servidor y cualquier empleado puede unirse. Solo por invitación significa que hace falta una invitación de un miembro.",
  "ui.etogo_prostranstva": "este espacio",
  "ui.etoy_komnaty": "este chat",
  "ui.zagruzit": "Subir",
  "ui.zakryt_tred": "Cerrar hilo",
  "ui.otvetit_v_tred_upomyanut_enter_otpravit": "Responder en el hilo… (@ — mencionar, Enter — enviar)",
  "ui.perenesti_v_prostranstvo": "Mover al espacio…",
  "ui.nastroyki_komnaty": "Ajustes del chat…",
  "profile.language": "Idioma",
  "profile.files": "Mis archivos",
  "profile.server": "Servidor",
  "profile.serverChange": "cambiar",
  "theme.system": "Como el sistema",
  "theme.light": "Claro",
  "theme.dark": "Oscuro",
  "ui.b": "B",
  "rtc.deviceDefault": "Predeterminado",
  "rtc.micLabel": "Micrófono",
  "rtc.cameraLabel": "Cámara",
  "rtc.speakerLabel": "Altavoz",
  "rtc.micWord": "micrófono",
  "rtc.cameraWord": "cámara",
  "rtc.speakerWord": "altavoz",
  "rtc.previouslyChosen": "seleccionado antes",
  "rtc.speakerSwitchFailed": "Este navegador no permitió cambiar el altavoz. El audio siguió en el anterior.",
  "rtc.deviceSwitchFailed": "No se pudo cambiar el dispositivo: sigue el anterior.",
  "rtc.encryptedNotSupported1": "Las llamadas en salas cifradas aún no son compatibles. ",
  "rtc.encryptedNotSupported2": "Crea una sala normal o espera una actualización.",
  "rtc.you": "Tú",
  "rtc.screenYou": "Pantalla: Tú",
  "rtc.micMuted": "Micrófono apagado",
  "rtc.cameraOff": "Cámara apagada",
  "rtc.screenShareDenied": "No se inició la pantalla compartida: acceso denegado",
  "device.generic": "Dispositivo",
  "device.yandexBrowser": "Yandex Browser",
  "device.browserWord": "navegador",
  "file.generic": "archivo",
  "error.rateLimited": "El servidor está limitando las solicitudes. Inténtalo en un minuto.",
  "space.memberSingular": "miembro",
  "space.memberPlural": "miembros",
  "space.lastAdminWarn1": "Sin administrador no se podrá gestionar el espacio: ni invitar, ",
  "space.lastAdminWarn2": "ni añadir salas, ni cambiar ajustes. Nombra antes a otro ",
  "space.lastAdminWarn3": "administrador o elimina al resto de miembros.",
  "common.unknown": "desconocido",
  "message.encrypted": "Mensaje cifrado",
  "message.youPrefix": "Tú",
  "room.inviteToRoom": "Invitación a la sala",
  "message.deleted": "mensaje eliminado",
  "message.wasDeleted": "Se eliminó el mensaje",
  "message.attachment": "adjunto",
  "emoji.searchPlaceholder": "Buscar (en inglés: heart, cat, fire)",
  "server.current": " · actual",
  "space.settingsMenu": "Ajustes del espacio…",
  "file.noName": "sin nombre",
  "error.noUserId": "No hay ID de usuario del cliente",
  "error.noAccessToken": "No hay token de acceso",
  "error.noClientIdNotOidc": "No hay client_id: la sesión no es OIDC",
  "error.noDeviceId": "No hay device_id",
  "error.masEndpointMissing": "El endpoint GraphQL de MAS no está declarado",
  "error.deviceAuthEndpointMissing": "El endpoint de autorización de dispositivo no está declarado",
  "error.tokenEndpointMissing": "El endpoint de token no está declarado",
  "error.authDeclined": "El usuario rechazó la autorización",
  "error.codeExpired": "El código ha caducado",
  "error.waitTimeout": "Se agotó el tiempo de espera",
  "error.micNoTrack": "El micrófono no entregó pista de audio",
  "error.cameraNoTrack": "La cámara no entregó pista de vídeo",
  "error.jwtNoUrl": "Servicio JWT: la respuesta no trae url/jwt",
  "error.screenNoTrack": "El navegador no entregó pista de vídeo de la pantalla",
  "error.ownPowerLevel": "Aquí no se permite cambiar tu propio nivel de permisos",
  "error.noEventIdEdit": "El mensaje editado no tiene event ID",
  "error.noEventIdRedact": "No hay event ID para redactar",
  "error.mxcLinkFailed": "No se pudo construir el enlace desde mxc://",
  "error.providerMissing": "Falta MatrixClientProvider más arriba en el árbol",
  "emoji.groupSmileys": "Caritas y emociones",
  "emoji.groupPeople": "Personas",
  "emoji.groupNature": "Animales y naturaleza",
  "emoji.groupFood": "Comida y bebida",
  "emoji.groupTravel": "Viajes y lugares",
  "emoji.groupActivities": "Actividades",
  "emoji.groupObjects": "Objetos",
  "emoji.groupSymbols": "Símbolos",
  "emoji.groupFlags": "Banderas",
  "server.hintMain": "servidor de producción de ALG",
  "server.hintStage": "de pruebas, los datos se pueden romper",
  "error.serverAddressRequired": "Introduce la dirección del servidor",
  "error.serverAddressInvalid": "La dirección del servidor no parece válida",
  "error.serverAddressHttps": "La dirección debe empezar por https://",
  "call.ringDiagStarting": "llamada: intentando iniciar el sonido…",
  "notification.newMessage": "Mensaje nuevo",
  "app.roomUnavailable": "Sala no disponible",
  "app.roomUnavailableBody": "No estás en esta sala (o el enlace tiene una errata). Pide a un miembro que te invite: tras la invitación el enlace se abrirá solo.",
  "room.linkMenu": "Enlace de la sala…",
  "roomLink.title": "Enlace a «{room}»",
  "roomLink.hint": "Envía este enlace para invitar a la sala. Abre la sala en nuestro mensajero.",
  "roomLink.fieldLabel": "Enlace",
  "roomLink.copy": "Copiar",
  "roomLink.share": "Compartir",
  "roomLink.copied": "Enlace copiado",
  "roomLink.copyFailed": "No se pudo copiar: selecciona el enlace y cópialo a mano",
  "roomLink.closedHint": "La sala es solo por invitación: el enlace deja entrar a quienes ya están invitados. Los demás verán que deben pedir una invitación.",
  "roomLink.openHint": "La sala es pública: cualquier usuario del servidor puede entrar con el enlace.",
  "roomLink.restrictedHint": "Podrán entrar con el enlace los miembros del espacio de la sala.",
  "roomLink.knockHint": "Se puede pedir acceso a la sala, pero este cliente aún no envía solicitudes: sin invitación el enlace no deja entrar.",
  "roomGate.title": "Sala desde un enlace",
  "roomGate.loading": "Comprobando la sala…",
  "roomGate.join": "Entrar en la sala",
  "roomGate.joining": "Entrando…",
  "roomGate.members": "Miembros: {count}",
  "roomGate.closedTitle": "La sala es privada: pide una invitación",
  "roomGate.closedBody": "No puedes entrar con el enlace: la sala es solo por invitación. Pide a un miembro que te invite; tras la invitación el enlace se abrirá solo.",
  "roomGate.knockBody": "Se puede pedir acceso a esta sala, pero el envío de solicitudes desde este cliente aún no está activado. Pide a un miembro que te invite.",
  "roomGate.notFound": "No se encontró ninguna sala para este enlace. Revisa el enlace.",
  "app.clickToOpen": "Haz clic para abrir",
  "app.goBack": "Volver",
  "composer.releaseToSend": "Suelta para enviar",
  "composer.photoVideo": "Foto/vídeo",
  "composer.file": "Archivo",
  "composer.voiceMessage": "Mensaje de voz",
  "composer.toRoom": "A la sala:",
  "common.secShort": "s",
  "emoji.nothingFound": "No se encontró nada",
  "error.boundaryBody": "La aplicación encontró un error y dejó de mostrar esta pantalla. El resto funciona: puedes volver.",
  "media.fileDownloaded": "Archivo descargado.",
  "media.shareFallbackDownloaded": "No se pudo compartir; el archivo se descargó.",
  "member.youSuffix": "· tú",
  "member.banCannotReturn": "no podrá volver a entrar",
  "member.banCannotReturnTail": ", ni con una nueva invitación, hasta que se levante el baneo manualmente (la lista está al final del panel de miembros).",
  "member.kickNoAutoReturn": "no volverá a la sala automáticamente",
  "member.kickNoAutoReturnTail": ": tendrá que volver a entrar o ser invitado de nuevo.",
  "member.roleExplain": "El rol define qué puede hacer un miembro en la sala: escribir, invitar, moderar, cambiar ajustes. El ascenso se aplica de inmediato en todos los clientes.",
  "member.powerLevel": "Nivel de permisos",
  "member.stateNotLoaded": ". Parte del estado de la sala aún no se ha cargado.",
  "member.kickWarnBody": "será expulsado de la sala y podrá volver con una nueva invitación (o por su cuenta, si la sala es pública).",
  "member.unbanWarn": "será desbaneado, pero",
  "notification.iosHint": "En iPhone/iPad las notificaciones solo funcionan si el sitio está en la pantalla de inicio (Compartir → Añadir a inicio).",
  "notification.blockedHint": "El navegador bloquea las notificaciones; la app no puede quitarlo. En Safari: Ajustes → Sitios web → Notificaciones.",
  "notification.showNew": "Mostrar notificaciones de mensajes nuevos",
  "notification.soundNew": "Sonido de mensaje nuevo",
  "notification.ringOnCall": "Tono en llamada entrante",
  "profile.deviceCodeHint": "Aparecerá un código: introdúcelo en el nuevo dispositivo para confirmar su inicio de sesión.",
  "profile.multiSessionHint": "Varios inicios de sesión desde un dispositivo; si alguno no es tuyo, ciérralo.",
  "profile.thisDeviceSuffix": "· este dispositivo",
  "profile.clientUnknown": "cliente desconocido: el servidor no lo informa",
  "profile.generatingCode": "Generando un código…",
  "profile.notificationsOnHint": "Las notificaciones están activadas. Las reglas de silencio (una sala abierta no suena) se aplican solas.",
  "profile.notYouHint": ". Si no eres tú, abre la gestión de dispositivos y cierra esa sesión.",
  "profile.deviceLimitHint": "º dispositivo requerirá aprobación del administrador. El límite aún no está activo: la parte del servidor está en curso.",
  "profile.sessionsWord": "sesiones",
  "profile.permissionRetryHint": "). El botón de abajo vuelve a preguntar al navegador; si responde «denegado», solo se cambia en sus ajustes.",
  "dialog.cannotLeaveSpace": "No puedes salir del espacio",
  "dialog.youWillLeaveSpace": "Vas a salir del espacio",
  "dialog.leaveSpaceTail": ". Sus salas desaparecerán de tu lista y volver requerirá una nueva invitación.",
  "dialog.youWillLeaveRoom": "Vas a salir de la sala",
  "dialog.leaveRoomTail": ". El historial queda en el servidor pero no estará disponible para ti. Volver a una sala privada exige nueva invitación.",
  "dialog.invitationTo": "Invitación a",
  "dialog.inviteDeclineTail": "será rechazada. Si te invitan de nuevo, la sala volverá a aparecer.",
  "dialog.spaceExplain": "Un espacio agrupa salas y personas. Un miembro del espacio ve sus salas abiertas.",
  "dialog.noSpacesToMove": "No hay dónde mover: no tienes espacios con permiso para gestionar el contenido (m.space.child). Pide a un administrador del espacio que lo mueva o que suba tu nivel de permisos.",
  "dialog.outsideSpacesHome": "— Fuera de espacios (Inicio) —",
  "dialog.inviteSpaceHint": "El invitado verá las salas abiertas del espacio y todos sus miembros. Las salas solo por invitación siguen ocultas.",
  "room.encryptionWord": "Cifrado",
  "room.encNotSupportedOff": "no compatible: desactivado",
  "room.encReadInElement": ". Puedes leer esa sala en Element. Aquí no se puede activar el cifrado.",
  "room.offWord": "desactivado",
  "room.encDisabledTail": ": la sala no está cifrada y el soporte E2EE está desactivado a propósito en este cliente. Aquí no se puede activar.",
  "room.changeSettings": "Cambiar ajustes…",
  "room.noRightsSettings": "No tienes permiso para cambiar estos ajustes; se muestran a título informativo. Contacta a un administrador.",
  "room.noRights": "sin permiso",
  "room.rolePermissions": "Permisos de roles",
  "room.advancedSettings": "Ajustes avanzados",
  "room.settingsSubtitle": "Ajustes de sala, permisos de roles, cifrado",
  "room.loadingHistory": "Cargando historial…",
  "room.publicWord": "Pública",
  "room.historyShared": "Desde que entra (shared)",
  "room.historyJoined": "Solo desde que entra (joined)",
  "room.historyExplain": "«Desde que entra»: el nuevo miembro ve el historial desde su entrada. «Solo desde que entra» es más estricto: ni la invitación muestra el pasado.",
  "room.thisIsWord": "Esto es",
  "room.invitationWord": "una invitación",
  "room.inviteHintTail": ". Pulsa «Aceptar» arriba para entrar en la sala, o «Rechazar» para quitarla de la lista. El contenido no se muestra antes de entrar.",
  "room.encryptedNoticeTail": "Este cliente no los lee a propósito: el cifrado está desactivado. Tampoco puedes enviar: otros clientes rechazan un mensaje sin cifrar en una sala cifrada. Usa Element para esta sala.",
  "room.callInProgress": "Llamada en curso",
  "room.callConnectFailed": "No se pudo conectar a la llamada.",
  "common.tryAgain": "Intentar de nuevo",
  "room.moderatorDeleteNotice": "Estás borrando el mensaje de otra persona como moderador. Los demás verán que fue eliminado.",
  "room.noVideoYet": "· nadie ha activado el vídeo",
  "server.pickerHint": "La app se conectará al servidor elegido. La sesión y los dispositivos se guardan por separado para cada servidor.",
  "space.fromSpaceQuestion": "¿del espacio?",
  "space.itIsYou": "— eres tú",
  "space.adminSuffix": "· admin",
  "space.noMembersYet": "El espacio aún no tiene miembros aparte de ti.",
  "space.removeMemberTail": ". Las salas y conversaciones se mantienen: no se borra nada. Una sala donde erais dos queda con un miembro y todo el historial. Puedes volver a invitar a la persona cuando quieras.",
  "space.invitedSuffix": "· invitado",
  "message.editedMark": "(editado)",
  "message.sendingMark": "· enviando…",
  "message.notSentMark": "· no enviado",
  "timeline.loadingPreview": "Cargando vista previa…",
  "timeline.callOngoing": "Llamada en curso",
  "timeline.loadingTail": "— cargando…",
  "member.kickShort": "Expulsar",
  "member.banShort": "Banear",
  "notification.permissionNotGranted": "Permiso no concedido",
  "member.banStricterHead": "El baneo es más estricto que la expulsión:",
  "profile.deviceLimitHead": "Al añadir el",
  "room.membersCountOne": "miembro",
  "room.membersCountFew": "miembros",
  "room.membersCountMany": "miembros",
  "profile.deviceLabelWeb": "{machine} · {client} (web)",
  "profile.deviceDeleteUnexpectedStatus": "Estado de eliminación inesperado: {status}",
  "matrix.errorUserNotFoundOnServer": "No se ha encontrado al usuario {user} en su servidor",
  "matrix.errorServerUnreachable": "No se puede contactar con el servidor: {detail}. Comprueba el dominio.",
  "space.lastAdminHead": "Eres el único administrador y en el espacio quedan {count} ",
  "timeline.inReplyTo": "En respuesta a",
  "rtc.deviceDisconnectedFallback": "{device} «{name}» se ha desconectado: se ha cambiado al dispositivo predeterminado.",
  "rtc.speakerRestored": "El altavoz «{name}» vuelve a estar disponible: el audio de la llamada vuelve a él.",
  "rtc.callMembershipFailed": "La participación en la llamada no se ha registrado en la sala: {error}. Los demás no te verán. Sal de la llamada y vuelve a entrar.",
  "rtc.screenOf": "Pantalla: {name}",
  "error.jwtHttp": "Servicio JWT: HTTP {status}",
  "space.notInRoomSpace": "{user} no pertenece al espacio de esta sala. Pide antes a un administrador que lo añada al espacio: solo entonces se le podrá invitar a salas y llamadas.",
  "timeline.roomNameChanged": "{actor} ha cambiado el nombre de la sala a «{name}»",
  "timeline.roomNameRemoved": "{actor} ha quitado el nombre de la sala",
  "timeline.roomTopicChanged": "{actor} ha cambiado el tema de la sala",
  "timeline.roomTopicRemoved": "{actor} ha quitado el tema de la sala",
  "timeline.roomAvatarChanged": "{actor} ha cambiado el avatar de la sala",
  "timeline.roomAvatarRemoved": "{actor} ha quitado el avatar de la sala",
  "timeline.memberInvited": "{actor} ha invitado a {subject} a la sala",
  "timeline.memberRenamed": "{oldName} ahora es {newName}",
  "timeline.memberAvatarChanged": "{subject} ha cambiado su avatar",
  "timeline.memberJoined": "{subject} se ha unido a la sala",
  "timeline.memberUnbanned": "{actor} ha desbloqueado a {subject}",
  "timeline.memberLeft": "{subject} ha salido de la sala",
  "timeline.memberKicked": "{actor} ha expulsado a {subject} de la sala{reason}",
  "timeline.memberBanned": "{actor} ha bloqueado a {subject}{reason}",
  "timeline.summaryJoined": "{names} se han unido a la sala",
  "timeline.summaryInvited": "{names} han sido invitados a la sala",
  "timeline.summaryLeft": "{names} han salido de la sala",
  "timeline.summaryKicked": "{names} han sido expulsados de la sala",
  "timeline.summaryBanned": "{names} han sido bloqueados",
  "timeline.summaryUnbanned": "{names} han sido desbloqueados",
  "timeline.namesTwo": "{first} y {second}",
  "timeline.namesThree": "{first}, {second} y {third}",
  "timeline.namesMoreOne": "{first}, {second} y {count} participante más",
  "timeline.namesMoreFew": "{first}, {second} y {count} participantes más",
  "timeline.namesMoreMany": "{first}, {second} y {count} participantes más",
  "profile.titleWithName": "Perfil — {name}",
  "common.sizeBytes": "{size} B",
  "common.sizeKb": "{size} KB",
  "common.sizeMb": "{size} MB",
  "space.membersTitle": "Miembros: {space}",
  "timeline.readUpToHere": "{name} ha leído hasta aquí",
  "timeline.attachmentDownload": "{info} · descargar",
  "timeline.threadLastSender": " · último: {name}",
  "timeline.durationMinutes": "{minutes} min",
  "timeline.durationHours": "{hours} h",
  "timeline.durationHoursMinutes": "{hours} h {minutes} min",
  "timeline.addReaction": "Reaccionar con {emoji}",
  "timeline.openThreadCount": "Abrir hilo · {count}",
  "call.ringBlocked": "el navegador ha bloqueado el sonido: {prefix}",
  "call.ringStarted": "sonido iniciado ({prefix})",
  "room.inviteAcceptFailed": "No se ha podido aceptar la invitación a «{room}»: {error}",
  "call.ongoingVideoInRoom": "📹 Videollamada en curso · {room}",
  "call.ongoingAudioInRoom": "📞 Llamada en curso · {room}",
  "call.incomingVideoFrom": "Videollamada entrante: {callers}",
  "call.incomingAudioFrom": "Llamada entrante: {callers}",
  "call.roomOngoingParticipants": "{room} · llamada en curso · {participants}",
  "media.downloadNamed": "Descargar {name}",
  "profile.fileFrom": "de {user}",
  "profile.loadFailed": "No se ha podido cargar: {error}",
  "dialog.domainLooksTruncated": "El dominio «{host}» parece incompleto",
  "dialog.removeEntry": "Quitar {id}",
  "room.yourPowerLevel": "Tu nivel de permisos: {level}. El servidor no aceptará un umbral superior a tu propio nivel.",
  "call.declinedBy": "{name} ha rechazado la llamada",
  "call.inCallOne": "Estás en la llamada · {count} participante",
  "call.inCallFew": "Estás en la llamada · {count} participantes",
  "call.inCallMany": "Estás en la llamada · {count} participantes",
  "member.actionsFor": "Acciones: {name}",
  "member.kickQuestion": "¿Expulsar a {name}?",
  "member.banQuestion": "¿Banear a {name}?",
  "member.roleFor": "Rol: {name}",
  "notification.cannotShowPermission": "no se puede mostrar: permission={permission}",
  "notification.showError": "error al mostrar: {error}",
  "profile.photoOf": "Foto: {name}",
  "profile.deviceAdded": "añadido {date}",
  "profile.renameDeviceNamed": "Cambiar el nombre de {device}",
  "profile.endSessionNamed": "Cerrar la sesión en {device}",
  "composer.micEnableFailed": "No se ha podido activar el micrófono: {error}",
  "space.notInAnySpace": "{user} no pertenece a ninguno de tus espacios. El chat directo solo es posible dentro de un espacio común: primero un administrador debe añadirlo.",
  "dialog.noSettingsPermissionRoom": "No tienes permiso para cambiar la configuración de esta sala.",
  "dialog.noSettingsPermissionSpace": "No tienes permiso para cambiar la configuración de este espacio.",
  "dialog.spaceSettings": "Configuración del espacio: {space}",
  "profile.masSessionNotFound": "No se ha encontrado una sesión activa del dispositivo {deviceId} en MAS; puede que ya esté finalizada. Actualice la lista y, si el dispositivo sigue ahí, vuelva a eliminarlo.",
  "rtc.deviceSwitchError": "No se ha podido cambiar el {device}: {error}",
  "profile.newDeviceOne": "Ha aparecido un dispositivo nuevo desde tu última visita: {devices}",
  "profile.newDeviceMany": "Han aparecido dispositivos nuevos desde tu última visita ({count}): {devices}",
  "profile.deviceCount": "Dispositivos: {count} de {limit}.",
  "room.levelValue": "nivel {level}",
  "thread.historyError": "No se ha terminado de cargar el historial del hilo: {error}",
  "thread.replyNotSent": "La respuesta no se ha enviado: {error}",
  "call.ringingWaitAnswer": "Llamando, esperando respuesta…",
  "call.noAnswerCountdown": "Nadie ha respondido · la llamada terminará en 0:{seconds}",
  "call.waitingCountdown": "Esperando respuesta · terminará en 0:{seconds}",
  "call.cameraFailed": "La cámara no se ha encendido: {error}",
  "call.screenShareFailed": "La pantalla compartida no se ha iniciado: {error}",
  "call.roomCallWithCount": "Hay una llamada en curso en esta sala · {count} {word}",
  "space.leaveRoomsOne": "Saldrá del espacio y de {count} sala dentro de él",
  "space.leaveRoomsFew": "Saldrá del espacio y de {count} salas dentro de él",
  "space.leaveRoomsMany": "Saldrá del espacio y de {count} salas dentro de él",
  "app.invitedBy": "Invitado por: {user}",
  "composer.voiceRecordingSeconds": "Grabando un mensaje de voz… {seconds} s",
  "media.slideBroken": "{icon} {name} — no se ha podido cargar",
  "media.slideBrokenError": "{icon} {name} — no se ha podido cargar: {error}",
  "room.attachmentBrokenNoError": "📎 {name} {size} — no se ha podido cargar",
  "composer.deleteRecording": "Eliminar grabación",
  "composer.recordingDuration": "Duración: {seconds} s",
  "composer.stopRecording": "Detener grabación",
  "composer.formattingToolbar": "Formato de texto",
  "composer.bold": "Negrita",
  "composer.italic": "Cursiva",
  "composer.underline": "Subrayado",
  "composer.strikethrough": "Tachado",
  "composer.textColorRed": "Color del texto: rojo",
  "composer.textColorOrange": "Color del texto: naranja",
  "composer.textColorGreen": "Color del texto: verde",
  "composer.textColorBlue": "Color del texto: azul",
  "composer.textColorPurple": "Color del texto: morado",
  "notification.messageSoundLabel": "Sonido de mensaje",
  "notification.callSoundLabel": "Sonido de llamada",
  "notification.previewSound": "Escuchar",
  "notification.roomModeLabel": "Modo de notificaciones",
  "notification.roomSoundLabel": "Sonido de este chat",
  "notification.soundDefault": "Predeterminado",
  "notification.soundSoft": "Suave",
  "notification.soundDouble": "Tono doble",
  "notification.soundChime": "Campanilla",
  "fontSize.default": "Predeterminado",
  "fontSize.label": "Tamaño del texto",
  "fontSize.large": "Grande",
  "fontSize.small": "Pequeño",
  "notification.acceptedUnverified": "La aplicación aceptó la solicitud, pero no se confirmó la visualización del sistema",
  "notification.appDisabled": "Las notificaciones del sistema están desactivadas en la aplicación",
  "notification.appEnabled": "Las notificaciones del sistema están activadas en la aplicación",
  "notification.categoriesTitle": "Tipos de notificación",
  "notification.categoryCalls": "Llamadas entrantes",
  "notification.categoryDirect": "Mensajes directos",
  "notification.categoryGroup": "Mensajes de grupo",
  "notification.categoryInvites": "Invitaciones a salas y espacios",
  "notification.categoryMentions": "Menciones y @room",
  "notification.categoryReactions": "Reacciones a mis mensajes",
  "notification.categoryReplies": "Respuestas e hilos",
  "notification.createdVerified": "La aplicación creó la notificación del sistema",
  "push.disable": "Desactivar",
  "push.disabled": "No están activadas para este dispositivo",
  "push.enable": "Activar notificaciones en segundo plano",
  "push.enabled": "Funciona incluso cuando la aplicación está cerrada",
  "push.notReady": "El servicio de notificaciones en segundo plano aún no está listo",
  "push.test": "Probar notificación en segundo plano",
  "push.testSent": "Notificación en segundo plano enviada",
  "push.title": "Notificaciones en segundo plano",
  "push.working": "Espera…",
  "room.groupsTab": "Grupos",
  "room.emptyGroups": "No hay chats grupales",
  "chat.private": "Chat privado",
  "chat.filterLabel": "Filtro: {value}",
  "chat.filterChats": "Filtrar chats",
  "chat.filters": "Filtros de chat",
  "chat.clearFilter": "Borrar filtro",
  "chat.messagePrivately": "Enviar mensaje privado",
  "profile.view": "Ver perfil",
  "chat.jumpToLatest": "Ir al mensaje más reciente",
  "chat.jumpToMention": "Ir a la mención",
  "settings.language": "Idioma",
  "server.main": "Principal",
  "server.stage": "Pruebas",
  "server.matrixPlaceholder": "matrix.example.com",
  "notification.background": "Notificaciones en segundo plano",
  "notification.notEnabledForDevice": "No habilitado para este dispositivo",
  "notification.enableBackground": "Activar las notificaciones en segundo plano",
  "notification.unsupportedRuntime": "Las notificaciones en segundo plano no son compatibles con el entorno de ejecución de esta aplicación.",
  "typing.one": "{name} está escribiendo",
  "typing.two": "{a} y {b} están escribiendo",
  "typing.more": "{a}, {b} y {count} más están escribiendo",
  "matrix.errorNetwork": "Sin conexión con el servidor. Comprueba tu red e inténtalo de nuevo.",
  "picker.busy": "La subida anterior aún está en curso, espere.",
  "picker.cancelled": "No se ha seleccionado ningún archivo.",
  "picker.chosen": "Archivo «{name}» seleccionado, subiendo…",
  "picker.done": "Listo, la imagen se ha subido.",
  "picker.failed": "No se ha podido subir: {error}",
  "picker.shellFailed": "La aplicación no ha podido obtener el archivo. Inténtelo de nuevo.",
  "picker.shellTooLarge": "El archivo «{name}» es demasiado grande: {size}, el límite es {limit}.",
  "picker.noDialog": "La pulsación se ha registrado, pero el sistema no ha abierto la ventana de archivos. Comunique esta línea al soporte.",
  "picker.noInput": "El campo de archivo no está listo. Vuelva a abrir la pantalla.",
  "picker.opening": "Abriendo el selector de archivos…",
  "search.error": "La búsqueda de mensajes ha fallado: {error}",
  "search.loadingMore": "Cargando más…",
  "search.messagesCount": "Mensajes · {count} encontrados",
  "search.messagesSection": "Mensajes",
  "search.more": "Mostrar más",
  "search.noMessages": "No se han encontrado mensajes para «{query}»",
  "search.resultAria": "Mensaje de {sender} en «{room}»",
  "search.retry": "Reintentar",
  "search.searching": "Buscando en el servidor…",
  "search.tooShort": "Escribe al menos 2 caracteres para buscar mensajes",
  "search.unknownRoom": "Sala desconocida",
  "app.sessionEndedTitle": "Tu sesión se ha cerrado en el servidor",
  "app.sessionEndedBody": "Este dispositivo se ha desconectado de la cuenta. Vuelve a iniciar sesión para continuar.",
  "profile.logoutProgress": "Cerrando sesión…",
  "profile.logoutRetry": "Reintentar cerrar sesión",
  "avatar.jpegOnly": "No se ha podido preparar la imagen. Pruebe con un archivo JPEG.",
  "avatar.decodeFailed": "No se ha podido abrir este archivo como imagen. Pruebe con JPEG o PNG.",
  "avatar.encodeFailed": "No se ha podido convertir la imagen a JPEG.",
  "ui.perevernut_kameru": "Voltear cámara",
  "call.labelSpeaker": "Altavoz",
  "call.labelScreenShare": "Pantalla",
  "call.labelInvite": "Invitar",
  "call.labelFlipCamera": "Girar",
  "call.labelCompose": "Escribir",
  "call.labelEnd": "Finalizar",
  "call.labelMicrophone": "Micrófono",
  "call.labelCamera": "Cámara",
  "message.forward": "Reenviar",
  "forward.title": "Reenviar a",
  "forward.unsupported": "Solo se pueden reenviar mensajes de texto.",
  "forward.failed": "No se pudo reenviar el mensaje: {error}",
  "update.title": "Actualización disponible",
  "update.body": "Hay una nueva versión de la aplicación: {version}.",
  "update.bodySize": "Hay una nueva versión de la aplicación: {version} · {size}.",
  "update.mandatoryNote": "Esta actualización es obligatoria para seguir usando la aplicación.",
  "update.now": "Actualizar",
  "update.later": "Más tarde",
};

export const ptBR: Messages = {
  "app.corporateLogin": "Entrar com a conta corporativa da ALG.",
  "app.errorLogin": "Falha ao entrar: {error}",
  "app.hideActionError": "Ocultar",
  "app.incomingCall": "Chamada recebida · {room}",
  "app.inviteNotice": "Você foi convidado para “{room}”",
  "app.inviteNoticeMore": "e mais {count}",
  "app.login": "Entrar",
  "app.logout": "Sair",
  "app.profile": "Perfil",
  "app.settings": "Configurações",
  "app.resetAndRestart": "Redefinir e começar de novo",
  "app.selectRoom": "Selecione uma sala à esquerda.",
  "app.serverChoose": "Escolher um servidor",
  "app.serverConnect": "Conectando ao servidor…",
  "app.serverConnectButton": "Conectar",
  "app.serverConnectDescription": "O aplicativo se conectará ao servidor selecionado. As sessões e os dispositivos são armazenados separadamente para cada servidor, então trocar de servidor não encerrará sua sessão no outro.",
  "app.serverCurrent": "atual",
  "app.serverCustom": "Outro endereço",
  "app.serverLabel": "Servidor: {server}",
  "app.serverProduction": "servidor de produção da ALG",
  "app.serverStaging": "staging, os dados podem ser alterados",
  "app.serverSwitch": "trocar",
  "app.serverUrlPlaceholder": "matrix.example.com",
  "app.sessionCheck": "Verificando a sessão…",
  "app.unavailableRoom": "A sala está indisponível ou você não é mais membro dela.",
  "call.accept": "Aceitar chamada",
  "call.callInProgress": "chamada em andamento",
  "call.captionRepliesEmpty": "Ainda não há respostas.",
  "call.decline": "Recusar chamada",
  "call.deviceCamera": "Câmera",
  "call.deviceDefault": "Padrão",
  "call.deviceFallback": "Dispositivo {count}",
  "call.deviceMicrophone": "Microfone",
  "call.deviceSpeaker": "Alto-falante",
  "call.copyDiagnostics": "Copiar diagnóstico da chamada",
  "call.diagnosticsCopied": "Diagnóstico copiado",
  "call.diagnosticsCopyFailed": "Não foi possível copiar o diagnóstico",
  "call.goToRoom": "Ir para a sala",
  "call.goToRoomHint": "Ir para a sala sem atender à chamada",
  "call.videoCallInProgress": "videochamada em andamento",
  "common.accept": "Aceitar",
  "common.cancel": "Cancelar",
  "common.close": "Fechar",
  "common.create": "Criar",
  "common.decline": "Recusar",
  "common.done": "Concluído",
  "common.hide": "Ocultar",
  "common.invite": "Convidar",
  "common.inviteShort": "+ Convidar",
  "common.leave": "Sair da sala",
  "common.messageEdited": " (editada)",
  "common.messageNotSent": " · não enviada",
  "common.messageSending": " · enviando…",
  "common.noMessages": "Ainda não há mensagens.",
  "common.remove": "Excluir",
  "common.roomStart": "início da sala",
  "common.save": "Salvar",
  "common.search": "Pesquisar",
  "common.yesDelete": "Sim, excluir",
  "composer.attachFile": "Anexar arquivo",
  "composer.attachImage": "Anexar imagem",
  "composer.attachMenu": "Anexos",
  "composer.attachTitle": "Anexar arquivo",
  "composer.cancelEdit": "Cancelar edição",
  "composer.cancelReply": "Cancelar resposta",
  "composer.disabledPlaceholder": "Você não pode escrever nesta sala",
  "composer.dropFiles": "Solte os arquivos aqui",
  "composer.editing": "Editando mensagem",
  "composer.emoji": "Emoji",
  "composer.fileUploadProgress": "Enviando arquivo… {percent}%",
  "composer.mentionAll": "Sala inteira",
  "composer.mentionInvited": "convidado",
  "composer.reply": "Responder a {user}",
  "composer.sendButton": "Enviar",
  "composer.sendError": "Não foi possível enviar: {error}",
  "composer.textPlaceholder": "Mensagem… (Enter para enviar, Shift+Enter para quebrar linha)",
  "dialog.avatarOfRoom": "Avatar da sala",
  "dialog.avatarOfSpace": "Avatar do espaço",
  "dialog.createProgress": "Criando…",
  "dialog.declineDescription": "O convite para “{room}” será recusado. Se você receber outro convite, a sala aparecerá novamente.",
  "dialog.declineProgress": "Recusando…",
  "dialog.declineTitle": "Recusar convite?",
  "dialog.dmAllSpacesHint": "Os membros de todos os seus espaços são exibidos. Você só pode iniciar uma conversa direta com pessoas que compartilham um espaço com você.",
  "dialog.dmDescription": "A pesquisa por nome ainda não está disponível: digite o ID completo no formato @username:algsuccess.com. A pessoa receberá um convite.",
  "dialog.dmIdLabel": "ID do Matrix do contato",
  "dialog.dmSpaceHint": "Os membros do espaço selecionado são exibidos. Para ver todos, troque para “Início” na barra à esquerda.",
  "dialog.dmTitle": "Nova conversa direta",
  "dialog.historyHint": "“A partir do momento em que entrarem” significa que um novo membro verá o histórico a partir da entrada. “Somente a partir do momento em que entrarem” significa que não verá nada anterior à entrada. Essa alteração não é retroativa para membros que já entraram.",
  "dialog.historyJoined": "Somente a partir do momento em que entrarem (novos membros não podem ver o passado)",
  "dialog.historyShared": "A partir do momento em que entrarem (novos membros veem o histórico desde a entrada)",
  "dialog.historyVisibility": "Visibilidade do histórico",
  "dialog.historyWho": "Quem pode ver o histórico",
  "dialog.inviteDone": "Convite enviado: {user}",
  "dialog.inviteIdLabel": "ID do Matrix",
  "dialog.inviteProgress": "Convidando…",
  "dialog.inviteSent": "Convite enviado: {user}",
  "dialog.inviteSpaceDescription": "A pessoa convidada verá as salas públicas do espaço e todos os seus membros. As salas apenas para convidados continuarão ocultas até que ela seja convidada para cada uma separadamente.",
  "dialog.inviteSpaceTitle": "Convidar para o espaço “{space}”",
  "dialog.inviteOutsideSpaceWarning": "{user} não faz parte do espaço desta sala. Você ainda pode enviar o convite, mas a pessoa permanecerá fora do espaço — um administrador deve adicioná-la separadamente.",
  "dialog.inviteSuggestEmpty": "Nenhuma correspondência — verifique a grafia ou digite o ID completo.",
  "dialog.inviteSuggestNone": "Não há mais sugestões: todas as pessoas que você pode convidar já estão na sala. Digite o ID completo no formato @username:algsuccess.com.",
  "dialog.inviteTitle": "Convidar para “{room}”",
  "dialog.joinByInvite": "Por convite",
  "dialog.joinMode": "Modo de entrada",
  "dialog.joinRoom": "Entrar na sala",
  "dialog.joinSpace": "Entrar no espaço",
  "dialog.leaveDescription": "Você sairá de “{room}”. O histórico permanecerá no servidor, mas você não poderá mais acessá-lo. Você só poderá voltar a uma sala privada com um novo convite.",
  "dialog.leaveProgress": "Saindo…",
  "dialog.leaveTitle": "Sair da sala?",
  "dialog.matrixIdBadDomain": "Caracteres inválidos no endereço do servidor",
  "dialog.matrixIdCyrillic": "Isto parece um teclado russo — troque para o inglês",
  "dialog.matrixIdInvalidLocalpart": "Os nomes de usuário podem conter apenas letras latinas, números e . _ - = + /",
  "dialog.matrixIdInvalidPrefix": "Um ID do Matrix começa com @",
  "dialog.matrixIdInvalidSpaces": "Os IDs do Matrix não podem conter espaços",
  "dialog.matrixIdMissingServer": "Falta o servidor depois dos dois-pontos, por exemplo @ivanov:algsuccess.com",
  "dialog.matrixIdMissingServerAddress": "O endereço do servidor depois dos dois-pontos está vazio",
  "dialog.matrixIdNoDomain": "O endereço do servidor não tem domínio, por exemplo algsuccess.com",
  "dialog.moveRoomCurrentHome": "A sala está atualmente fora dos espaços (“Início”).",
  "dialog.moveRoomCurrentSpace": "A sala está atualmente no espaço “{space}”.",
  "dialog.moveRoomEmpty": "Não há para onde movê-la: você não tem espaços onde possa gerenciar membros. Peça a um administrador do espaço para movê-la ou aumentar seu nível de permissão.",
  "dialog.moveRoomLabel": "Mover para",
  "dialog.moveRoomProgress": "Movendo…",
  "dialog.moveRoomTitle": "Mover “{room}”",
  "dialog.newName": "Novo nome",
  "dialog.newRoomDescription": "Visível no diretório do servidor; qualquer funcionário pode entrar. Sem a caixa de seleção, será apenas para convidados.",
  "dialog.newRoomNameLabel": "Nome",
  "dialog.newRoomNamePlaceholder": "Por exemplo: Release 2.4",
  "dialog.newRoomTitle": "Nova sala",
  "dialog.newSpaceTitle": "Novo espaço",
  "dialog.newTopic": "Novo tópico",
  "dialog.noSettingsPermission": "Você não tem permissão para alterar as configurações de {kind}.",
  "dialog.publicJoin": "Público (qualquer pessoa pode entrar)",
  "dialog.publicRoomDescription": "Visível no diretório do servidor; qualquer funcionário pode entrar. Sem a caixa de seleção, será apenas para convidados.",
  "dialog.publicRoomHint": "Uma sala pública fica visível no diretório do servidor e qualquer pessoa pode entrar. Salas apenas para convidados só podem ser acessadas por convite de um membro.",
  "dialog.publicRoomLabel": "Sala pública",
  "dialog.publicSpaceHint": "Um espaço público fica visível no diretório do servidor e qualquer pessoa pode entrar. Espaços apenas para convidados só podem ser acessados por convite de um membro.",
  "dialog.roomCreatedInHome": "A sala será criada fora dos espaços (“Início”). Você poderá convidar qualquer usuário.",
  "dialog.roomCreatedInSpace": "A sala será criada no espaço “{space}”.",
  "dialog.roomLeaveBlocked": "Você não pode sair do espaço “{room}”. {reason}",
  "dialog.roomLeaveSpaceDescription": "Você sairá do espaço “{room}”. As salas dele desaparecerão da sua lista, e você só poderá voltar com um novo convite.",
  "dialog.roomLeaveSpaceTitle": "Sair do espaço?",
  "dialog.roomSettings": "Configurações da sala: {room}",
  "dialog.roomTargetHome": "A sala será criada fora dos espaços (“Início”). Você poderá convidar qualquer usuário.",
  "dialog.roomTargetSpace": "A sala será criada no espaço “{space}”.",
  "dialog.selectedSpace": "espaço selecionado",
  "dialog.spaceCreatedInviteFailed": "Espaço criado, mas os convites falharam: {users}",
  "dialog.spaceDescription": "Um espaço reúne salas e pessoas. Os membros do espaço veem suas salas públicas e todos os seus membros; as salas apenas para convidados permanecem ocultas até um convite separado.",
  "dialog.spaceInviteAction": "Convidar para o espaço…",
  "dialog.spaceLeaveAction": "Sair do espaço…",
  "dialog.spaceMemberPlaceholder": "Nome ou @user:algsuccess.com",
  "dialog.spaceMembersAction": "Membros do espaço…",
  "dialog.spaceMembersLabel": "Membros (opcional)",
  "dialog.spaceNameLabel": "Nome",
  "dialog.spaceSettingsTitle": "Configurações do espaço",
  "dialog.spaceTopicLabel": "Descrição (opcional)",
  "dialog.spaceTopicPlaceholder": "Sobre o que é este espaço",
  "dialog.topicUnset": "(não definido)",
  "dialog.understood": "Entendi",
  "dialog.untitled": "(sem título)",
  "emoji.loadFailed": "Não foi possível carregar a lista de emojis.",
  "emoji.loading": "Carregando emojis…",
  "emoji.recent": "Recentes",
  "emoji.search": "Pesquisar emoji",
  "error.backToChats": "Voltar às conversas",
  "error.renderStopped": "O aplicativo encontrou um erro e parou de renderizar esta tela. Todo o resto está funcionando — você pode voltar à lista de conversas.",
  "error.somethingBroken": "Algo deu errado",
  "matrix.authCallbackMissingFlow": "Recebemos um retorno OIDC, mas não há contexto do fluxo — inicie o login novamente.",
  "matrix.authRefused": "O MAS recusou a autorização: {error} — {description}",
  "matrix.authStateMismatch": "O estado OIDC não corresponde — cancelando o login.",
  "matrix.errorAttachmentLink": "Não foi possível abrir o anexo: o servidor não retornou um link.",
  "matrix.errorAttachmentServer": "o servidor respondeu {status}",
  "matrix.errorForbidden": "Permissões insuficientes: {detail}",
  "matrix.errorNotFound": "Não encontrado: {detail}",
  "matrix.errorRateLimit": "O servidor está limitando a frequência das solicitações. Tente novamente em um minuto.",
  "matrix.profileMissingUserId": "O ID do usuário do cliente não foi encontrado",
  "matrix.sessionRejected": "A sessão armazenada foi rejeitada pelo servidor: {error}",
  "media.download": "Baixar",
  "media.loading": "carregando…",
  "media.next": "Próximo",
  "media.openInBrowser": "Abrir no navegador",
  "media.previous": "Anterior",
  "media.share": "Compartilhar",
  "member.admin": "Administrador",
  "member.ban": "Banir",
  "member.banAction": "Banir",
  "member.banned": "Banidos · {count}",
  "member.bannedCount": "Banidos · {count}",
  "member.changeRole": "Alterar função",
  "member.changeRoleAction": "Alterar função",
  "member.close": "✕",
  "member.count": "Membros · {count}",
  "member.invite": "+ Convidar",
  "member.invited": "Convidados · {count}",
  "member.invitedCount": "Convidados · {count}",
  "member.invitedUser": "convidado · {user}",
  "member.justNow": "entrou agora",
  "member.kick": "Remover",
  "member.kickAction": "Remover",
  "member.lastActive": "esteve ativo há {count} min",
  "member.lastActiveDays": "esteve ativo há {count} dias",
  "member.lastActiveHours": "esteve ativo há {count} horas",
  "member.leaveSelfWarning": "Você não pode sair do espaço: é o último administrador.",
  "member.mismatch": "O servidor informa {serverCount} membros que entraram, mas {loaded} foram carregados. Parte do estado da sala ainda não foi carregada.",
  "member.moderator": "moderador",
  "member.notLoaded": "A lista de membros não foi carregada.",
  "member.online": "online",
  "member.onlineStatus": "online",
  "member.participants": "Participantes · {count}",
  "member.role": "Função",
  "member.roleAdministrator": "Administrador",
  "member.roleModerator": "Moderador",
  "member.roleParticipant": "Participante",
  "member.unban": "Desbanir",
  "member.unbanAction": "Desbloquear",
  "member.you": "você",
  "notification.allow": "Permitir notificações",
  "notification.apiMissing": "A API de notificações não está disponível neste navegador",
  "notification.browserRejected": "o navegador recusou a solicitação",
  "notification.browserStatus": "Notificações do navegador: {status}.",
  "notification.deniedHint": "As notificações estão bloqueadas pelo navegador — o aplicativo não pode desbloqueá-las. No Safari, acesse Ajustes → Sites → Notificações; no Chrome, acesse Configurações → Privacidade → Configurações do site → Notificações.",
  "notification.mobileHint": "No iPhone/iPad, as notificações só estão disponíveis se o site for adicionado à Tela de Início (Compartilhar → “Adicionar à Tela de Início”, iOS 16.4+). Os sons de chamadas e os banners no aplicativo funcionam sem isso.",
  "notification.sent": "enviada ao navegador",
  "notification.settingsTitle": "Configurações de notificações",
  "notification.statusDefault": "ainda não solicitadas",
  "notification.statusDenied": "bloqueadas pelo navegador",
  "notification.statusGranted": "permitidas",
  "notification.statusUnsupported": "não compatíveis com este navegador",
  "notification.test": "Mostrar notificação de teste",
  "notification.testBody": "Notificação de teste. Se você consegue vê-la, tudo está funcionando.",
  "profile.addDevice": "Adicionar dispositivo",
  "profile.addDeviceCodeHint": "Digite este código no novo dispositivo:",
  "profile.allChats": "Todas as conversas",
  "profile.appearance": "Aparência",
  "profile.changePhoto": "Alterar foto",
  "profile.clickToRename": "Clique para alterar o nome",
  "profile.close": "Fechar",
  "profile.closeCabinet": "Fechar perfil",
  "profile.codeValid": "Código válido por: {time}",
  "profile.deleteCurrentDeviceQuestion": "Excluir este dispositivo e sair. O aplicativo pedirá que você entre novamente. Continuar?",
  "profile.deleteDeviceQuestion": "Excluir o dispositivo “{device}”? Todas as sessões nele serão encerradas.",
  "profile.deviceActive": "ativo {date}",
  "profile.deviceCurrent": "este dispositivo",
  "profile.deviceNameLabel": "Nome do dispositivo",
  "profile.deviceNamePlaceholder": "Por exemplo: MacBook, celular",
  "profile.deviceSessions": "{count} sessões",
  "profile.devices": "Dispositivos",
  "profile.devicesUnknownActivity": "atividade desconhecida",
  "profile.displayName": "Nome de exibição",
  "profile.filesScopeHint": "Arquivos e mídias das conversas já carregadas são exibidos, e a pesquisa funciona entre eles. Ainda não temos um arquivo completo no servidor com todos os anexos — isso é uma tarefa separada do servidor.",
  "profile.filesSearchAria": "Pesquisar arquivos e mídias",
  "profile.filesSearchPlaceholder": "Pesquisar por nome de arquivo ou legenda",
  "profile.filesTab": "Arquivos",
  "profile.finishLoginQuestion": "Concluir o login em “{device}”?",
  "profile.imageRequired": "É necessária uma imagem (PNG, JPEG etc.)",
  "profile.lightTheme": "Claro",
  "profile.loadingDevices": "Carregando dispositivos…",
  "profile.logout": "Sair",
  "profile.logoutConfirm": "Sim, sair",
  "profile.logoutQuestion": "Sair deste dispositivo?",
  "profile.mediaTab": "Mídia",
  "profile.multipleSessionsHint": "Várias sessões de um dispositivo; se alguma não for sua, encerre-a.",
  "profile.myFiles": "Meus arquivos e mídias",
  "profile.newCode": "Obter novo código",
  "profile.noMedia": "Não há imagens ou vídeos nas conversas carregadas.",
  "profile.noOtherFiles": "Não há arquivos de outras pessoas nas conversas carregadas.",
  "profile.noOwnFiles": "Não há arquivos seus nas conversas carregadas.",
  "profile.noSearchResults": "Nada foi encontrado para esta pesquisa. A pesquisa funciona entre as conversas já carregadas.",
  "profile.notifications": "Notificações",
  "profile.notificationsEnabled": "As notificações estão ativadas. As regras de silêncio (sem som para salas públicas) são aplicadas automaticamente.",
  "profile.notificationsUnsupported": "Este navegador não é compatível com notificações.",
  "profile.openOnNewDevice": "Abra no novo dispositivo:",
  "profile.openPhoto": "Abrir foto em tela cheia",
  "profile.permissionDenied": "bloqueadas pelo navegador",
  "profile.permissionGranted": "ativadas",
  "profile.permissionNotAsked": "não solicitadas",
  "profile.permissionUnsupported": "não compatíveis",
  "profile.personalCabinet": "Perfil",
  "profile.photo": "Foto do perfil",
  "profile.photoNotSet": "Nenhuma foto definida",
  "profile.renameDevice": "Renomear este dispositivo",
  "profile.resetDeviceName": "Redefinir nome",
  "profile.saving": "Salvando…",
  "profile.searchResults": "{count} encontrados",
  "profile.sharedFiles": "Arquivos e mídias compartilhados",
  "profile.switchServer": "trocar",
  "profile.title": "Perfil",
  "profile.uploadPhoto": "Enviando foto…",
  "room.acceptInviteMenu": "Aceitar convite",
  "room.add": "Adicionar",
  "room.attachmentBroken": "📎 {name} {size} — falha ao carregar: {error}",
  "room.attachmentLoading": "📎 {name} — carregando…",
  "room.callAlreadyIn": "Você já está em uma chamada",
  "room.callCamera": "Câmera",
  "room.callConnecting": "Conectando…",
  "room.callDecline": "Recusar chamada",
  "room.callIncoming": "Chamada recebida",
  "room.callLeave": "Encerrar chamada",
  "room.callMuted": "Microfone desligado",
  "room.callParticipants": "chamada em andamento · {count} participantes",
  "room.captionEnable": "Ativar legendas",
  "room.captions": "Legendas",
  "room.collapseList": "Recolher a lista de conversas",
  "room.expandList": "Expandir a lista de conversas",
  "room.chatsCount": "Conversas: {visible} de {joined}",
  "room.declineInviteMenu": "Recusar convite",
  "room.download": "Baixar",
  "room.emptyFavourites": "Não há conversas favoritas. Clique com o botão direito em uma conversa → “Adicionar aos favoritos”.",
  "room.emptyOutsideSpaces": "Ainda não há nada aqui",
  "room.emptyPeople": "Não há conversas diretas",
  "room.emptySearch": "Nada encontrado para “{query}”",
  "room.emptySpace": "Este espaço não tem salas em que você entrou",
  "room.emptyUnread": "Não há conversas não lidas",
  "room.encryptedBadge": "Criptografia de ponta a ponta ativada",
  "room.encryptedNotice": "As mensagens nesta sala são criptografadas (E2EE).\nEste cliente deliberadamente não as lê: a criptografia está desativada aqui. O envio também não está disponível — outros clientes rejeitarão uma mensagem não criptografada em uma sala criptografada. Use o Element para esta sala.",
  "room.encryptedPreview": "Mensagem criptografada",
  "room.encryptionPageDisabled": "A criptografia está desativada: a sala não é criptografada, e o suporte a E2EE está deliberadamente desativado neste cliente. Não é possível ativá-lo aqui.",
  "room.encryptionPageEnabled": "A sala é criptografada (E2EE), mas este cliente não oferece suporte à criptografia — ela está desativada. Leia esta sala no Element. Não é possível ativar a criptografia aqui.",
  "room.favourite": "favorita",
  "room.favouriteButton": "☆ Adicionar aos favoritos",
  "room.favouriteMenu": "Adicionar aos favoritos",
  "room.favouritedButton": "★ Nos favoritos",
  "room.favouritesTab": "Favoritos",
  "room.headerCallJoin": "Entrar na chamada",
  "room.headerCallLeave": "Sair da chamada",
  "room.headerCallStart": "Iniciar chamada",
  "room.headerOpenPage": "Abrir página da sala",
  "room.headerVideoJoin": "Entrar na chamada com vídeo",
  "room.headerVideoStart": "Iniciar videochamada",
  "room.historyError": "O carregamento do histórico não terminou: {error}",
  "room.historyLoading": "Carregando histórico…",
  "room.homeLabel": "Início — conversas fora dos espaços",
  "room.homeTab": "Início",
  "room.insufficientPermissions": "Permissões insuficientes",
  "room.inviteMenu": "Convidar membro…",
  "room.inviteNotice": "Este é um convite. Selecione “Aceitar” no cabeçalho para entrar na sala ou “Recusar” para removê-la da lista. O conteúdo da sala não é exibido antes de você entrar.",
  "room.inviteNoticeMore": "e mais {count}",
  "room.invitePreview": "Convite para a sala",
  "room.invitesCount": "Convites · {count}",
  "room.leaveMenu": "Sair da sala…",
  "room.loadOlder": "↑ role para cima para carregar o histórico",
  "room.loadingChats": "Carregando conversas…",
  "room.loadingShort": "Carregando…",
  "room.mediaFound": "{count} encontrados",
  "room.memberCount": "{count} membros · {roomId}",
  "room.members": "Membros",
  "room.mentioned": "você foi mencionado",
  "room.waitingChip": "Esperando por mim",
  "room.emptyWaiting": "Ninguém está esperando por você",
  "room.waitingChipAria": "Esperando por mim: {count}",
  "room.mentionsTab": "Menções",
  "room.messageLinkMiss": "A mensagem vinculada é mais antiga que o histórico carregado. Role para cima para carregar mais; ela aparecerá então.",
  "room.newDm": "+ Conversa direta",
  "room.newRoom": "+ Sala",
  "room.noMessagesPreview": "Nenhuma mensagem",
  "room.noResults": "Nada encontrado para esta pesquisa",
  "room.notificationSettings": "Notificações",
  "room.notificationsCurrent": "Notificações: {mode}",
  "room.notificationsMenu": "Notificações ▾",
  "room.notifyAll": "Todas as mensagens",
  "room.notifyAllHint": "notificar sobre todas as mensagens",
  "room.notifyMentions": "Somente menções",
  "room.notifyMentionsHint": "ficar em silêncio até mencionarem você",
  "room.notifyNone": "Nenhuma",
  "room.notifyNoneHint": "silêncio, inclusive para menções",
  "room.openMembers": "Abrir lista de membros",
  "room.openSettings": "Abrir configurações da sala",
  "room.pageLabel": "Página da sala",
  "room.peopleTab": "Pessoas",
  "room.railAria": "Espaços",
  "room.receiptError": "Não foi possível enviar a confirmação de leitura: {error}",
  "room.removeFavourite": "Remover dos favoritos",
  "room.roomPage": "Página da sala",
  "room.roomSettings": "Configurações da sala",
  "room.scanBusy": "verificando…",
  "room.scanComplete": "Todo o histórico foi visualizado.",
  "room.scanCount": "{count} mensagens visualizadas.",
  "room.scanDeeper": "pesquisar mais profundamente",
  "room.searchAria": "Pesquisar conversas",
  "room.searchPlaceholder": "Pesquisar",
  "room.sectionChats": "Conversas",
  "room.sectionFavourites": "Favoritos",
  "room.sidebarAria": "Lista de conversas",
  "room.spaceCreate": "+ Espaço",
  "room.mobileCreateTitle": "Criar",
  "room.mobileCreateRoom": "Sala",
  "room.mobileCreateDm": "Conversa privada",
  "room.mobileCreateSpace": "Espaço",
  "room.spaceEmpty": "Este espaço não tem salas em que você entrou",
  "room.spaceLeave": "Sair do espaço",
  "room.spaceMembers": "Membros do espaço",
  "room.spaceRename": "Configurações do espaço",
  "room.tabFiles": "Arquivos",
  "room.tabLinks": "Links",
  "room.tabMedia": "Mídia",
  "room.tabMembers": "Membros",
  "room.tabVoice": "Mensagens de voz",
  "room.unfavouriteMenu": "Remover dos favoritos",
  "room.unreadTab": "Não lidas",
  "room.you": "você",
  "space.admin": "administrador",
  "space.invited": "convidado",
  "space.membersNotFound": "Espaço não encontrado nos dados carregados. Atualize a página.",
  "space.partialRemoval": "Não foi removido de todos os lugares. Restantes: {rooms}",
  "space.removeQuestion": "Remover {user} do espaço?",
  "space.removeSummary": "Essa pessoa sairá do espaço e das suas {count} salas. As salas e as conversas permanecerão no lugar — nada será excluído. Uma sala em que vocês eram dois permanecerá com um membro e todo o histórico. Você poderá convidar a pessoa novamente a qualquer momento.",
  "space.removed": "{user} removido do espaço e das suas salas ({count}).",
  "space.you": "você",
  "thread.loadOlder": "↑ role para cima para carregar o histórico",
  "thread.noReplies": "Ainda não há respostas.",
  "thread.sendError": "Não foi possível enviar a resposta: {error}",
  "thread.start": "início do tópico",
  "thread.title": "Tópico",
  "timeline.attachmentFallback": "arquivo",
  "timeline.attachmentNotLoaded": "não carregado",
  "timeline.audioOpen": "Abrir no visualizador",
  "timeline.callActive": "Chamada em andamento",
  "timeline.callDecline": "Recusar",
  "timeline.callDuration": "Duração: {duration}",
  "timeline.callFinished": "Chamada encerrada",
  "timeline.callJoin": "Entrar",
  "timeline.callParticipantsCount": "Participantes: {count}",
  "timeline.copyLink": "Copiar link",
  "timeline.dayToday": "hoje",
  "timeline.dayYesterday": "ontem",
  "timeline.delete": "Excluir",
  "timeline.downloadFile": "Baixar arquivo",
  "timeline.downloading": "Baixando…",
  "timeline.edit": "Editar",
  "timeline.emote": "* {user} {body}",
  "timeline.historyBeginning": "início da sala",
  "timeline.loadOlder": "↑ Carregar mais",
  "timeline.noMessages": "Ainda não há mensagens.",
  "timeline.openViewer": "Abrir no visualizador",
  "timeline.reaction": "Reação",
  "timeline.repliesFew": "{count} respostas",
  "timeline.repliesMany": "{count} respostas",
  "timeline.repliesOne": "{count} resposta",
  "timeline.reply": "Responder",
  "timeline.senderMe": "Você",
  "timeline.senderUnknown": "desconhecido",
  "timeline.share": "Compartilhar",
  "ui.zakryt_esc": "Fechar (Esc)",
  "ui.nuzhna_kartinka_png_jpeg_i_t_p": "É necessária uma imagem (PNG, JPEG etc.)",
  "ui.bez_imeni": "sem nome",
  "ui.limit_poka_ne_deystvuet_servernaya_chast": " O limite ainda não está ativo: o servidor está em desenvolvimento.",
  "ui.ustroystvo_bez_imeni": "Dispositivo sem nome",
  "ui.udalit_eto_ustroystvo_vyhod_iz_akkaunta": "Remover este dispositivo (sair da conta)",
  "ui.udalit_eto_ustroystvo": "Remover este dispositivo",
  "ui.udalit_ustroystvo": "Remover dispositivo",
  "ui.udalyayu": "Removendo…",
  "ui.da_zavershit": "Sim, encerrar",
  "ui.ustroystvo": "dispositivo",
  "ui.zavershit_etot_vhod": "Encerrar esta sessão",
  "ui.filtr_po_chatu": "Filtrar por conversa",
  "ui.gotovlyu_fayl": "Preparando arquivo…",
  "ui.vas_ni_v_ch_m_ne_upominali": "Você não foi mencionado",
  "ui.home_chaty_vne_prostranstv": "Home — conversas fora dos espaços",
  "ui.sozdat_prostranstvo": "Criar espaço",
  "ui.v_istorii_komnaty_ne_naydeno_kartinok_i": "Nenhuma imagem ou vídeo encontrado no histórico da sala",
  "ui.my_prosmotreli_tolko_chast_istorii_nazhm": "Vimos apenas parte do histórico — clique em “buscar mais profundamente” abaixo.",
  "ui.kb": "KB",
  "ui.mb": "MB",
  "ui.gb": "GB",
  "ui.v_istorii_komnaty_ne_naydeno_faylov": "Nenhum arquivo encontrado no histórico da sala",
  "ui.v_istorii_komnaty_ne_naydeno_ssylok": "Nenhum link encontrado no histórico da sala",
  "ui.v_istorii_komnaty_ne_naydeno_golosovyh": "Nenhuma mensagem de voz encontrada no histórico da sala",
  "ui.etot_brauzer_ne_dal_pereklyuchit_dinamik": "Este navegador não conseguiu trocar o alto-falante. O som permaneceu no dispositivo anterior.",
  "ui.ne_udalos_pereklyuchit_ustroystvo_ostalo": "Não foi possível trocar o dispositivo — o anterior permanece.",
  "ui.mikrofon": "microfone",
  "ui.kameru": "câmera",
  "ui.dinamik": "alto-falante",
  "ui.vybrannoe_ranee": "selecionado anteriormente",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne": "Chamadas em salas criptografadas ainda não são compatíveis. ",
  "ui.sozdayte_obychnuyu_komnatu_ili_dozhdites_o": "Crie uma sala comum ou aguarde uma atualização.",
  "ui.mikrofon_ne_dal_audiodorozhku": "O microfone não forneceu uma faixa de áudio",
  "ui.kamera_ne_dala_videodorozhku": "A câmera não forneceu uma faixa de vídeo",
  "ui.jwt_servis_v_otvete_net_url_jwt": "Serviço JWT: a resposta não contém url/jwt",
  "ui.brauzer_ne_dal_videodorozhku_ekrana": "O navegador não forneceu uma faixa de vídeo da tela",
  "ui.ekran_vy": "Tela: você",
  "ui.demonstraciya_ekrana_ne_nachalas_dostup_n": "O compartilhamento de tela não começou: acesso não concedido",
  "ui.brauzer_ne_umeet_zapisyvat_opus": "O navegador não consegue gravar opus",
  "ui.slishkom_korotko": "Curto demais",
  "ui.golosovoe_dlinnee_5_minut": "Mensagem de voz com mais de 5 minutos",
  "ui.dostup_k_mikrofonu_zapresch_n": "Acesso ao microfone negado",
  "ui.priglash_n_no_esch_ne_vosh_l_uvedomlenie_pri": "Convidado, mas ainda não entrou — a notificação chegará após a entrada",
  "ui.redaktiruyte_soobschenie": "Edite a mensagem…",
  "ui.otvet": "Responder…",
  "ui.soobschenie_upomyanut_enter_otpravit": "Mensagem… (@ — mencionar, Enter — enviar)",
  "ui.otpravit_fayl": "Enviar arquivo",
  "ui.uchastniki_komnaty": "Membros da sala",
  "ui.isklyuchit_iz_komnaty": "Remover da sala",
  "ui.zabanit": "Banir",
  "ui.izmenit_prava": "Alterar permissões",
  "ui.prichina_neobyazatelno_vidna_drugim_uchast": "Motivo (opcional, visível para outros membros)",
  "ui.naprimer_flud": "Por exemplo: flood",
  "ui.naprimer_spam": "Por exemplo: spam",
  "ui.snyat_ban": "Desbanir?",
  "ui.net_userid_klienta": "sem userId do cliente",
  "ui.ustroystvo_2": "Dispositivo",
  "ui.yandeks_brauzer": "Yandex Browser",
  "ui.brauzer": "navegador",
  "ui.net_access_token": "sem access token",
  "ui.net_client_id_sessiya_ne_oidc": "sem client_id — a sessão não é OIDC",
  "ui.net_device_id": "sem device_id",
  "ui.mas_graphql_endpoint_ne_obyavlen": "MAS GraphQL endpoint não declarado",
  "ui.device_authorization_endpoint_ne_obyavle": "Device authorization endpoint não declarado",
  "ui.token_endpoint_ne_obyavlen": "Token endpoint não declarado",
  "ui.polzovatel_otklonil_avtorizaciyu": "O usuário recusou a autorização",
  "ui.kod_ist_k": "Código expirado",
  "ui.vremya_ozhidaniya_isteklo": "Tempo limite esgotado",
  "ui.id_t_demonstraciya_vashego_ekrana": "Você está compartilhando sua tela",
  "ui.vernutsya_v_zvonok": "Voltar à chamada",
  "ui.vyklyuchit_mikrofon": "Silenciar microfone",
  "ui.vklyuchit_mikrofon": "Ativar microfone",
  "ui.vyklyuchit_kameru": "Desligar câmera",
  "ui.vklyuchit_kameru": "Ligar câmera",
  "ui.otmenit_zvonok": "Cancelar chamada",
  "ui.brauzer_otklonil_pokaz_onerror": "o navegador recusou a exibição (onerror)",
  "ui.api_otsutstvuet": " · API indisponível",
  "ui.uchastnik": "participante",
  "ui.uchastnikov": "participantes",
  "ui.bez_administratora_prostranstvom_nelzya": "Sem administrador, o espaço não poderá ser gerenciado: não será possível convidar, ",
  "ui.ni_dobavit_komnatu_ni_izmenit_nastroyk": "adicionar uma sala nem alterar as configurações. Primeiro nomeie outro ",
  "ui.administratora_ili_udalite_ostalnyh_ucha": "administrador ou remova os outros membros.",
  "ui.izmenenie_sobstvennogo_urovnya_prav_zdes": "Não é permitido alterar seu próprio nível de permissão aqui",
  "ui.net_eventid_u_redaktiruemogo_soobscheniya": "a mensagem editada não tem eventId",
  "ui.net_eventid_dlya_redact": "sem eventId para redact",
  "ui.otklonit_zvonok_zvonyaschiy_uznaet_ob_otka": "Recusar chamada — o chamador saberá que foi recusada",
  "ui.staree": "Mais antigo (←)",
  "ui.novee": "Mais recente (→)",
  "ui.udaleno_ne_vezde_ostalos": "Não foi excluído em todos os lugares. Restam: ",
  "ui.komnaty": "chats",
  "ui.komnat": "salas",
  "ui.ne_udalos_postroit_ssylku_iz_mxc": "não foi possível criar o link a partir de mxc://",
  "ui.nedostatochno_prav_dlya_otpravki_soobscheniy": "Você não tem permissão para enviar mensagens neste chat",
  "ui.redaktiruemoe_soobschenie_ne_naydeno_v_len": "A mensagem que está sendo editada não foi encontrada na linha do tempo",
  "ui.soobschenie_na_kotoroe_vy_otvechaete_ne_nay": "A mensagem à qual você está respondendo não foi encontrada na linha do tempo",
  "ui.zvonki_v_zashifrovannyh_komnatah_poka_ne_2": "Chamadas em chats criptografados ainda não são compatíveis",
  "ui.vybrat_mikrofon_i_dinamik": "Selecionar microfone e alto-falante",
  "ui.zaprashivaem_dostup_k_kamere": "Solicitando acesso à câmera…",
  "ui.vklyuchit_kameru_zaprosim_dostup": "Ligar câmera (vamos solicitar acesso)",
  "ui.vybrat_kameru": "Selecionar câmera",
  "ui.demonstraciya_ekrana_nedostupna_v_etom_br": "O compartilhamento de tela não está disponível neste navegador",
  "ui.vybiraem_okno_ili_ekran": "Selecione uma janela ou tela…",
  "ui.ostanovit_demonstraciyu_ekrana": "Parar compartilhamento de tela",
  "ui.demonstraciya_ekrana": "Compartilhamento de tela",
  "ui.svernut_zvonok_v_okoshko_chtoby_pisat_v": "Minimize a chamada em uma janela para escrever neste chat",
  "ui.uchastnika": "participantes",
  "ui.podklyuchaemsya_k_zvonku": "Entrando na chamada…",
  "ui.id_t_zvonok_zhd_m_otveta": "Chamando, aguardando resposta",
  "ui.otkazatsya_ot_zvonka_zvonyaschiy_uznaet_ob": "Recusar a chamada — quem ligou saberá que você recusou",
  "ui.otkazatsya_ot_zvonka": "Recusar chamada",
  "ui.otmenit_podklyuchenie": "Cancelar conexão",
  "ui.udalit_soobschenie": "Excluir mensagem?",
  "ui.nedostatochno_prav_dlya_udaleniya_etogo_soo": "Você não tem permissão para excluir esta mensagem.",
  "ui.soobschenie_ne_naydeno": "Mensagem não encontrada",
  "ui.udalit_svo_soobschenie": "Excluir sua mensagem?",
  "ui.udalit_soobschenie_moderatorom": "Excluir mensagem como moderador?",
  "ui.soobschenie_ne_naydeno_v_lente": "Mensagem não encontrada na linha do tempo.",
  "ui.komnata_budet_sozdana_vne_prostranstv_do": "O chat será criado fora dos espaços (\"Home\"). Qualquer usuário pode ser convidado.",
  "ui.pustoe_imya_polzovatelya_do_dvoetochiya": "O nome de usuário antes dos dois-pontos está vazio",
  "ui.pokazany_uchastniki_vybrannogo_prostranst": "Exibindo os membros do espaço selecionado. Para ver todos, mude para \"Home\" na barra à esquerda.",
  "ui.naprimer_otdel_prodazh": "Por exemplo: Equipe de vendas",
  "ui.perenesti": "Mover",
  "ui.seychas_komnata_vne_prostranstv_dom": "Este chat está fora dos espaços (\"Home\").",
  "ui.podskazyvat_nekogo_vse_kogo_vy_znaete_p": "Não há sugestões: todos que você conhece dos seus espaços já estão aqui. Digite um identificador completo, como @usuário:algsuccess.com.",
  "ui.zagruzka": "Carregando…",
  "ui.zagruzit_avatar_komnaty": "Enviar avatar do chat",
  "ui.vidna_vsem_dazhe_bez_vhoda": "visível para todos, mesmo sem entrar",
  "ui.s_momenta_vhoda_uchastnika": "desde a entrada do membro",
  "ui.s_momenta_priglasheniya": "desde o convite",
  "ui.tolko_s_momenta_vhoda": "somente desde a entrada",
  "ui.tema": "Tópico",
  "ui.avatar": "Avatar",
  "ui.publichnaya": "pública",
  "ui.po_priglasheniyu": "somente por convite",
  "ui.pisat_soobscheniya": "Enviar mensagens",
  "ui.priglashat_uchastnikov": "Convidar membros",
  "ui.udalyat_chuzhie_soobscheniya": "Excluir mensagens de outras pessoas",
  "ui.menyat_nastroyki_i_roli": "Alterar configurações e funções",
  "ui.uchastniki": "membros",
  "ui.moderatory": "moderadores",
  "ui.adminy": "administradores",
  "ui.nedostatochno_prav_dlya_izmeneniya": "Você não tem permissão para alterar isso",
  "ui.menyat_prava_roley_mozhet_tolko_tot_u_ko": "Somente alguém com permissões suficientes pode alterar as permissões das funções (limite m.room.power_levels). Você não tem essas permissões — os valores são exibidos para referência.",
  "ui.otvetov": "respostas",
  "ui.otvet_2": "resposta",
  "ui.otveta": "respostas",
  "ui.history_avtodogruzka_ostanovlena_8_stra": "[history] carregamento automático interrompido: 8 páginas sem progresso",
  "ui.naverhu_stranica_ne_dala_vidimyh_soobschen": "no topo, a página não retornou mensagens visíveis",
  "ui.soobschenie_ne_zagruzheno": "Mensagem não carregada",
  "ui.menshe_minuty": "menos de um minuto",
  "ui.snyat_reakciyu": "Remover reação",
  "ui.drugoy_emodzi": "Outro emoji",
  "ui.otvetit_v_trede": "Responder na thread",
  "ui.kopirovat_tekst": "Copiar texto",
  "ui.prostranstva": "espaços",
  "ui.prostranstvo": "espaço",
  "ui.komnatu": "chat",
  "ui.publichnoe_prostranstvo_vidno_v_kataloge": "Um espaço público aparece no diretório do servidor e qualquer funcionário pode entrar. Somente por convite significa que é preciso um convite de um membro.",
  "ui.publichnaya_komnata_vidna_v_kataloge_serve": "Um chat público aparece no diretório do servidor e qualquer funcionário pode entrar. Somente por convite significa que é preciso um convite de um membro.",
  "ui.etogo_prostranstva": "este espaço",
  "ui.etoy_komnaty": "este chat",
  "ui.zagruzit": "Enviar",
  "ui.zakryt_tred": "Fechar thread",
  "ui.otvetit_v_tred_upomyanut_enter_otpravit": "Responder na thread… (@ — mencionar, Enter — enviar)",
  "ui.perenesti_v_prostranstvo": "Mover para o espaço…",
  "ui.nastroyki_komnaty": "Configurações do chat…",
  "profile.language": "Idioma",
  "profile.files": "Meus arquivos",
  "profile.server": "Servidor",
  "profile.serverChange": "mudar",
  "theme.system": "Como o sistema",
  "theme.light": "Claro",
  "theme.dark": "Escuro",
  "ui.b": "B",
  "rtc.deviceDefault": "Padrão",
  "rtc.micLabel": "Microfone",
  "rtc.cameraLabel": "Câmera",
  "rtc.speakerLabel": "Alto-falante",
  "rtc.micWord": "microfone",
  "rtc.cameraWord": "câmera",
  "rtc.speakerWord": "alto-falante",
  "rtc.previouslyChosen": "selecionado antes",
  "rtc.speakerSwitchFailed": "Este navegador não permitiu trocar o alto-falante. O áudio continuou no anterior.",
  "rtc.deviceSwitchFailed": "Não foi possível trocar o dispositivo — o anterior continua.",
  "rtc.encryptedNotSupported1": "Chamadas em salas criptografadas ainda não têm suporte. ",
  "rtc.encryptedNotSupported2": "Crie uma sala comum ou aguarde uma atualização.",
  "rtc.you": "Você",
  "rtc.screenYou": "Tela: Você",
  "rtc.micMuted": "Microfone desligado",
  "rtc.cameraOff": "Câmera desligada",
  "rtc.screenShareDenied": "O compartilhamento de tela não começou: acesso negado",
  "device.generic": "Dispositivo",
  "device.yandexBrowser": "Yandex Browser",
  "device.browserWord": "navegador",
  "file.generic": "arquivo",
  "error.rateLimited": "O servidor está limitando as solicitações. Tente em um minuto.",
  "space.memberSingular": "membro",
  "space.memberPlural": "membros",
  "space.lastAdminWarn1": "Sem administrador não será possível gerenciar o espaço: nem convidar, ",
  "space.lastAdminWarn2": "nem adicionar salas, nem alterar configurações. Nomeie antes outro ",
  "space.lastAdminWarn3": "administrador ou remova os demais membros.",
  "common.unknown": "desconhecido",
  "message.encrypted": "Mensagem criptografada",
  "message.youPrefix": "Você",
  "room.inviteToRoom": "Convite para a sala",
  "message.deleted": "mensagem excluída",
  "message.wasDeleted": "A mensagem foi excluída",
  "message.attachment": "anexo",
  "emoji.searchPlaceholder": "Buscar (em inglês: heart, cat, fire)",
  "server.current": " · atual",
  "space.settingsMenu": "Configurações do espaço…",
  "file.noName": "sem nome",
  "error.noUserId": "Sem ID de usuário do cliente",
  "error.noAccessToken": "Sem token de acesso",
  "error.noClientIdNotOidc": "Sem client_id — a sessão não é OIDC",
  "error.noDeviceId": "Sem device_id",
  "error.masEndpointMissing": "O endpoint GraphQL do MAS não está declarado",
  "error.deviceAuthEndpointMissing": "O endpoint de autorização de dispositivo não está declarado",
  "error.tokenEndpointMissing": "O endpoint de token não está declarado",
  "error.authDeclined": "O usuário recusou a autorização",
  "error.codeExpired": "O código expirou",
  "error.waitTimeout": "O tempo de espera esgotou",
  "error.micNoTrack": "O microfone não forneceu faixa de áudio",
  "error.cameraNoTrack": "A câmera não forneceu faixa de vídeo",
  "error.jwtNoUrl": "Serviço JWT: a resposta não traz url/jwt",
  "error.screenNoTrack": "O navegador não forneceu faixa de vídeo da tela",
  "error.ownPowerLevel": "Não é permitido alterar seu próprio nível de permissão aqui",
  "error.noEventIdEdit": "A mensagem editada não tem event ID",
  "error.noEventIdRedact": "Sem event ID para redigir",
  "error.mxcLinkFailed": "Não foi possível montar o link a partir de mxc://",
  "error.providerMissing": "MatrixClientProvider ausente acima na árvore",
  "emoji.groupSmileys": "Carinhas e emoções",
  "emoji.groupPeople": "Pessoas",
  "emoji.groupNature": "Animais e natureza",
  "emoji.groupFood": "Comida e bebida",
  "emoji.groupTravel": "Viagens e lugares",
  "emoji.groupActivities": "Atividades",
  "emoji.groupObjects": "Objetos",
  "emoji.groupSymbols": "Símbolos",
  "emoji.groupFlags": "Bandeiras",
  "server.hintMain": "servidor de produção da ALG",
  "server.hintStage": "de testes, os dados podem ser quebrados",
  "error.serverAddressRequired": "Informe o endereço do servidor",
  "error.serverAddressInvalid": "O endereço do servidor parece inválido",
  "error.serverAddressHttps": "O endereço deve começar com https://",
  "call.ringDiagStarting": "chamada: tentando iniciar o som…",
  "notification.newMessage": "Nova mensagem",
  "app.roomUnavailable": "Sala indisponível",
  "app.roomUnavailableBody": "Você não está nesta sala (ou o link tem um erro). Peça a um membro para convidá-lo — após o convite o link abrirá sozinho.",
  "room.linkMenu": "Link da sala…",
  "roomLink.title": "Link para “{room}”",
  "roomLink.hint": "Envie este link para convidar para a sala. Ele abre a sala no nosso mensageiro.",
  "roomLink.fieldLabel": "Link",
  "roomLink.copy": "Copiar",
  "roomLink.share": "Compartilhar",
  "roomLink.copied": "Link copiado",
  "roomLink.copyFailed": "Não foi possível copiar — selecione o link e copie manualmente",
  "roomLink.closedHint": "A sala é só por convite: o link deixa entrar quem já foi convidado. Os demais verão um pedido para solicitar convite.",
  "roomLink.openHint": "A sala é pública: qualquer usuário do servidor pode entrar pelo link.",
  "roomLink.restrictedHint": "Membros do espaço da sala podem entrar pelo link.",
  "roomLink.knockHint": "É possível pedir para entrar na sala, mas este cliente ainda não envia pedidos: sem convite o link não deixa entrar.",
  "roomGate.title": "Sala a partir de um link",
  "roomGate.loading": "Verificando a sala…",
  "roomGate.join": "Entrar na sala",
  "roomGate.joining": "Entrando…",
  "roomGate.members": "Membros: {count}",
  "roomGate.closedTitle": "A sala é privada — peça um convite",
  "roomGate.closedBody": "Não é possível entrar pelo link: a sala é só por convite. Peça a um membro para convidá-lo — após o convite o link abrirá sozinho.",
  "roomGate.knockBody": "É possível pedir para entrar nesta sala, mas o envio de pedidos neste cliente ainda não está ativo. Peça a um membro para convidá-lo.",
  "roomGate.notFound": "Nenhuma sala encontrada para este link. Verifique o link.",
  "app.clickToOpen": "Clique para abrir",
  "app.goBack": "Voltar",
  "composer.releaseToSend": "Solte para enviar",
  "composer.photoVideo": "Foto/vídeo",
  "composer.file": "Arquivo",
  "composer.voiceMessage": "Mensagem de voz",
  "composer.toRoom": "Para a sala:",
  "common.secShort": "s",
  "emoji.nothingFound": "Nada encontrado",
  "error.boundaryBody": "O aplicativo encontrou um erro e parou de exibir esta tela. O restante funciona — você pode voltar.",
  "media.fileDownloaded": "Arquivo baixado.",
  "media.shareFallbackDownloaded": "Não foi possível compartilhar — o arquivo foi baixado.",
  "member.youSuffix": "· você",
  "member.banCannotReturn": "não poderá entrar novamente",
  "member.banCannotReturnTail": ", nem com um novo convite, até o banimento ser removido manualmente (a lista fica no fim do painel de membros).",
  "member.kickNoAutoReturn": "não voltará à sala automaticamente",
  "member.kickNoAutoReturnTail": ": ele precisa entrar de novo ou ser convidado outra vez.",
  "member.roleExplain": "O papel define o que um membro pode fazer na sala: escrever, convidar, moderar, alterar configurações. A promoção vale imediatamente em todos os clientes.",
  "member.powerLevel": "Nível de permissão",
  "member.stateNotLoaded": ". Parte do estado da sala ainda não foi carregada.",
  "member.kickWarnBody": "será removido da sala e poderá voltar com um novo convite (ou sozinho, se a sala for pública).",
  "member.unbanWarn": "será desbanido, mas",
  "notification.iosHint": "No iPhone/iPad as notificações só funcionam se o site estiver na tela de início (Compartilhar → Adicionar à Tela de Início).",
  "notification.blockedHint": "O navegador bloqueou as notificações; o app não pode remover isso. No Safari: Ajustes → Sites → Notificações.",
  "notification.showNew": "Mostrar notificações de novas mensagens",
  "notification.soundNew": "Som de nova mensagem",
  "notification.ringOnCall": "Toque em chamada recebida",
  "profile.deviceCodeHint": "Aparecerá um código: digite-o no novo dispositivo para confirmar o login nesta conta.",
  "profile.multiSessionHint": "Vários logins do mesmo dispositivo; se algum não for seu, encerre-o.",
  "profile.thisDeviceSuffix": "· este dispositivo",
  "profile.clientUnknown": "cliente desconhecido — o servidor não informa",
  "profile.generatingCode": "Gerando um código…",
  "profile.notificationsOnHint": "As notificações estão ativas. As regras de silêncio (sala aberta não apita) valem automaticamente.",
  "profile.notYouHint": ". Se não for você, abra o gerenciamento de dispositivos e encerre essa sessão.",
  "profile.deviceLimitHint": "º dispositivo exigirá aprovação do administrador. O limite ainda não está ativo: a parte do servidor está em andamento.",
  "profile.sessionsWord": "sessões",
  "profile.permissionRetryHint": "). O botão abaixo pergunta ao navegador de novo; se a resposta for “negado”, só os ajustes do navegador mudam isso.",
  "dialog.cannotLeaveSpace": "Você não pode sair do espaço",
  "dialog.youWillLeaveSpace": "Você vai sair do espaço",
  "dialog.leaveSpaceTail": ". As salas dele sairão da sua lista e voltar exigirá um novo convite.",
  "dialog.youWillLeaveRoom": "Você vai sair da sala",
  "dialog.leaveRoomTail": ". O histórico fica no servidor, mas não estará disponível para você. Voltar a uma sala privada exige novo convite.",
  "dialog.invitationTo": "Convite para",
  "dialog.inviteDeclineTail": "será recusado. Se você for convidado de novo, a sala reaparecerá.",
  "dialog.spaceExplain": "Um espaço agrupa salas e pessoas. Um membro do espaço vê as salas abertas dele.",
  "dialog.noSpacesToMove": "Não há para onde mover: nenhum espaço onde você possa gerenciar o conteúdo (m.space.child). Peça a um administrador do espaço para mover ou aumentar seu nível de permissão.",
  "dialog.outsideSpacesHome": "— Fora de espaços (Início) —",
  "dialog.inviteSpaceHint": "O convidado verá as salas abertas do espaço e todos os membros. Salas só por convite continuam ocultas.",
  "room.encryptionWord": "Criptografia",
  "room.encNotSupportedOff": "sem suporte — desativado",
  "room.encReadInElement": ". Você pode ler essa sala no Element. Aqui não dá para ativar a criptografia.",
  "room.offWord": "desativado",
  "room.encDisabledTail": ": a sala não é criptografada e o suporte a E2EE está desativado de propósito neste cliente. Não dá para ativar aqui.",
  "room.changeSettings": "Alterar configurações…",
  "room.noRightsSettings": "Você não tem permissão para alterar estas configurações — são apenas informativas. Fale com um administrador.",
  "room.noRights": "sem permissão",
  "room.rolePermissions": "Permissões de papéis",
  "room.advancedSettings": "Configurações avançadas",
  "room.settingsSubtitle": "Configurações da sala, permissões de papéis, criptografia",
  "room.loadingHistory": "Carregando histórico…",
  "room.publicWord": "Pública",
  "room.historyShared": "A partir da entrada (shared)",
  "room.historyJoined": "Apenas a partir da entrada (joined)",
  "room.historyExplain": "“A partir da entrada”: o novo membro vê o histórico desde que entrou. “Apenas a partir da entrada” é mais rígido: nem o convite revela o passado.",
  "room.thisIsWord": "Isto é",
  "room.invitationWord": "um convite",
  "room.inviteHintTail": ". Toque em “Aceitar” no topo para entrar na sala, ou “Recusar” para removê-la da lista. O conteúdo não é exibido antes de entrar.",
  "room.encryptedNoticeTail": "Este cliente não os lê de propósito: a criptografia está desativada. O envio também não funciona — outros clientes rejeitam mensagem sem criptografia em sala criptografada. Use o Element para esta sala.",
  "room.callInProgress": "Chamada em andamento",
  "room.callConnectFailed": "Não foi possível conectar à chamada.",
  "common.tryAgain": "Tentar novamente",
  "room.moderatorDeleteNotice": "Você está excluindo a mensagem de outra pessoa como moderador. Os demais verão que foi excluída.",
  "room.noVideoYet": "· ninguém ativou o vídeo",
  "server.pickerHint": "O app vai conectar ao servidor escolhido. Sessão e dispositivos ficam separados por servidor.",
  "space.fromSpaceQuestion": "do espaço?",
  "space.itIsYou": "— é você",
  "space.adminSuffix": "· admin",
  "space.noMembersYet": "O espaço ainda não tem membros além de você.",
  "space.removeMemberTail": ". Salas e conversas permanecem — nada é excluído. Uma sala onde vocês eram dois fica com um membro e todo o histórico. Você pode convidar a pessoa de volta a qualquer momento.",
  "space.invitedSuffix": "· convidado",
  "message.editedMark": "(editado)",
  "message.sendingMark": "· enviando…",
  "message.notSentMark": "· não enviado",
  "timeline.loadingPreview": "Carregando prévia…",
  "timeline.callOngoing": "Chamada em andamento",
  "timeline.loadingTail": "— carregando…",
  "member.kickShort": "Expulsar",
  "member.banShort": "Banir",
  "notification.permissionNotGranted": "Permissão não concedida",
  "member.banStricterHead": "O banimento é mais rígido que a expulsão:",
  "profile.deviceLimitHead": "Ao adicionar o",
  "room.membersCountOne": "membro",
  "room.membersCountFew": "membros",
  "room.membersCountMany": "membros",
  "profile.deviceLabelWeb": "{machine} · {client} (web)",
  "profile.deviceDeleteUnexpectedStatus": "Status de exclusão inesperado: {status}",
  "matrix.errorUserNotFoundOnServer": "O usuário {user} não foi encontrado no servidor dele",
  "matrix.errorServerUnreachable": "Não é possível contatar o servidor: {detail}. Verifique o domínio.",
  "space.lastAdminHead": "Você é o único administrador e o espaço ainda tem {count} ",
  "timeline.inReplyTo": "Em resposta a",
  "rtc.deviceDisconnectedFallback": "{device} “{name}” foi desconectado — mudamos para o dispositivo padrão.",
  "rtc.speakerRestored": "O alto-falante “{name}” está disponível novamente — o áudio da chamada voltou para ele.",
  "rtc.callMembershipFailed": "A participação na chamada não foi registrada na sala: {error}. Os outros participantes não verão você. Saia da chamada e entre novamente.",
  "rtc.screenOf": "Tela: {name}",
  "error.jwtHttp": "Serviço JWT: HTTP {status}",
  "space.notInRoomSpace": "{user} não faz parte do espaço desta sala. Peça antes a um administrador que o adicione ao espaço — só então será possível convidá-lo para salas e chamadas.",
  "timeline.roomNameChanged": "{actor} alterou o nome da sala para “{name}”",
  "timeline.roomNameRemoved": "{actor} removeu o nome da sala",
  "timeline.roomTopicChanged": "{actor} alterou o tópico da sala",
  "timeline.roomTopicRemoved": "{actor} removeu o tópico da sala",
  "timeline.roomAvatarChanged": "{actor} alterou o avatar da sala",
  "timeline.roomAvatarRemoved": "{actor} removeu o avatar da sala",
  "timeline.memberInvited": "{actor} convidou {subject} para a sala",
  "timeline.memberRenamed": "{oldName} agora é {newName}",
  "timeline.memberAvatarChanged": "{subject} alterou o próprio avatar",
  "timeline.memberJoined": "{subject} entrou na sala",
  "timeline.memberUnbanned": "{actor} desbaniu {subject}",
  "timeline.memberLeft": "{subject} saiu da sala",
  "timeline.memberKicked": "{actor} removeu {subject} da sala{reason}",
  "timeline.memberBanned": "{actor} baniu {subject}{reason}",
  "timeline.summaryJoined": "{names} entraram na sala",
  "timeline.summaryInvited": "{names} foram convidados para a sala",
  "timeline.summaryLeft": "{names} saíram da sala",
  "timeline.summaryKicked": "{names} foram removidos da sala",
  "timeline.summaryBanned": "{names} foram banidos",
  "timeline.summaryUnbanned": "{names} foram desbanidos",
  "timeline.namesTwo": "{first} e {second}",
  "timeline.namesThree": "{first}, {second} e {third}",
  "timeline.namesMoreOne": "{first}, {second} e mais {count} participante",
  "timeline.namesMoreFew": "{first}, {second} e mais {count} participantes",
  "timeline.namesMoreMany": "{first}, {second} e mais {count} participantes",
  "profile.titleWithName": "Perfil — {name}",
  "common.sizeBytes": "{size} B",
  "common.sizeKb": "{size} KB",
  "common.sizeMb": "{size} MB",
  "space.membersTitle": "Membros: {space}",
  "timeline.readUpToHere": "{name} leu até aqui",
  "timeline.attachmentDownload": "{info} · baixar",
  "timeline.threadLastSender": " · último: {name}",
  "timeline.durationMinutes": "{minutes} min",
  "timeline.durationHours": "{hours} h",
  "timeline.durationHoursMinutes": "{hours} h {minutes} min",
  "timeline.addReaction": "Reagir com {emoji}",
  "timeline.openThreadCount": "Abrir tópico · {count}",
  "call.ringBlocked": "som bloqueado pelo navegador: {prefix}",
  "call.ringStarted": "som iniciado ({prefix})",
  "room.inviteAcceptFailed": "Não foi possível aceitar o convite para “{room}”: {error}",
  "call.ongoingVideoInRoom": "📹 Videochamada em andamento · {room}",
  "call.ongoingAudioInRoom": "📞 Chamada em andamento · {room}",
  "call.incomingVideoFrom": "Videochamada recebida: {callers}",
  "call.incomingAudioFrom": "Chamada recebida: {callers}",
  "call.roomOngoingParticipants": "{room} · chamada em andamento · {participants}",
  "media.downloadNamed": "Baixar {name}",
  "profile.fileFrom": "de {user}",
  "profile.loadFailed": "Não foi possível carregar: {error}",
  "dialog.domainLooksTruncated": "O domínio “{host}” parece incompleto",
  "dialog.removeEntry": "Remover {id}",
  "room.yourPowerLevel": "Seu nível de permissão: {level}. O servidor não aceitará um limite acima do seu próprio nível.",
  "call.declinedBy": "{name} recusou a chamada",
  "call.inCallOne": "Você está na chamada · {count} participante",
  "call.inCallFew": "Você está na chamada · {count} participantes",
  "call.inCallMany": "Você está na chamada · {count} participantes",
  "member.actionsFor": "Ações: {name}",
  "member.kickQuestion": "Remover {name}?",
  "member.banQuestion": "Banir {name}?",
  "member.roleFor": "Função: {name}",
  "notification.cannotShowPermission": "não é possível exibir: permission={permission}",
  "notification.showError": "erro ao exibir: {error}",
  "profile.photoOf": "Foto: {name}",
  "profile.deviceAdded": "adicionado {date}",
  "profile.renameDeviceNamed": "Renomear {device}",
  "profile.endSessionNamed": "Encerrar a sessão em {device}",
  "composer.micEnableFailed": "Não foi possível ativar o microfone: {error}",
  "space.notInAnySpace": "{user} não faz parte de nenhum dos seus espaços. A conversa direta só é possível dentro de um espaço em comum — primeiro um administrador precisa adicioná-lo lá.",
  "dialog.noSettingsPermissionRoom": "Você não tem permissão para alterar as configurações desta sala.",
  "dialog.noSettingsPermissionSpace": "Você não tem permissão para alterar as configurações deste espaço.",
  "dialog.spaceSettings": "Configurações do espaço: {space}",
  "profile.masSessionNotFound": "Nenhuma sessão ativa do dispositivo {deviceId} foi encontrada no MAS — ela pode já estar encerrada. Atualize a lista; se o dispositivo continuar lá, exclua novamente.",
  "rtc.deviceSwitchError": "Não foi possível trocar o {device}: {error}",
  "profile.newDeviceOne": "Um novo dispositivo apareceu desde a sua última visita: {devices}",
  "profile.newDeviceMany": "Novos dispositivos apareceram desde a sua última visita ({count}): {devices}",
  "profile.deviceCount": "Dispositivos: {count} de {limit}.",
  "room.levelValue": "nível {level}",
  "thread.historyError": "O carregamento do histórico do tópico não terminou: {error}",
  "thread.replyNotSent": "A resposta não foi enviada: {error}",
  "call.ringingWaitAnswer": "Chamando, aguardando resposta…",
  "call.noAnswerCountdown": "Ninguém atendeu · a chamada terminará em 0:{seconds}",
  "call.waitingCountdown": "Aguardando resposta · terminará em 0:{seconds}",
  "call.cameraFailed": "A câmera não ligou: {error}",
  "call.screenShareFailed": "O compartilhamento de tela não começou: {error}",
  "call.roomCallWithCount": "Há uma chamada em andamento nesta sala · {count} {word}",
  "space.leaveRoomsOne": "Sairá do espaço e de {count} sala dentro dele",
  "space.leaveRoomsFew": "Sairá do espaço e de {count} salas dentro dele",
  "space.leaveRoomsMany": "Sairá do espaço e de {count} salas dentro dele",
  "app.invitedBy": "Convidado por: {user}",
  "composer.voiceRecordingSeconds": "Gravando uma mensagem de voz… {seconds} s",
  "media.slideBroken": "{icon} {name} — falha ao carregar",
  "media.slideBrokenError": "{icon} {name} — falha ao carregar: {error}",
  "room.attachmentBrokenNoError": "📎 {name} {size} — falha ao carregar",
  "composer.deleteRecording": "Excluir gravação",
  "composer.recordingDuration": "Duração: {seconds} s",
  "composer.stopRecording": "Parar gravação",
  "composer.formattingToolbar": "Formatação de texto",
  "composer.bold": "Negrito",
  "composer.italic": "Itálico",
  "composer.underline": "Sublinhado",
  "composer.strikethrough": "Tachado",
  "composer.textColorRed": "Cor do texto: vermelho",
  "composer.textColorOrange": "Cor do texto: laranja",
  "composer.textColorGreen": "Cor do texto: verde",
  "composer.textColorBlue": "Cor do texto: azul",
  "composer.textColorPurple": "Cor do texto: roxo",
  "notification.messageSoundLabel": "Som de mensagem",
  "notification.callSoundLabel": "Som de chamada",
  "notification.previewSound": "Ouvir",
  "notification.roomModeLabel": "Modo de notificações",
  "notification.roomSoundLabel": "Som deste chat",
  "notification.soundDefault": "Padrão",
  "notification.soundSoft": "Suave",
  "notification.soundDouble": "Tom duplo",
  "notification.soundChime": "Carrilhão",
  "fontSize.default": "Padrão",
  "fontSize.label": "Tamanho do texto",
  "fontSize.large": "Grande",
  "fontSize.small": "Pequeno",
  "notification.acceptedUnverified": "O aplicativo aceitou a solicitação, mas a exibição pelo sistema não foi confirmada",
  "notification.appDisabled": "As notificações do sistema estão desativadas no aplicativo",
  "notification.appEnabled": "As notificações do sistema estão ativadas no aplicativo",
  "notification.categoriesTitle": "Tipos de notificação",
  "notification.categoryCalls": "Chamadas recebidas",
  "notification.categoryDirect": "Mensagens diretas",
  "notification.categoryGroup": "Mensagens em grupos",
  "notification.categoryInvites": "Convites para salas e espaços",
  "notification.categoryMentions": "Menções e @room",
  "notification.categoryReactions": "Reações às minhas mensagens",
  "notification.categoryReplies": "Respostas e tópicos",
  "notification.createdVerified": "A notificação do sistema foi criada pelo aplicativo",
  "push.disable": "Desativar",
  "push.disabled": "Não estão ativadas para este dispositivo",
  "push.enable": "Ativar notificações em segundo plano",
  "push.enabled": "Funciona mesmo quando o aplicativo está fechado",
  "push.notReady": "O serviço de notificações em segundo plano ainda não está pronto",
  "push.test": "Testar notificação em segundo plano",
  "push.testSent": "Notificação em segundo plano enviada",
  "push.title": "Notificações em segundo plano",
  "push.working": "Aguarde…",
  "room.groupsTab": "Grupos",
  "room.emptyGroups": "Nenhum chat em grupo",
  "chat.private": "Chat privado",
  "chat.filterLabel": "Filtro: {value}",
  "chat.filterChats": "Filtrar chats",
  "chat.filters": "Filtros de chat",
  "chat.clearFilter": "Limpar filtro",
  "chat.messagePrivately": "Enviar mensagem privada",
  "profile.view": "Ver perfil",
  "chat.jumpToLatest": "Ir para a mensagem mais recente",
  "chat.jumpToMention": "Ir para a menção",
  "settings.language": "Idioma",
  "server.main": "Principal",
  "server.stage": "Teste",
  "server.matrixPlaceholder": "matrix.example.com",
  "notification.background": "Notificações em segundo plano",
  "notification.notEnabledForDevice": "Não ativado para este dispositivo",
  "notification.enableBackground": "Ativar notificações em segundo plano",
  "notification.unsupportedRuntime": "As notificações em segundo plano não são compatíveis com o ambiente de execução deste aplicativo.",
  "typing.one": "{name} está digitando",
  "typing.two": "{a} e {b} estão digitando",
  "typing.more": "{a}, {b} e mais {count} estão digitando",
  "matrix.errorNetwork": "Sem conexão com o servidor. Verifique sua rede e tente novamente.",
  "picker.busy": "O envio anterior ainda está em andamento, aguarde.",
  "picker.cancelled": "Nenhum arquivo selecionado.",
  "picker.chosen": "Arquivo “{name}” selecionado, enviando…",
  "picker.done": "Pronto, a imagem foi enviada.",
  "picker.failed": "Falha ao enviar: {error}",
  "picker.shellFailed": "O aplicativo não conseguiu obter o arquivo. Tente novamente.",
  "picker.shellTooLarge": "O arquivo “{name}” é grande demais: {size}, o limite é {limit}.",
  "picker.noDialog": "O clique foi registrado, mas o sistema não abriu a janela de arquivos. Informe esta linha ao suporte.",
  "picker.noInput": "O campo de arquivo não está pronto. Abra a tela novamente.",
  "picker.opening": "Abrindo o seletor de arquivos…",
  "search.error": "A pesquisa de mensagens falhou: {error}",
  "search.loadingMore": "Carregando mais…",
  "search.messagesCount": "Mensagens · {count} encontradas",
  "search.messagesSection": "Mensagens",
  "search.more": "Mostrar mais",
  "search.noMessages": "Nenhuma mensagem encontrada para “{query}”",
  "search.resultAria": "Mensagem de {sender} em “{room}”",
  "search.retry": "Tentar de novo",
  "search.searching": "Pesquisando no servidor…",
  "search.tooShort": "Digite pelo menos 2 caracteres para pesquisar mensagens",
  "search.unknownRoom": "Sala desconhecida",
  "app.sessionEndedTitle": "A sua sessão foi encerrada no servidor",
  "app.sessionEndedBody": "Este dispositivo foi desconectado da conta. Inicie sessão novamente para continuar.",
  "profile.logoutProgress": "Saindo…",
  "profile.logoutRetry": "Tentar sair novamente",
  "avatar.jpegOnly": "Não foi possível preparar a imagem. Tente um arquivo JPEG.",
  "avatar.decodeFailed": "Não foi possível abrir este arquivo como imagem. Tente JPEG ou PNG.",
  "avatar.encodeFailed": "Não foi possível converter a imagem para JPEG.",
  "ui.perevernut_kameru": "Virar câmera",
  "call.labelSpeaker": "Viva-voz",
  "call.labelScreenShare": "Tela",
  "call.labelInvite": "Convidar",
  "call.labelFlipCamera": "Virar",
  "call.labelCompose": "Escrever",
  "call.labelEnd": "Encerrar",
  "call.labelMicrophone": "Microfone",
  "call.labelCamera": "Câmera",
  "message.forward": "Encaminhar",
  "forward.title": "Encaminhar para",
  "forward.unsupported": "Só é possível encaminhar mensagens de texto.",
  "forward.failed": "Não foi possível encaminhar a mensagem: {error}",
  "update.title": "Atualização disponível",
  "update.body": "Uma nova versão do aplicativo está disponível: {version}.",
  "update.bodySize": "Uma nova versão do aplicativo está disponível: {version} · {size}.",
  "update.mandatoryNote": "Esta atualização é obrigatória para continuar usando o aplicativo.",
  "update.now": "Atualizar",
  "update.later": "Mais tarde",
};
